import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A valid URL, transported as a string */
  Attachment: { input: any; output: any; }
  /**
   * Attachment is used to replace the attachment url with
   * CDN url for caching.
   *
   */
  AttachmentType: { input: any; output: any; }
  /**
   * Take a Ruby/Rails Time, Date or DateTime, and display it as a string in
   * the ISO8601 standard format. If a time is present, the timezone will be
   * UTC, and the format will be "Z" (meaning UTC), not "+00:00" (an alternate
   * way to write UTC in ISO8601). Note the max resolution returned is seconds.
   *
   */
  DateType: { input: any; output: any; }
  /** Maps a key to an input. */
  Hash: { input: any; output: any; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any; }
  /** Represents untyped JSON */
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

/** Autogenerated input type of AcceptOpenTeamInvitation */
export type AcceptOpenTeamInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['ID']['input'];
};

/** Autogenerated return type of AcceptOpenTeamInvitation. */
export type AcceptOpenTeamInvitationPayload = {
  __typename?: 'AcceptOpenTeamInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AcceptTeamInvitation */
export type AcceptTeamInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['ID']['input'];
};

/** Autogenerated return type of AcceptTeamInvitation. */
export type AcceptTeamInvitationPayload = {
  __typename?: 'AcceptTeamInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Account */
export type Account = {
  __typename?: 'Account';
  /** External ID */
  externalId: Scalars['String']['output'];
  /** ID */
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of ActivateCampaign */
export type ActivateCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
};

/** Autogenerated return type of ActivateCampaign. */
export type ActivateCampaignPayload = {
  __typename?: 'ActivateCampaignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AddAdminSeats */
export type AddAdminSeatsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emails: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of AddAdminSeats. */
export type AddAdminSeatsPayload = {
  __typename?: 'AddAdminSeatsPayload';
  addedUsers?: Maybe<Array<User>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<ChildCompany>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
  users?: Maybe<Array<StoreUser>>;
};

/** Autogenerated input type of AddContactsCampaign */
export type AddContactsCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  number: Scalars['String']['input'];
};

/** Autogenerated return type of AddContactsCampaign. */
export type AddContactsCampaignPayload = {
  __typename?: 'AddContactsCampaignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AddProduct */
export type AddProductInput = {
  /** Catalog Id */
  catalogId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Product ID */
  productId: Scalars['Int']['input'];
  /** Store ID */
  storeId: Scalars['Int']['input'];
};

/** Autogenerated return type of AddProduct. */
export type AddProductPayload = {
  __typename?: 'AddProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error */
  error?: Maybe<Scalars['String']['output']>;
  /** Store */
  store?: Maybe<Store>;
};

/** Autogenerated input type of AddProgramSlackChannel */
export type AddProgramSlackChannelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: SlackChannelInput;
  programId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddProgramSlackChannel. */
export type AddProgramSlackChannelPayload = {
  __typename?: 'AddProgramSlackChannelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Address = {
  __typename?: 'Address';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  /** This is to be used ONLY in contact_profiles */
  country?: Maybe<Scalars['String']['output']>;
  countryId?: Maybe<Scalars['ID']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  /** This is to be used ONLY in contact_profiles */
  formatted?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  /** This is to be used ONLY in contact_profiles */
  state?: Maybe<Scalars['String']['output']>;
  stateAbbreviation?: Maybe<Scalars['String']['output']>;
  stateId?: Maybe<Scalars['ID']['output']>;
  stateName?: Maybe<Scalars['String']['output']>;
  stateNameNonUs?: Maybe<Scalars['String']['output']>;
  /** This is to be used ONLY in contact_profiles */
  street1?: Maybe<Scalars['String']['output']>;
  /** This is to be used ONLY in contact_profiles */
  street2?: Maybe<Scalars['String']['output']>;
  validationData?: Maybe<Scalars['Hash']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
  /** This is to be used ONLY in contact_profiles */
  zipCode?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
  zipcodeNonUs?: Maybe<Scalars['String']['output']>;
};

/** Input type for address */
export type AddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  recordType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateName?: InputMaybe<Scalars['String']['input']>;
  stateNameNonUs?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  validationData?: InputMaybe<Scalars['Hash']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
  zipcodeNonUs?: InputMaybe<Scalars['String']['input']>;
};

export type Admin = {
  __typename?: 'Admin';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  roles: Array<Role>;
};

/** AI Generated Description */
export type AiDescription = {
  __typename?: 'AiDescription';
  /** Compliance Information */
  compliance?: Maybe<Scalars['String']['output']>;
  /** Contact Information */
  contact?: Maybe<Scalars['String']['output']>;
  /** Customizations Information */
  customizations?: Maybe<Scalars['String']['output']>;
  /** AI Generated Description */
  description?: Maybe<Scalars['String']['output']>;
  /** EU GPSR-related Product Information */
  euGpsr?: Maybe<Scalars['String']['output']>;
  /** Manufacturer Information */
  manufacturer?: Maybe<Scalars['String']['output']>;
  /** Warranty Information */
  warranty?: Maybe<Scalars['String']['output']>;
  /** Why Buy Information */
  whyBuy?: Maybe<Scalars['String']['output']>;
};

/** Valid credit card api method enums */
export enum ApiMethodEnum {
  SetupIntentApi = 'setup_intent_api',
  SourceApi = 'source_api'
}

/** Autogenerated input type of ApproveLead */
export type ApproveLeadInput = {
  /** Catalog ID */
  catalogId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ApproveLead. */
export type ApproveLeadPayload = {
  __typename?: 'ApproveLeadPayload';
  /** Catalog */
  catalog?: Maybe<Catalog>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ApproveOpenTeamInvitation */
export type ApproveOpenTeamInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  tokens: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ApproveOpenTeamInvitation. */
export type ApproveOpenTeamInvitationPayload = {
  __typename?: 'ApproveOpenTeamInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ApproveProduct */
export type ApproveProductInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Product slug */
  slug: Scalars['String']['input'];
};

/** Autogenerated return type of ApproveProduct. */
export type ApproveProductPayload = {
  __typename?: 'ApproveProductPayload';
  /** Catalog */
  catalog?: Maybe<Catalog>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of Archive */
export type ArchiveInput = {
  /** Archive/Unarchive a Shop */
  archive: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Store code, to identify store */
  number: Scalars['String']['input'];
};

/** Autogenerated return type of Archive. */
export type ArchivePayload = {
  __typename?: 'ArchivePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Store */
  store?: Maybe<Store>;
  /** Current User */
  user?: Maybe<User>;
};

export type AssetAggregation = {
  __typename?: 'AssetAggregation';
  /** Kinds of assets */
  kinds: Array<AssetLibraryKind>;
  /** Users of assets */
  users: Array<User>;
};

/** Asset library kind */
export type AssetLibraryKind = {
  __typename?: 'AssetLibraryKind';
  /** Asset library kind key */
  key: Scalars['String']['output'];
  /** Asset library kind presentation */
  presentation: Scalars['String']['output'];
};

export type AssetLibraryPaginated = {
  __typename?: 'AssetLibraryPaginated';
  /** Aggregations of assets */
  aggregations?: Maybe<AssetAggregation>;
  /** Assets */
  collection: Array<DigitalAsset>;
  /** Total results */
  total: Scalars['Int']['output'];
};

/** Autogenerated input type of AssociateProgramWithMsTeamsChannel */
export type AssociateProgramWithMsTeamsChannelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: MsTeamsChannelInput;
  programId: Scalars['ID']['input'];
};

/** Autogenerated return type of AssociateProgramWithMsTeamsChannel. */
export type AssociateProgramWithMsTeamsChannelPayload = {
  __typename?: 'AssociateProgramWithMsTeamsChannelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Attribute Type */
export type AttributeType = {
  __typename?: 'AttributeType';
  /** ID */
  id: Scalars['ID']['output'];
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
  /** Display position for FE filter ordering */
  position: Scalars['Int']['output'];
  /** Selection intent (single_select or multiple_select) */
  selectionIntent?: Maybe<Scalars['String']['output']>;
  /** Value source intent (default or custom) */
  valueSourceIntent?: Maybe<Scalars['String']['output']>;
};

/** Attribute Value */
export type AttributeValue = {
  __typename?: 'AttributeValue';
  /** Associated Attribute Type */
  attributeType?: Maybe<AttributeType>;
  /** Attribute Type ID */
  attributeTypeId?: Maybe<Scalars['ID']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
};

/** Logo to product mapping for automated catalog */
export type AutomatedCatalogLogoMappingInput = {
  /** When true, applies this logo to all selected variants not explicitly mapped to another logo */
  applyToUnmapped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Logo ID */
  logoId: Scalars['Int']['input'];
  /** Explicit product/color mappings for this logo */
  selectedProducts?: InputMaybe<Array<DraftAutomatedCatalogSelectedProductInput>>;
};

/** Basic User object type */
export type BasicUser = {
  __typename?: 'BasicUser';
  avatarUrl?: Maybe<Scalars['AttachmentType']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

/** Brand or vendor */
export type Brand = {
  __typename?: 'Brand';
  /** Description used when banner is not available */
  bannerDescription?: Maybe<Scalars['String']['output']>;
  /** Banner Image at Brand's product listing */
  bannerImage?: Maybe<Scalars['Attachment']['output']>;
  /** ID used on Elasticsearch */
  esId: Scalars['ID']['output'];
  /** Featured Logo */
  featuredLogo?: Maybe<Scalars['Attachment']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** unique key */
  key: Scalars['String']['output'];
  /** Logo */
  logo?: Maybe<Scalars['Attachment']['output']>;
  /** name */
  name?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of BulkAcceptOrDeclineTeamInvitation */
export type BulkAcceptOrDeclineTeamInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invitations: Array<InvitationInput>;
};

/** Autogenerated return type of BulkAcceptOrDeclineTeamInvitation. */
export type BulkAcceptOrDeclineTeamInvitationPayload = {
  __typename?: 'BulkAcceptOrDeclineTeamInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of BulkDeleteUserContact */
export type BulkDeleteUserContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of BulkDeleteUserContact. */
export type BulkDeleteUserContactPayload = {
  __typename?: 'BulkDeleteUserContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of BulkRemoveProgramContacts */
export type BulkRemoveProgramContactsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  excludeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  filters?: InputMaybe<Scalars['Hash']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  programId: Scalars['ID']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BulkRemoveProgramContacts. */
export type BulkRemoveProgramContactsPayload = {
  __typename?: 'BulkRemoveProgramContactsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of BulkUpdateProgramContacts */
export type BulkUpdateProgramContactsInput = {
  addedById?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  excludeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  filters?: InputMaybe<Scalars['Hash']['input']>;
  includeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  newAmount: Scalars['Int']['input'];
  onlyDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  onlyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  programId: Scalars['ID']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BulkUpdateProgramContacts. */
export type BulkUpdateProgramContactsPayload = {
  __typename?: 'BulkUpdateProgramContactsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  program?: Maybe<Program>;
  programContacts?: Maybe<Array<ProgramContact>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of BulkUpdateUserContactColumn */
export type BulkUpdateUserContactColumnInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  excludeFromCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromPrograms?: InputMaybe<Scalars['Boolean']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of BulkUpdateUserContactColumn. */
export type BulkUpdateUserContactColumnPayload = {
  __typename?: 'BulkUpdateUserContactColumnPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of BulkUpdateUserContact */
export type BulkUpdateUserContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contacts: Array<UpdateContact>;
};

/** Autogenerated return type of BulkUpdateUserContact. */
export type BulkUpdateUserContactPayload = {
  __typename?: 'BulkUpdateUserContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contactDetails?: Maybe<Array<UpdateContactResponse>>;
};

/** Bundle Product */
export type BundleProduct = {
  __typename?: 'BundleProduct';
  /** Brand data */
  brand?: Maybe<Brand>;
  /** Bundle Id */
  bundleId?: Maybe<Scalars['Int']['output']>;
  /** Catalog */
  catalog?: Maybe<Catalog>;
  /** Catalog Type */
  catalogType?: Maybe<Scalars['String']['output']>;
  /** Child Bundle Products for BYO */
  childProducts?: Maybe<Array<BundleProduct>>;
  /** Collection Id */
  collectionId?: Maybe<Scalars['Int']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Price for Product Set */
  price?: Maybe<Scalars['Float']['output']>;
  /** Product */
  product?: Maybe<Product>;
  /** Product Id */
  productId?: Maybe<Scalars['Int']['output']>;
  /** Product type */
  productType?: Maybe<Scalars['String']['output']>;
  /** Quantity */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** Variant */
  variant?: Maybe<Variant>;
  /** Variant Id */
  variantId?: Maybe<Scalars['Int']['output']>;
  /** vendor by us or global */
  vendor?: Maybe<Vendor>;
};

/** Attribtues for creating or updating a bundle product */
export type BundleProductInput = {
  /** Delete */
  _destroy: Scalars['Boolean']['input'];
  /** Is Global item */
  catalogType?: InputMaybe<Scalars['String']['input']>;
  /** Collection Id */
  collectionId?: InputMaybe<Scalars['Int']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Product Id */
  productId: Scalars['Int']['input'];
  /** Quantity */
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** Bundle Store */
export type BundleStore = {
  __typename?: 'BundleStore';
  /** accessibility tools enabled for store */
  accessibilityEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** accessibility tools enabled for store for custom domain */
  accessibilityEnabledOnCustomDomain?: Maybe<Scalars['Boolean']['output']>;
  /** Accessible to current user */
  accessible: Scalars['Boolean']['output'];
  /** Accounts */
  account?: Maybe<Account>;
  /** Display as a locker shop */
  actAsLockerShop?: Maybe<Scalars['Boolean']['output']>;
  /** active */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** address */
  address?: Maybe<Scalars['String']['output']>;
  /** admins count */
  adminsCount?: Maybe<Scalars['Int']['output']>;
  /** Allowed locker products with global zone */
  allowGlobalLockerProducts?: Maybe<Scalars['Boolean']['output']>;
  /** Store current display and current user display currencies */
  availableDisplayCurrencies?: Maybe<Array<DisplayCurrency>>;
  /** Related banner */
  banner?: Maybe<DigitalAsset>;
  /** User email blacklisted */
  blacklisted: Scalars['Boolean']['output'];
  /** Branding & Theme Configuration */
  brandingTheme?: Maybe<StoreBrandingTheme>;
  /** Bundle for a country */
  bundle?: Maybe<Product>;
  /** bundle number */
  bundleNumber?: Maybe<Scalars['String']['output']>;
  /** bundle state */
  bundleState?: Maybe<Scalars['String']['output']>;
  /** Bundle Store Data */
  bundleStore?: Maybe<BundleStore>;
  /** All Bundles Zones */
  bundleZones?: Maybe<Array<Scalars['String']['output']>>;
  /** Bundles */
  bundles?: Maybe<Array<Product>>;
  /** Cache key */
  cacheKey?: Maybe<Scalars['String']['output']>;
  /** Catalog */
  catalog?: Maybe<Catalog>;
  /** catalogs */
  catalogCache?: Maybe<CatalogCache>;
  /** Catalog Store Ids */
  catalogStoreIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** organizer emails which have visited catalogs */
  catalogVisitedOrganizers: Array<Scalars['String']['output']>;
  /** catalogs */
  catalogs?: Maybe<Array<Catalog>>;
  /** Clone ID */
  cloneId?: Maybe<Scalars['ID']['output']>;
  /** Cloning in Progress */
  cloningInProgress?: Maybe<Scalars['Boolean']['output']>;
  /** associated CMS pages */
  cmsPages?: Maybe<Array<CmsPage>>;
  /** unique code */
  code?: Maybe<Scalars['String']['output']>;
  /** Compressed Product Image */
  compressedProductImage?: Maybe<Scalars['Attachment']['output']>;
  /** Compressed Top Banner */
  compressedTopBanner?: Maybe<Scalars['Attachment']['output']>;
  /** Config */
  config: StoreConfig;
  /** contact phone */
  contactPhone?: Maybe<Scalars['String']['output']>;
  /** Status for a taxon with for_swag as true attached to this store */
  containsMerch: Scalars['Boolean']['output'];
  /** created at */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Store Creator */
  creator?: Maybe<User>;
  /** Store Creator Domain */
  creatorDomain?: Maybe<Scalars['String']['output']>;
  /** fiat/custom/priceless */
  currencyType?: Maybe<Scalars['String']['output']>;
  /** custom currency membership applied */
  customCurrencyAddon?: Maybe<Scalars['Boolean']['output']>;
  /** Store Custom Domain Enabled */
  customDomainEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Store Custom Domain */
  customDomainRoot?: Maybe<Scalars['String']['output']>;
  /** Store Custom Domain Url */
  customDomainUrl?: Maybe<Scalars['String']['output']>;
  /** Store Custom Domain Verified */
  customDomainVerified?: Maybe<Scalars['Boolean']['output']>;
  /** customer support email */
  customerSupportEmail?: Maybe<Scalars['String']['output']>;
  /** customizer logos, will be used to customize swag */
  customizerLogos?: Maybe<Array<Scalars['Attachment']['output']>>;
  /** default */
  default?: Maybe<Scalars['Boolean']['output']>;
  /** default country id */
  defaultCountryId?: Maybe<Scalars['Int']['output']>;
  /** default currency */
  defaultCurrency?: Maybe<Scalars['String']['output']>;
  /** default locale */
  defaultLocale?: Maybe<Scalars['String']['output']>;
  /** description */
  description?: Maybe<Scalars['String']['output']>;
  /** Display warehouse address for locker shop */
  displayWarehouseAddress?: Maybe<Scalars['Boolean']['output']>;
  /** Store Admins with Read only access */
  editAccessStoreAdmins: Array<User>;
  /** organizers who have visited edit catalogs */
  editCatalogVisitedOrganizers: Array<Scalars['String']['output']>;
  /** identify whether price rouding is enabled or not */
  enableCeilPrices?: Maybe<Scalars['Boolean']['output']>;
  /** Store does not have non swag magic store products */
  enabledGlobalCatalog?: Maybe<Scalars['Boolean']['output']>;
  /** Store has active, enabled products or not */
  enabledProductsPresent?: Maybe<Scalars['Boolean']['output']>;
  /** External ID */
  externalId?: Maybe<Scalars['ID']['output']>;
  /** facebook */
  facebook?: Maybe<Scalars['String']['output']>;
  /** favicon */
  favicon?: Maybe<Scalars['Attachment']['output']>;
  /** Frontend Store URL */
  feUrl: Scalars['String']['output'];
  /** Frontend Store URL with workspace slug */
  feUrlWithWorkspaceSlug: Scalars['String']['output'];
  /** Store Featured or not */
  featured?: Maybe<Scalars['Boolean']['output']>;
  /** First marketing Category */
  firstMarketingCategory?: Maybe<MarketingCategory>;
  /** Form states for store */
  formStates?: Maybe<Scalars['JSON']['output']>;
  /** hex code */
  hexCode?: Maybe<Scalars['String']['output']>;
  /** Hide Bulk Pricing */
  hideBulkPricing?: Maybe<Scalars['Boolean']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** instagram */
  instagram?: Maybe<Scalars['String']['output']>;
  /** Whether products of this store are customizable */
  isCustomizable: Scalars['Boolean']['output'];
  /** Is Kit */
  isKit?: Maybe<Scalars['Boolean']['output']>;
  /** current user is store owner or not */
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  /** is subscribed */
  isSubscribed?: Maybe<Scalars['Boolean']['output']>;
  /** logo */
  logo?: Maybe<Scalars['Attachment']['output']>;
  /** logo file extension */
  logoType?: Maybe<Scalars['String']['output']>;
  /** mail from address */
  mailFromAddress?: Maybe<Scalars['String']['output']>;
  /** max price cap for products in priceless shop */
  maxPrice?: Maybe<Scalars['Float']['output']>;
  /** Memberships */
  membership: Membership;
  /** Return a menu */
  menu?: Maybe<Menu>;
  /** meta description */
  metaDescription?: Maybe<Scalars['String']['output']>;
  /** meta keywords */
  metaKeywords?: Maybe<Scalars['String']['output']>;
  /** min price cap for products in priceless shop */
  minPrice?: Maybe<Scalars['Float']['output']>;
  /** top banner for mobile view */
  mobileTopBanner?: Maybe<Scalars['Attachment']['output']>;
  /** First N Bundle Products */
  nBundleProducts?: Maybe<Array<BundleProduct>>;
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
  /** new order notifications email */
  newOrderNotificationsEmail?: Maybe<Scalars['String']['output']>;
  /** Friendly Id */
  number: Scalars['String']['output'];
  /** Optimized Search Required */
  optimizedSearch?: Maybe<Scalars['Boolean']['output']>;
  /** Is shop owned by stadium */
  ownedByStadium: Scalars['Boolean']['output'];
  /** Parent object */
  parent?: Maybe<Store>;
  /** Parent ID */
  parentId?: Maybe<Scalars['ID']['output']>;
  /** Current user permissions for the store */
  permissions?: Maybe<Scalars['JSON']['output']>;
  /** Migration of Shop points to stadium points */
  pointsMigrationAllowed: Scalars['Boolean']['output'];
  /** Preview Image */
  previewImage?: Maybe<Scalars['Attachment']['output']>;
  /** Private Shop */
  private: Scalars['Boolean']['output'];
  /** Product Image */
  productImage?: Maybe<Scalars['Attachment']['output']>;
  /** whether to display variants as products or not */
  productsBroken?: Maybe<Scalars['Boolean']['output']>;
  /** whether the products creation is completed or not */
  productsCreationCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** Store frontend url link qr code */
  qrCodeImage?: Maybe<Scalars['Attachment']['output']>;
  /** Store Admins with Read only access */
  readAccessStoreAdmins: Array<User>;
  /** Restrict category widgets */
  restrictCategoryWidgets: Scalars['Boolean']['output'];
  /** seo robots */
  seoRobots?: Maybe<Scalars['String']['output']>;
  /** seo title */
  seoTitle?: Maybe<Scalars['String']['output']>;
  /** Shop code with workspace slug */
  shopCodeWithWorkspaceSlug?: Maybe<Scalars['String']['output']>;
  /** Shop Top Banner */
  shopTopBanner?: Maybe<Scalars['Attachment']['output']>;
  /** Type of Shop */
  shopType: Scalars['String']['output'];
  /** Show loader when cloning in progress */
  showLoader?: Maybe<Scalars['Boolean']['output']>;
  /** Show You might also like */
  showMoreFromThisBrand: Scalars['Boolean']['output'];
  /** Show More from this brand */
  showYouMightAlsoLike: Scalars['Boolean']['output'];
  /** state */
  state?: Maybe<Scalars['String']['output']>;
  /**  Store admins */
  storeAdmins: Array<User>;
  /** Store Detail */
  storeDetail?: Maybe<StoreDetail>;
  /** Locker Shop Store IDS */
  storeIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** store owners */
  storeOwners?: Maybe<Array<User>>;
  /** supported currencies */
  supportedCurrencies?: Maybe<Scalars['String']['output']>;
  /** supported locales */
  supportedLocales?: Maybe<Scalars['String']['output']>;
  /** Swag Only Shop enabled/disabled on store */
  swagOnlyShop?: Maybe<Scalars['Boolean']['output']>;
  /** verify if the products have been synced to ES or not */
  syncedToEs?: Maybe<Scalars['Boolean']['output']>;
  /** tagline */
  tagline?: Maybe<Scalars['String']['output']>;
  /** Taxon IDs */
  taxonIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Moment Shop Name */
  templateName?: Maybe<Scalars['String']['output']>;
  /** theme */
  theme?: Maybe<Scalars['String']['output']>;
  /** Theme details */
  themeDetails?: Maybe<Scalars['String']['output']>;
  /** top banner */
  topBanner?: Maybe<Scalars['Attachment']['output']>;
  /** Total Number of Bundle Products */
  totalBundleProducts?: Maybe<Scalars['Int']['output']>;
  /** Total Number of US Bundle Products */
  totalUsProducts?: Maybe<Scalars['Int']['output']>;
  /** twitter */
  twitter?: Maybe<Scalars['String']['output']>;
  /** unavailable products */
  unavailableBundleProducts?: Maybe<Array<BundleProduct>>;
  /** updated at */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** url */
  url?: Maybe<Scalars['String']['output']>;
  /** verify if the variants have been associated or not */
  variantsAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** organizer emails which have visited */
  visitedOrganizers: Array<Scalars['String']['output']>;
  /** Working on Fallback or cloned actually */
  workingOnFallback?: Maybe<Scalars['Boolean']['output']>;
  /** Workspace ID */
  workspaceId?: Maybe<Scalars['String']['output']>;
};


/** Bundle Store */
export type BundleStoreAccessibilityEnabledArgs = {
  customDomainRoot?: InputMaybe<Scalars['String']['input']>;
};


/** Bundle Store */
export type BundleStoreBundleArgs = {
  country: Scalars['String']['input'];
  sendUsToNonUs?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bundle Store */
export type BundleStoreCmsPagesArgs = {
  selectedTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


/** Bundle Store */
export type BundleStoreMenuArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  forceCache?: InputMaybe<Scalars['Boolean']['input']>;
  globalZone?: InputMaybe<Scalars['Boolean']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  isDesigner?: InputMaybe<Scalars['Boolean']['input']>;
  location: Scalars['String']['input'];
  storeCode?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['String']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** Bundle Store */
export type BundleStoreNBundleProductsArgs = {
  limit: Scalars['Int']['input'];
};


/** Bundle Store */
export type BundleStorePermissionsArgs = {
  dashboardPermissions?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Bundle Store */
export type BundleStoreTaxonIdsArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
};

export type Campaign = {
  __typename?: 'Campaign';
  active: Scalars['Boolean']['output'];
  addVideoMessage?: Maybe<Scalars['Boolean']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  autoRecipients: Scalars['Boolean']['output'];
  baseOrderNumber?: Maybe<Scalars['String']['output']>;
  campaignType?: Maybe<CampaignTypeEnum>;
  campaignTypeText?: Maybe<Scalars['String']['output']>;
  completed: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['DateType']['output']>;
  contactFilters?: Maybe<Scalars['Hash']['output']>;
  createdAt: Scalars['DateType']['output'];
  creator?: Maybe<User>;
  dateOffset?: Maybe<DateOffset>;
  deactivationDate?: Maybe<Scalars['DateType']['output']>;
  deactivationReason?: Maybe<Scalars['String']['output']>;
  event?: Maybe<CampaignEvent>;
  formState?: Maybe<Scalars['Hash']['output']>;
  giftType?: Maybe<GiftTypeEnum>;
  id: Scalars['ID']['output'];
  isKitsOos: Scalars['Boolean']['output'];
  isPaymentFailing: Scalars['Boolean']['output'];
  locked: Scalars['Boolean']['output'];
  mailerPreferences?: Maybe<Scalars['Hash']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  orderSetting?: Maybe<OrderSetting>;
  orderStats?: Maybe<OrderStats>;
  owner?: Maybe<User>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  /** User permissions for this campaign */
  permissions: Scalars['Hash']['output'];
  receiveThankYouMessageEmailNotifications?: Maybe<Scalars['Boolean']['output']>;
  showThankYouMessagePrompt?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  totalRecipients?: Maybe<Scalars['Int']['output']>;
  /** Short summary of upcoming gifts */
  upcomingGifts?: Maybe<Array<Gift>>;
  videoMessagePresent?: Maybe<Scalars['Boolean']['output']>;
  webhookCampaignsApiDocsUrl?: Maybe<Scalars['String']['output']>;
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export type CampaignConfig = {
  __typename?: 'CampaignConfig';
  campaignPresets: Array<CampaignPreset>;
  campaignTypeCollection: Scalars['Hash']['output'];
  contactDataCollection: Scalars['Hash']['output'];
  frequencyCollection: Scalars['Hash']['output'];
  sendInviteOnCollection: Scalars['Hash']['output'];
};

export type CampaignEvent = {
  __typename?: 'CampaignEvent';
  atsInterviewStageNames?: Maybe<Array<Scalars['String']['output']>>;
  contactData?: Maybe<Scalars['String']['output']>;
  contactProviderId?: Maybe<Scalars['Int']['output']>;
  crmCampaignId?: Maybe<Scalars['Int']['output']>;
  crmListId?: Maybe<Scalars['Int']['output']>;
  dayPeriod?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateType']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  milestone?: Maybe<Scalars['Int']['output']>;
  minOpportunityAmount?: Maybe<Scalars['Float']['output']>;
  sendInviteDate?: Maybe<Scalars['DateType']['output']>;
  sendInviteOn?: Maybe<Scalars['String']['output']>;
  sendToExisting?: Maybe<Scalars['Boolean']['output']>;
  sendToOnlyPrimary?: Maybe<Scalars['Boolean']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  stageId?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['DateType']['output']>;
  timeHours?: Maybe<Scalars['String']['output']>;
  timeMins?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type CampaignEventInput = {
  atsInterviewStageNames?: InputMaybe<Array<Scalars['String']['input']>>;
  contactData?: InputMaybe<Scalars['String']['input']>;
  contactProviderId?: InputMaybe<Scalars['Int']['input']>;
  crmCampaignId?: InputMaybe<Scalars['Int']['input']>;
  crmListId?: InputMaybe<Scalars['Int']['input']>;
  dayPeriod?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateType']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  milestone?: InputMaybe<Scalars['Int']['input']>;
  minOpportunityAmount?: InputMaybe<Scalars['Float']['input']>;
  sendInviteDate?: InputMaybe<Scalars['DateType']['input']>;
  sendInviteOn?: InputMaybe<Scalars['String']['input']>;
  sendToExisting?: InputMaybe<Scalars['Boolean']['input']>;
  sendToOnlyPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateType']['input']>;
  timeHours?: InputMaybe<Scalars['String']['input']>;
  timeMins?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignInput = {
  addVideoMessage?: InputMaybe<Scalars['Boolean']['input']>;
  autoRecipients?: InputMaybe<Scalars['Boolean']['input']>;
  baseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  campaignType?: InputMaybe<CampaignTypeEnum>;
  campaignTypeText?: InputMaybe<Scalars['String']['input']>;
  contactFilters?: InputMaybe<Scalars['Hash']['input']>;
  dateOffset?: InputMaybe<DateOffsetInput>;
  event?: InputMaybe<CampaignEventInput>;
  formState?: InputMaybe<Scalars['Hash']['input']>;
  giftType?: InputMaybe<GiftTypeEnum>;
  markComplete?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderSetting?: InputMaybe<OrderSettingInput>;
  receiveThankYouMessageEmailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  retryFailedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  showThankYouMessagePrompt?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignOrder = {
  __typename?: 'CampaignOrder';
  date: Scalars['DateType']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** First and last name from the campaign contact */
  name?: Maybe<Scalars['String']['output']>;
};

export type CampaignOrderList = {
  __typename?: 'CampaignOrderList';
  meta: ListMeta;
  upcomingCampaignGifts?: Maybe<Array<CampaignOrder>>;
};

export type CampaignPreset = {
  __typename?: 'CampaignPreset';
  contactData?: Maybe<Scalars['Hash']['output']>;
  enabledContactProviders?: Maybe<Array<Scalars['String']['output']>>;
  frequency?: Maybe<Scalars['Hash']['output']>;
  hint: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  sendInviteOn: Scalars['Hash']['output'];
  showContactData: Scalars['Boolean']['output'];
  showContactProvider: Scalars['Boolean']['output'];
  showCrmCampaignList: Scalars['Boolean']['output'];
  showCrmCampaignStage: Scalars['Boolean']['output'];
  showEndDate: Scalars['Boolean']['output'];
  showFrequency: Scalars['Boolean']['output'];
  showHubspotList: Scalars['Boolean']['output'];
  showInterviewStages: Scalars['Boolean']['output'];
  showMilestone: Scalars['Boolean']['output'];
  showOpportunityAmount: Scalars['Boolean']['output'];
  showOpportunityStage: Scalars['Boolean']['output'];
  showRecipientInfo: Scalars['Boolean']['output'];
  showStartDate: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

/** Valid types for campaign types */
export enum CampaignTypeEnum {
  AtsInterviewStage = 'ats_interview_stage',
  CrmCampaign = 'crm_campaign',
  CrmList = 'crm_list',
  CrmOpportunity = 'crm_opportunity',
  Milestone = 'milestone',
  NewHires = 'new_hires',
  OnceEveryYear = 'once_every_year',
  Recurring = 'recurring',
  Webhook = 'webhook'
}

/** Store Catalog */
export type Catalog = {
  __typename?: 'Catalog';
  /** Active proudcts count */
  activeProductsCount?: Maybe<Scalars['Int']['output']>;
  /** Catalog added in store */
  addedInStore?: Maybe<Scalars['Boolean']['output']>;
  /** Products count added in store */
  addedInStoreCount?: Maybe<Scalars['Int']['output']>;
  /** Catalog added to store at */
  addedToStoreAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Approval Required */
  approvalRequired: Scalars['Boolean']['output'];
  /** Archival date */
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Total Automated Products to be added to the catalog */
  automatedProductsCount?: Maybe<Scalars['Int']['output']>;
  /** Total Available products count */
  availableProductsCount?: Maybe<Scalars['Int']['output']>;
  /** Can add catalog to shop */
  canAddToStore: Scalars['Boolean']['output'];
  /** Can Archive Catalog */
  canArchive: Scalars['Boolean']['output'];
  /** Can request bulk shipment */
  canBulkRequest?: Maybe<Scalars['Boolean']['output']>;
  /** Can customize products of this catalog */
  canCustomize: Scalars['Boolean']['output'];
  /** Can Edit Catalog */
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  /** Can Request changes */
  canRequestChanges: Scalars['Boolean']['output'];
  /** Can Restock Product */
  canRestock?: Maybe<Scalars['Boolean']['output']>;
  /** Can Share Catalog */
  canShare: Scalars['Boolean']['output'];
  /** Can View Catalog */
  canView: Scalars['Boolean']['output'];
  /** Color group ids */
  colorGroupIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** created at */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Store Creator */
  creator?: Maybe<User>;
  /** Store Creator Domain */
  creatorDomain?: Maybe<Scalars['String']['output']>;
  /** whether or not this catalog is customizable or not */
  customizable: Scalars['Boolean']['output'];
  /** design change by date */
  designChangeByDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** design guideline */
  designGuideline?: Maybe<Scalars['Attachment']['output']>;
  /** Display state */
  displayState?: Maybe<Scalars['String']['output']>;
  /** catalog design ready date */
  estimatedReadyDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** catalog design ready date for all */
  estimatedReadyDateForAll?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** External order number */
  externalOrderNumber?: Maybe<Scalars['String']['output']>;
  /** id */
  id: Scalars['ID']['output'];
  /** kind of catalog */
  kind: Scalars['String']['output'];
  /** whether logo is editable */
  logoEditable: Scalars['Boolean']['output'];
  /** User authorized to use logos */
  logosAuthorized: Scalars['Boolean']['output'];
  /** name of catalog */
  name?: Maybe<Scalars['String']['output']>;
  /** next unapproved product */
  nextUnapprovedProduct?: Maybe<Product>;
  /** unique identifier of catalog */
  number: Scalars['String']['output'];
  /** payment status */
  paid: Scalars['Boolean']['output'];
  /** catalog user paid or not */
  paidUser: Scalars['Boolean']['output'];
  /** primary logo via digital asset */
  primaryDigitalAssetLogo?: Maybe<DigitalAsset>;
  /** primary logo object */
  primaryLogo?: Maybe<Logo>;
  /** primary logo */
  primaryLogoFile?: Maybe<Scalars['Attachment']['output']>;
  /** Has Product that is disabled at Top Level */
  productDisabledAtTopLevel?: Maybe<Scalars['Boolean']['output']>;
  /** Return product list */
  products: Array<Product>;
  /** products not added in store */
  productsNotAdded: Scalars['Boolean']['output'];
  /** recipient locations */
  recipientLocations?: Maybe<Array<Scalars['String']['output']>>;
  /** Recipient located outside US or not */
  recipientOutsideUs?: Maybe<Scalars['String']['output']>;
  /** secondary logos object */
  secondaryLogos: Array<Logo>;
  /** secondary logos */
  secondaryLogosFiles: Array<Scalars['Attachment']['output']>;
  /** Show draft automated mockup banner */
  showDraftAutomatedMockupBanner?: Maybe<Scalars['Boolean']['output']>;
  /** unique identifier of catalog */
  slug: Scalars['String']['output'];
  /** state of catalog */
  state?: Maybe<Scalars['String']['output']>;
  /** Status Information */
  statusInformation?: Maybe<Scalars['String']['output']>;
  /** store of catalog */
  store: Store;
  /** StoreCatalogs */
  storeCatalogs?: Maybe<Array<StoreCatalog>>;
  /** Store ID */
  storeId: Scalars['ID']['output'];
  /** Logo page user comment */
  userNotes?: Maybe<Scalars['String']['output']>;
};


/** Store Catalog */
export type CatalogAddedInStoreArgs = {
  storeNumber: Scalars['String']['input'];
};


/** Store Catalog */
export type CatalogAddedInStoreCountArgs = {
  storeNumber: Scalars['String']['input'];
};


/** Store Catalog */
export type CatalogAddedToStoreAtArgs = {
  storeNumber: Scalars['String']['input'];
};


/** Store Catalog */
export type CatalogAvailableProductsCountArgs = {
  includeInactiveProducts?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Store Catalog */
export type CatalogProductsArgs = {
  forCatalogStore?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Store Catalog */
export type CatalogCache = {
  __typename?: 'CatalogCache';
  /** Active Product Ids */
  activateProductIds: Array<Scalars['String']['output']>;
  /** Inactive Product Ids */
  deactivateProductIds: Array<Scalars['String']['output']>;
  /** Disabled Taxon Ids */
  disableTaxonIds: Array<Scalars['String']['output']>;
  /** Disabled Product Ids */
  disabledProductIds: Array<Scalars['String']['output']>;
  /** Enabled Product Ids */
  enableTaxonIds: Array<Scalars['String']['output']>;
  /** Enabled Product Ids */
  enabledProductIds: Array<Scalars['String']['output']>;
};

/** Return images of catalog variant */
export type CatalogVariantImages = {
  __typename?: 'CatalogVariantImages';
  /** external id */
  catalogStoreExternalId: Scalars['ID']['output'];
  /** internal id */
  catalogStoreId: Scalars['ID']['output'];
  /** Is store catalog in design_complete state */
  designed: Scalars['Boolean']['output'];
  /** Images */
  images?: Maybe<Array<Scalars['Attachment']['output']>>;
  /** Does this variant belongs to users locker */
  lockerProduct: Scalars['Boolean']['output'];
  /** Product Slug */
  productSlug: Scalars['String']['output'];
};

/** Return images of catalog variant */
export type CatalogVariants = {
  __typename?: 'CatalogVariants';
  /** Catalog store external id */
  catalogStoreExternalId?: Maybe<Scalars['ID']['output']>;
  /** All enabled variants in a catalog */
  variants?: Maybe<Array<Variant>>;
};

/** Category information */
export type Category = {
  __typename?: 'Category';
  id: Scalars['ID']['output'];
  intent: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rewards: Array<Reward>;
  termsAndConditions: Scalars['String']['output'];
};

/** Input type for change password */
export type ChangePasswordInput = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};

/** Autogenerated input type of ChangePrivacy */
export type ChangePrivacyInput = {
  /** Consent for displaying the shop */
  allowToPublish?: InputMaybe<Scalars['Boolean']['input']>;
  /** Blacklisted emails */
  blacklistedEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Store number to identify store */
  number: Scalars['String']['input'];
  /** Store privacy status */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whitelisted domains */
  whitelistedDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whitelisted emails */
  whitelistedEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restrict shop access to workspace members */
  workspaceAccessible?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of ChangePrivacy. */
export type ChangePrivacyPayload = {
  __typename?: 'ChangePrivacyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Response */
  response: Response;
};

/** Autogenerated input type of CheckoutAddProgramOrder */
export type CheckoutAddProgramOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  orderNumber: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
};

/** Autogenerated return type of CheckoutAddProgramOrder. */
export type CheckoutAddProgramOrderPayload = {
  __typename?: 'CheckoutAddProgramOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ChildCompany = {
  __typename?: 'ChildCompany';
  activePackage?: Maybe<Package>;
  /** Additional Cost Per Seat */
  additionalCostPerSeat?: Maybe<Scalars['Int']['output']>;
  adminUsers?: Maybe<Array<User>>;
  /** Total Admins Added Count */
  adminsCount?: Maybe<Scalars['Int']['output']>;
  /** Company users where migrated_user is false */
  companyUsers: PaginatedCompanyUsers;
  createdAt: Scalars['ISO8601DateTime']['output'];
  eshopEnabled: Scalars['Boolean']['output'];
  ghostCompany?: Maybe<ChildCompany>;
  id: Scalars['ID']['output'];
  /** Company users where migrated_user is true */
  migratedCompanyUsers: PaginatedCompanyUsers;
  name?: Maybe<Scalars['String']['output']>;
  nonGhostChildCompanies?: Maybe<Array<ChildCompany>>;
  note?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  ownerUser?: Maybe<User>;
  ownerUsers?: Maybe<Array<User>>;
  /** Associated Company Package */
  packageFeatures?: Maybe<Array<PackageFeature>>;
  /** Maps intent key based on input */
  packageIntentMappingKey?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  /** Extra Purchased Seat Count */
  seatsAdded?: Maybe<Scalars['Int']['output']>;
  /** Total seats included initially in package */
  seatsIncludedInPackage?: Maybe<Scalars['Int']['output']>;
  /** Unoccupied Seat Count */
  seatsLeft?: Maybe<Scalars['Int']['output']>;
  senderUsers?: Maybe<Array<User>>;
  subscription?: Maybe<Subscription>;
  /** Total number of current admins (migrated_user is false) */
  totalCurrentAdmins: Scalars['Int']['output'];
  /** Total number of current senders (migrated_user is false) */
  totalCurrentSenders: Scalars['Int']['output'];
  /** Total number of current users (migrated_user is false) */
  totalCurrentUsers: Scalars['Int']['output'];
  /** Total number of migrated admins (migrated_user is true) */
  totalMigratedAdmins: Scalars['Int']['output'];
  /** Total number of migrated senders (migrated_user is true) */
  totalMigratedSenders: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  users?: Maybe<Array<User>>;
};


export type ChildCompanyCompanyUsersArgs = {
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type ChildCompanyMigratedCompanyUsersArgs = {
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type ChildCompanyPackageIntentMappingKeyArgs = {
  originalKey: Scalars['String']['input'];
};

/** Autogenerated input type of Clone */
export type CloneInput = {
  /** Existion banner id */
  bannerId?: InputMaybe<Scalars['String']['input']>;
  /** Banner metadata */
  bannerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Clone Id by which store will be cloned */
  cloneId: Scalars['String']['input'];
  /** Display Currency (STC/USD/PRICELESS/display_currency_id) */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Logo file */
  logo?: InputMaybe<Scalars['Upload']['input']>;
  /** Existing logo id */
  logoId?: InputMaybe<Scalars['String']['input']>;
  /** Max price for products in priceless shop in USD */
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Min price for products in priceless shop in USD */
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Top banner */
  topBanner?: InputMaybe<Scalars['Upload']['input']>;
};

/** Autogenerated return type of Clone. */
export type ClonePayload = {
  __typename?: 'ClonePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Response */
  response: Response;
};

/** CMS Page */
export type CmsPage = {
  __typename?: 'CmsPage';
  /** sections of a page */
  cmsSections?: Maybe<Array<CmsSection>>;
  /** content */
  content?: Maybe<Scalars['String']['output']>;
  /** id */
  id: Scalars['ID']['output'];
  /** locale */
  locale?: Maybe<Scalars['String']['output']>;
  /** meta_description */
  metaDescription?: Maybe<Scalars['String']['output']>;
  /** meta_title */
  metaTitle?: Maybe<Scalars['String']['output']>;
  /** slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** store_id */
  storeId?: Maybe<Scalars['ID']['output']>;
  /** title */
  title?: Maybe<Scalars['String']['output']>;
  /** type */
  type?: Maybe<Scalars['String']['output']>;
  /** visible */
  visible?: Maybe<Scalars['Boolean']['output']>;
};


/** CMS Page */
export type CmsPageCmsSectionsArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
};

/** CMS Page Sections */
export type CmsSection = {
  __typename?: 'CmsSection';
  /** content */
  content?: Maybe<Scalars['String']['output']>;
  /** Country */
  countryIso?: Maybe<Scalars['String']['output']>;
  /** JSON configs */
  data?: Maybe<Scalars['JSON']['output']>;
  /** destination */
  destination?: Maybe<Scalars['Boolean']['output']>;
  /** Fit */
  fit?: Maybe<Scalars['String']['output']>;
  /** id */
  id: Scalars['ID']['output'];
  /** To indentify sections for third-party tools like Plasmic */
  identifier?: Maybe<Scalars['String']['output']>;
  /** image_one */
  imageOne?: Maybe<Scalars['Attachment']['output']>;
  /** image_three */
  imageThree?: Maybe<Scalars['Attachment']['output']>;
  /** image_two */
  imageTwo?: Maybe<Scalars['Attachment']['output']>;
  /** Intent */
  intent?: Maybe<CmsSectionEnum>;
  /** Json content */
  jsonContent?: Maybe<Scalars['String']['output']>;
  /** Settings */
  jsonSettings?: Maybe<Scalars['JSON']['output']>;
  /** linked resource */
  linkedResource?: Maybe<CmsSectionResource>;
  /** Return a menu */
  menu?: Maybe<Menu>;
  /** title */
  name?: Maybe<Scalars['String']['output']>;
  /** position */
  position?: Maybe<Scalars['String']['output']>;
  /** Show browse all products for brand/vendor */
  showBrowseAllProducts?: Maybe<Scalars['Boolean']['output']>;
  /** Taxon IDs */
  taxonIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Type */
  type?: Maybe<Scalars['String']['output']>;
};

/** CMS Section Enums */
export enum CmsSectionEnum {
  /** banner with message */
  BannerImage = 'banner_image',
  /** banner with message */
  BannerWithMessage = 'banner_with_message',
  /** Best Brands */
  BestBrands = 'best_brands',
  /** Best Selling Products */
  BestSellingProducts = 'best_selling_products',
  /** book a call section */
  BookACallSection = 'book_a_call_section',
  /** Default Brand Page Content */
  BrandPage = 'brand_page',
  /** Default Cart Page Content */
  CartPage = 'cart_page',
  /** Case Studies */
  CaseStudies = 'case_studies',
  /** catalog hero image with button */
  CatalogHeroImageWithButton = 'catalog_hero_image_with_button',
  /** catalog marketing banner */
  CatalogMarketingBanner = 'catalog_marketing_banner',
  /** catalog offerings */
  CatalogOfferings = 'catalog_offerings',
  /** Catalog Page */
  CatalogPage = 'catalog_page',
  /** Default Category Page Content */
  CategoryPage = 'category_page',
  /** Default Checkout Page Content */
  CheckoutPage = 'checkout_page',
  /** Collapsible Message */
  CollapsibleMessage = 'collapsible_message',
  /** Default Collection Page Content */
  CollectionPage = 'collection_page',
  /** country carousel */
  CountryCarousel = 'country_carousel',
  /** Country Featured Brands */
  CountryFeaturedBrands = 'country_featured_brands',
  /** Country Featured Categories */
  CountryFeaturedCategories = 'country_featured_categories',
  /** Country Featured Picks */
  CountryFeaturedPicks = 'country_featured_picks',
  /** Custom */
  Custom = 'custom',
  /** Default Page Content */
  DefaultPageContent = 'default_page_content',
  /** FAQs Accordion */
  Faqs = 'faqs',
  /** featured brand with items */
  FeaturedBrandWithItems = 'featured_brand_with_items',
  /** featured picks */
  FeaturedPicks = 'featured_picks',
  /** featured product */
  FeaturedProduct = 'featured_product',
  /** featured shops */
  FeaturedShops = 'featured_shops',
  /** gift catalog */
  GiftCatalog = 'gift_catalog',
  /** hero image */
  HeroImage = 'hero_image',
  /** image with text on left */
  ImageWithTextOnLeft = 'image_with_text_on_left',
  /** image with text on right */
  ImageWithTextOnRight = 'image_with_text_on_right',
  /** kit carousel */
  KitCarousel = 'kit_carousel',
  /** locker catalog */
  LockerCatalog = 'locker_catalog',
  /** logo */
  Logo = 'logo',
  /** Additional Brand Products */
  MoreFromBrand = 'more_from_brand',
  /** onboarding package details */
  OnboardingPackageDetails = 'onboarding_package_details',
  /** Default Order Confirmation Page Content */
  OrderConfirmationPage = 'order_confirmation_page',
  /** Plasmic Content */
  PlasmicContent = 'plasmic_content',
  /** Default Product Detail Page Content */
  ProductDetailPage = 'product_detail_page',
  /** Default Product Listing Page Content */
  ProductListingPage = 'product_listing_page',
  /** Redeemption Gift Card Page */
  RedeemGiftCardPage = 'redeem_gift_card_page',
  /** Default Search Page Content */
  SearchPage = 'search_page',
  /** shop by category */
  ShopByCategory = 'shop_by_category',
  /** shop designed swags */
  ShopDesignedSwags = 'shop_designed_swags',
  /** shop our catalog */
  ShopOurCatalog = 'shop_our_catalog',
  /** Shop WorldWide */
  ShopWorldwide = 'shop_worldwide',
  /** Suggested Products */
  SimilarProducts = 'similar_products',
  /** text only */
  TextOnly = 'text_only',
  /** Theme Collection */
  ThemeCollection = 'theme_collection',
  /** Trending Shop Templates */
  TrendingShopTemplates = 'trending_shop_templates'
}

/** objects which can be linked resource on CMS Section */
export type CmsSectionResource = Brand | Menu | Product | Taxon | Vendor;

export type Comment = {
  __typename?: 'Comment';
  amount: Scalars['Int']['output'];
  body: Scalars['String']['output'];
  commentor: User;
  createdAt: Scalars['DateType']['output'];
  creatorExist: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<PostImage>>;
  lockAt: Scalars['DateType']['output'];
  locked: Scalars['Boolean']['output'];
  mentions?: Maybe<Array<Mention>>;
  ownerContact?: Maybe<ProgramContact>;
  post: Post;
  reactions?: Maybe<Array<PostReaction>>;
  stickers?: Maybe<Array<PostSticker>>;
};

export type CommentList = {
  __typename?: 'CommentList';
  comments?: Maybe<Array<Comment>>;
  meta: ListMeta;
};

/** CompanyDetail */
export type CompanyDetail = {
  __typename?: 'CompanyDetail';
  /** Logos of desired types */
  attachedLogos?: Maybe<Array<Logo>>;
  /** Domain */
  domain: Scalars['String']['output'];
  /** ID */
  id: Scalars['ID']['output'];
  /** Logos of desired types */
  logos: Array<Scalars['Hash']['output']>;
  /** Company Name */
  name: Scalars['String']['output'];
  /** Ordered Logos of desired types */
  orderedLogos: Array<Scalars['Hash']['output']>;
  /** Available Logo Themes */
  possibleLogoThemes: Array<Scalars['String']['output']>;
  /** Available Logo Types */
  possibleLogoTypes: Array<Scalars['String']['output']>;
};


/** CompanyDetail */
export type CompanyDetailAttachedLogosArgs = {
  themes?: InputMaybe<Array<Scalars['String']['input']>>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** CompanyDetail */
export type CompanyDetailLogosArgs = {
  themes?: InputMaybe<Array<Scalars['String']['input']>>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** CompanyDetail */
export type CompanyDetailOrderedLogosArgs = {
  themes?: InputMaybe<Array<Scalars['String']['input']>>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CompanyPackage = {
  __typename?: 'CompanyPackage';
  /** Child company */
  company: ChildCompany;
  /** Package */
  package: Package;
};

export type CompanyPackageFeatureAssignment = {
  __typename?: 'CompanyPackageFeatureAssignment';
  /** Company */
  company: ChildCompany;
  /** In progress purchased seats */
  delta?: Maybe<Scalars['Int']['output']>;
  /** Package Feature */
  packageFeature: PackageFeature;
  /** Total additional Purchased seats */
  totalPurchased?: Maybe<Scalars['Int']['output']>;
};

export type CompanyUser = {
  __typename?: 'CompanyUser';
  company: ChildCompany;
  id: Scalars['ID']['output'];
  migratedUser: Scalars['Boolean']['output'];
  roleTitle?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type CompanyValue = {
  __typename?: 'CompanyValue';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Config information */
export type Config = {
  __typename?: 'Config';
  amountToPointsMapping: Scalars['JSON']['output'];
  autoTopUpAmounts?: Maybe<Array<Scalars['Int']['output']>>;
  autoTopUpBalances?: Maybe<Array<Scalars['Int']['output']>>;
  contactEmploymentStatuses: Array<Scalars['Hash']['output']>;
  contactOfferStatuses: Array<Scalars['Hash']['output']>;
  countries: Array<Country>;
  maxAllotedPointsPerOrder: Scalars['Int']['output'];
  minimumTierPoints: Scalars['Int']['output'];
  partnerApiDocsUrl: Scalars['String']['output'];
  rewardsLaunchDate: Scalars['ISO8601Date']['output'];
  teamGiftPreferences: Array<Scalars['Hash']['output']>;
  teamOnboardingFile?: Maybe<Scalars['String']['output']>;
  teamOnboardingFileUpdatedAt?: Maybe<Scalars['DateType']['output']>;
  thresholdTierPointsLimit: Scalars['Int']['output'];
  userContactsSampleCsv?: Maybe<Scalars['String']['output']>;
  userContactsSampleCsvWithPreApproval?: Maybe<Scalars['String']['output']>;
  userContactsSampleCsvWithRoles?: Maybe<Scalars['String']['output']>;
  walletAmountDenominations: Array<Scalars['Int']['output']>;
  walletCurrencies: Array<Currency>;
  walletSavingsPlans: Array<WalletSavingsPlan>;
  waysToEarnLaunchDate: Scalars['ISO8601Date']['output'];
};

/** Autogenerated input type of ConnectUserContactProvider */
export type ConnectUserContactProviderInput = {
  category: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  providerSlug?: InputMaybe<Scalars['String']['input']>;
  ripplingOauthCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ConnectUserContactProvider. */
export type ConnectUserContactProviderPayload = {
  __typename?: 'ConnectUserContactProviderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contactProvider?: Maybe<ContactProvider>;
  errors?: Maybe<Scalars['Hash']['output']>;
  linkToken?: Maybe<Scalars['String']['output']>;
  nicknameRequired: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ConsumeAdminPasswordResetLink */
export type ConsumeAdminPasswordResetLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Autogenerated return type of ConsumeAdminPasswordResetLink. */
export type ConsumeAdminPasswordResetLinkPayload = {
  __typename?: 'ConsumeAdminPasswordResetLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Scalars['Hash']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  /** Whether the contact is active or not */
  active: Scalars['Boolean']['output'];
  avatarUrl?: Maybe<Scalars['AttachmentType']['output']>;
  categoryNames?: Maybe<Array<Scalars['String']['output']>>;
  checked: Scalars['Boolean']['output'];
  customField1?: Maybe<Scalars['String']['output']>;
  customField2?: Maybe<Scalars['String']['output']>;
  customField3?: Maybe<Scalars['String']['output']>;
  customField4?: Maybe<Scalars['String']['output']>;
  customField5?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['DateType']['output']>;
  deletable: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  employmentEndDate?: Maybe<Scalars['DateType']['output']>;
  employmentStartDate?: Maybe<Scalars['DateType']['output']>;
  employmentStatus?: Maybe<Scalars['String']['output']>;
  excludeFromCampaigns: Scalars['Boolean']['output'];
  excludeFromPrograms: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  homeAddress?: Maybe<Address>;
  id: Scalars['ID']['output'];
  integratedWith?: Maybe<Scalars['String']['output']>;
  /** Contact User is admin of active company package */
  isActivePackageAdmin: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lastRedeemedOn?: Maybe<Scalars['DateType']['output']>;
  lockedFields?: Maybe<Array<Scalars['String']['output']>>;
  maskedDateOfBirth?: Maybe<Scalars['String']['output']>;
  offerClosedDate?: Maybe<Scalars['DateType']['output']>;
  offerStartDate?: Maybe<Scalars['DateType']['output']>;
  offerStatus?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Scalars['Hash']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preApproved: Scalars['Boolean']['output'];
  programAmount?: Maybe<Scalars['Int']['output']>;
  sharedAddress?: Maybe<Scalars['String']['output']>;
  sharedAddressName?: Maybe<Scalars['String']['output']>;
  spreeId?: Maybe<Scalars['Int']['output']>;
  staged?: Maybe<Scalars['Boolean']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  workAddress?: Maybe<Address>;
  workspaceUser?: Maybe<WorkspaceUser>;
};

export type ContactFilter = {
  __typename?: 'ContactFilter';
  excludeIds?: Maybe<Array<Scalars['String']['output']>>;
  filters?: Maybe<Scalars['Hash']['output']>;
  includeIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Contacts table column keys in preferred display order. Empty array means no column reordering. */
  orderedColumnKeys: Array<Scalars['String']['output']>;
  preApproveAllContacts: Scalars['Boolean']['output'];
  preApproveExcludeIds?: Maybe<Array<Scalars['String']['output']>>;
  preApproveIncludeIds?: Maybe<Array<Scalars['String']['output']>>;
  searchTerm?: Maybe<Scalars['String']['output']>;
  selectAllContacts: Scalars['Boolean']['output'];
  sourceId: Scalars['ID']['output'];
  sourceType: Scalars['String']['output'];
};

export type ContactFilterView = {
  __typename?: 'ContactFilterView';
  /** Filter payload, column order, and selection state (contact_filters row) */
  contactFilter: ContactFilter;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  owner: WorkspaceUser;
  shared: Scalars['Boolean']['output'];
};

export type ContactFilterViewInput = {
  filters?: InputMaybe<Scalars['Hash']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderedColumnKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContactInput = {
  customField1?: InputMaybe<Scalars['String']['input']>;
  customField2?: InputMaybe<Scalars['String']['input']>;
  customField3?: InputMaybe<Scalars['String']['input']>;
  customField4?: InputMaybe<Scalars['String']['input']>;
  customField5?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateType']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employmentEndDate?: InputMaybe<Scalars['DateType']['input']>;
  employmentStartDate?: InputMaybe<Scalars['DateType']['input']>;
  employmentStatus?: InputMaybe<Scalars['String']['input']>;
  excludeFromCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFromPrograms?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  homeAddress?: InputMaybe<AddressInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastRedeemedOn?: InputMaybe<Scalars['DateType']['input']>;
  offerClosedDate?: InputMaybe<Scalars['DateType']['input']>;
  offerStartDate?: InputMaybe<Scalars['DateType']['input']>;
  offerStatus?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<PermissionTypes>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<RoleTypes>;
  teamName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  workAddress?: InputMaybe<AddressInput>;
};

export type ContactList = {
  __typename?: 'ContactList';
  aggregations?: Maybe<Array<Scalars['Hash']['output']>>;
  contacts: Array<Contact>;
  meta?: Maybe<PaginationMetadata>;
};

export type ContactProvider = {
  __typename?: 'ContactProvider';
  category?: Maybe<Scalars['String']['output']>;
  contactsCount: Scalars['Int']['output'];
  crmCampaignStatuses?: Maybe<Array<CrmCampaignStatus>>;
  crmCampaigns?: Maybe<Array<CrmCampaign>>;
  crmLists?: Maybe<Array<CrmList>>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  currencyRequired?: Maybe<Scalars['Boolean']['output']>;
  errorDescription?: Maybe<Scalars['DateType']['output']>;
  id: Scalars['ID']['output'];
  importCompletedAt?: Maybe<Scalars['DateType']['output']>;
  importStartedAt?: Maybe<Scalars['DateType']['output']>;
  jobInterviewStages?: Maybe<Array<JobInterviewStage>>;
  lastSyncCompletedAt?: Maybe<Scalars['DateType']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  opportunityStages?: Maybe<Array<OpportunityStage>>;
  position?: Maybe<Scalars['Int']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  providerSlug?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  resyncCompletedAt?: Maybe<Scalars['DateType']['output']>;
  resyncStartedAt?: Maybe<Scalars['DateType']['output']>;
  sendNotifications?: Maybe<Scalars['Boolean']['output']>;
  syncCompletedAt?: Maybe<Scalars['DateType']['output']>;
  syncStartedAt?: Maybe<Scalars['DateType']['output']>;
  syncing?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['String']['output'];
};


export type ContactProviderCrmCampaignsArgs = {
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type ContactProviderCrmListsArgs = {
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ContactProviderInput = {
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  publicToken?: InputMaybe<Scalars['String']['input']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Country */
export type Country = {
  __typename?: 'Country';
  dialCode: Scalars['String']['output'];
  /** ID */
  id: Scalars['ID']['output'];
  /** Iso */
  iso: Scalars['String']['output'];
  /** Iso3 */
  iso3: Scalars['String']['output'];
  /** Iso Name */
  isoName: Scalars['String']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** States Required */
  statesRequired: Scalars['Boolean']['output'];
  /** Zipcode Required */
  zipcodeRequired: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateAssets */
export type CreateAssetsInput = {
  /** Asset attachment */
  attachment?: InputMaybe<Scalars['Upload']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Existing asset id */
  existingAssetId?: InputMaybe<Scalars['ID']['input']>;
  /** Kind of asset */
  kind: Scalars['String']['input'];
  /** Name of asset */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Notes of asset */
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateAssets. */
export type CreateAssetsPayload = {
  __typename?: 'CreateAssetsPayload';
  /** Digital Asset */
  asset?: Maybe<DigitalAsset>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of CreateAutomatedCatalog */
export type CreateAutomatedCatalogInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Logo mappings for automated catalog */
  logosMapping: Array<AutomatedCatalogLogoMappingInput>;
  /** Catalog number */
  number: Scalars['String']['input'];
};

/** Autogenerated return type of CreateAutomatedCatalog. */
export type CreateAutomatedCatalogPayload = {
  __typename?: 'CreateAutomatedCatalogPayload';
  /** Created catalog */
  catalog?: Maybe<Catalog>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of CreateAutomatedProducts */
export type CreateAutomatedProductsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Logo file */
  logo?: InputMaybe<Scalars['Upload']['input']>;
  /** Existing Logo Id */
  logoId?: InputMaybe<Scalars['Int']['input']>;
  /** Dummy Store number */
  number: Scalars['String']['input'];
};

/** Autogenerated return type of CreateAutomatedProducts. */
export type CreateAutomatedProductsPayload = {
  __typename?: 'CreateAutomatedProductsPayload';
  /** Automated Products */
  automatedProducts?: Maybe<Array<Product>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of CreateBaseImages */
export type CreateBaseImagesInput = {
  /** Asset attachments */
  attachments: Array<Scalars['Upload']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateBaseImages. */
export type CreateBaseImagesPayload = {
  __typename?: 'CreateBaseImagesPayload';
  /** Digital Assets */
  assets?: Maybe<Array<DigitalAsset>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of CreateCampaign */
export type CreateCampaignInput = {
  campaign?: InputMaybe<CampaignInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCampaign. */
export type CreateCampaignPayload = {
  __typename?: 'CreateCampaignPayload';
  campaign?: Maybe<Campaign>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateCatalog */
export type CreateCatalogInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Design guideline */
  designGuideline?: InputMaybe<Scalars['Upload']['input']>;
  /** Catalog ID */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Catalog kind */
  kind?: InputMaybe<Scalars['String']['input']>;
  /** Catalog Existing logo id */
  logoId?: InputMaybe<Scalars['String']['input']>;
  /** User authorized to use logos */
  logosAuthorized?: InputMaybe<Scalars['Boolean']['input']>;
  /** Catalog Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Primary Logo */
  primaryLogo?: InputMaybe<Scalars['Upload']['input']>;
  /** recipient locations */
  recipientLocations?: InputMaybe<Array<Scalars['String']['input']>>;
  /** recipient located outside US */
  recipientOutsideUs?: InputMaybe<Scalars['String']['input']>;
  /** Secondary Logos */
  secondaryLogos?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** comment on update logo */
  userNotes?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCatalog. */
export type CreateCatalogPayload = {
  __typename?: 'CreateCatalogPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Create/Update catalog response */
  response?: Maybe<Response>;
};

/** Autogenerated input type of CreateChildCompany */
export type CreateChildCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateChildCompany. */
export type CreateChildCompanyPayload = {
  __typename?: 'CreateChildCompanyPayload';
  childCompany?: Maybe<ChildCompany>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateCompanyWorkspace */
export type CreateCompanyWorkspaceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: WorkspaceInput;
};

/** Autogenerated return type of CreateCompanyWorkspace. */
export type CreateCompanyWorkspacePayload = {
  __typename?: 'CreateCompanyWorkspacePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  workspace?: Maybe<Workspace>;
};

/** Autogenerated input type of CreateContactFilterView */
export type CreateContactFilterViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: ContactFilterViewInput;
};

/** Autogenerated return type of CreateContactFilterView. */
export type CreateContactFilterViewPayload = {
  __typename?: 'CreateContactFilterViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contactFilterView?: Maybe<ContactFilterView>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateDigitalAsset */
export type CreateDigitalAssetInput = {
  /** Is approved by designer */
  approvedByDesigner?: InputMaybe<Scalars['Boolean']['input']>;
  /** Asset attachment */
  attachment: Scalars['Upload']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Folder id */
  folderId?: InputMaybe<Scalars['ID']['input']>;
  /** Kind of asset one of {:default=>0, :banner=>1, :csv=>2, :print_file=>3, :json=>4, :default_icon=>5, :default_mobile_app_icon=>6, :default_products_image=>7, :default_thumbnail_image=>8, :default_mobile_banner=>9, :default_banner=>10, :logo=>11, :design_guidelines=>12, :default_portrait_image=>13, :theme_portrait_image=>14, :theme_landscape_image=>15, :other=>16, :default_seo_image=>17} */
  kind?: InputMaybe<Scalars['String']['input']>;
  /** Is user authorized */
  userAuthorized?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CreateDigitalAsset. */
export type CreateDigitalAssetPayload = {
  __typename?: 'CreateDigitalAssetPayload';
  /** Digital Asset */
  asset?: Maybe<DigitalAsset>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Current User */
  user?: Maybe<User>;
};

/** Autogenerated input type of CreateDummyStore */
export type CreateDummyStoreInput = {
  /** Existing Banner Id */
  bannerId?: InputMaybe<Scalars['Int']['input']>;
  /** Banner metadata */
  bannerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Display Currency (STC/USD/PRICELESS) */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Logo file */
  logo?: InputMaybe<Scalars['Upload']['input']>;
  /** Existing Logo Id */
  logoId?: InputMaybe<Scalars['Int']['input']>;
  /** User authorized to use logos */
  logosAuthorized?: InputMaybe<Scalars['Boolean']['input']>;
  /** Max price for products in priceless shop in USD */
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Min price for products in priceless shop in USD */
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Parent Id by which store will be created */
  parentId: Scalars['Int']['input'];
  /** Taxon Ids */
  taxonIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Banner file */
  topBanner?: InputMaybe<Scalars['Upload']['input']>;
};

/** Autogenerated return type of CreateDummyStore. */
export type CreateDummyStorePayload = {
  __typename?: 'CreateDummyStorePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Dummy Store */
  dummyStore?: Maybe<DummyStore>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Current User */
  user?: Maybe<User>;
};

/** Autogenerated input type of Create */
export type CreateInput = {
  /** Existion banner id */
  bannerId?: InputMaybe<Scalars['String']['input']>;
  /** Banner metadata */
  bannerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company Detail Id */
  companyDetailId?: InputMaybe<Scalars['String']['input']>;
  /** Logo url */
  companyDetailLogoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Create automted catalog or not */
  createAutomatedCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display Currency (STC/USD/PRICELESS) */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Update form states for store */
  formStates?: InputMaybe<Scalars['JSON']['input']>;
  /** Logo file */
  logo?: InputMaybe<Scalars['Upload']['input']>;
  /** Existing logo id */
  logoId?: InputMaybe<Scalars['String']['input']>;
  /** User authorized to use logos */
  logosAuthorized?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Parent Id by which store will be created */
  parentId: Scalars['String']['input'];
  /** Taxons Ids for category select */
  taxonsIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Top banner */
  topBanner?: InputMaybe<Scalars['Upload']['input']>;
};

/** Autogenerated input type of CreateLogo */
export type CreateLogoInput = {
  /** Is logo approved by designer */
  approvedByDesigner?: InputMaybe<Scalars['Boolean']['input']>;
  /** Catalog number to create the logo */
  catalogNumber?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email of the user to create the logo */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Logo image */
  image?: InputMaybe<Scalars['Upload']['input']>;
};

/** Autogenerated return type of CreateLogo. */
export type CreateLogoPayload = {
  __typename?: 'CreateLogoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Logo */
  logo?: Maybe<Logo>;
  /** Current user */
  user?: Maybe<User>;
};

/** Autogenerated input type of CreateMsTeamsPost */
export type CreateMsTeamsPostInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: MsTeamsPostInput;
};

/** Autogenerated return type of CreateMsTeamsPost. */
export type CreateMsTeamsPostPayload = {
  __typename?: 'CreateMsTeamsPostPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  msTeamsPost?: Maybe<MsTeamsPost>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateMsTeamsTenant */
export type CreateMsTeamsTenantInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Autogenerated return type of CreateMsTeamsTenant. */
export type CreateMsTeamsTenantPayload = {
  __typename?: 'CreateMsTeamsTenantPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  msTeamsTenant?: Maybe<MsTeamsTenant>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of Create. */
export type CreatePayload = {
  __typename?: 'CreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors: Array<Scalars['String']['output']>;
  /** Store */
  store?: Maybe<Store>;
  workspaceJoinRequest?: Maybe<WorkspaceJoinRequest>;
};

/** Autogenerated input type of CreatePost */
export type CreatePostInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: PostInput;
  programId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreatePost. */
export type CreatePostPayload = {
  __typename?: 'CreatePostPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  post?: Maybe<Post>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreatePostReaction */
export type CreatePostReactionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['ID']['input'];
  shortCode: Scalars['String']['input'];
};

/** Autogenerated return type of CreatePostReaction. */
export type CreatePostReactionPayload = {
  __typename?: 'CreatePostReactionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  postReaction?: Maybe<PostReaction>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateProgram */
export type CreateProgramInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  program?: InputMaybe<ProgramInput>;
};

/** Autogenerated input type of CreateProgramOrder */
export type CreateProgramOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

/** Autogenerated return type of CreateProgramOrder. */
export type CreateProgramOrderPayload = {
  __typename?: 'CreateProgramOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  programOrder?: Maybe<ProgramOrder>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CreateProgram. */
export type CreateProgramPayload = {
  __typename?: 'CreateProgramPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  program?: Maybe<Program>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateRequestMockup */
export type CreateRequestMockupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Request mockup attributes */
  requestMockupData: Array<RequestMockupCatalogInput>;
};

/** Autogenerated return type of CreateRequestMockup. */
export type CreateRequestMockupPayload = {
  __typename?: 'CreateRequestMockupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of CreateSetupIntentUserCreditCard */
export type CreateSetupIntentUserCreditCardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateSetupIntentUserCreditCard. */
export type CreateSetupIntentUserCreditCardPayload = {
  __typename?: 'CreateSetupIntentUserCreditCardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateShop */
export type CreateShopInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Find existing bundle or not */
  findExistingBundle?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CreateShop. */
export type CreateShopPayload = {
  __typename?: 'CreateShopPayload';
  /** Bundle */
  bundleShop?: Maybe<Store>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateSlackPost */
export type CreateSlackPostInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: SlackPostInput;
};

/** Autogenerated return type of CreateSlackPost. */
export type CreateSlackPostPayload = {
  __typename?: 'CreateSlackPostPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  slackPost?: Maybe<SlackPost>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateTeam */
export type CreateTeamInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  markComplete?: InputMaybe<Scalars['Boolean']['input']>;
  team: TeamInput;
};

/** Autogenerated return type of CreateTeam. */
export type CreateTeamPayload = {
  __typename?: 'CreateTeamPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
  team?: Maybe<Team>;
};

/** Autogenerated input type of CreateUserAddress */
export type CreateUserAddressInput = {
  address: AddressInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CreateUserAddress. */
export type CreateUserAddressPayload = {
  __typename?: 'CreateUserAddressPayload';
  address?: Maybe<Address>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateUserContact */
export type CreateUserContactInput = {
  addressRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contact: ContactInput;
};

/** Autogenerated return type of CreateUserContact. */
export type CreateUserContactPayload = {
  __typename?: 'CreateUserContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateUserCreditCard */
export type CreateUserCreditCardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  creditCard: CreditCardInput;
};

/** Autogenerated return type of CreateUserCreditCard. */
export type CreateUserCreditCardPayload = {
  __typename?: 'CreateUserCreditCardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  creditCard?: Maybe<CreditCard>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateWarehouseProduct */
export type CreateWarehouseProductInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ColorDataInputType */
  colorData?: InputMaybe<OptionTypeValueHashInput>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Images */
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** Name */
  name: Scalars['String']['input'];
  /** Sell Price */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Quantity */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Size Data */
  sizeData?: InputMaybe<SizeDataInput>;
  /** Taxon Ids */
  taxonIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Tracking number */
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  /** WarehouseProductMetaData */
  warehouseProductMetadataAttributes?: InputMaybe<WarehouseProductMetadataInput>;
};

/** Autogenerated return type of CreateWarehouseProduct. */
export type CreateWarehouseProductPayload = {
  __typename?: 'CreateWarehouseProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Warehouse Product */
  warehouseProduct?: Maybe<Product>;
};

export type CreditCard = {
  __typename?: 'CreditCard';
  ccType?: Maybe<Scalars['String']['output']>;
  default: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastDigits?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

/** Input type for credit card */
export type CreditCardInput = {
  apiMethod?: InputMaybe<ApiMethodEnum>;
  ccType?: InputMaybe<Scalars['String']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  gatewayPaymentProfileId?: InputMaybe<Scalars['String']['input']>;
  lastDigits?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type CrmCampaign = {
  __typename?: 'CrmCampaign';
  active: Scalars['Boolean']['output'];
  endDate?: Maybe<Scalars['DateType']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateType']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CrmCampaignStatus = {
  __typename?: 'CrmCampaignStatus';
  active?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CrmList = {
  __typename?: 'CrmList';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  lastSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Currency = {
  __typename?: 'Currency';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

/** Autogenerated input type of CurrentUserContactUpdate */
export type CurrentUserContactUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  integrationNotification: Scalars['Boolean']['input'];
  programId: Scalars['ID']['input'];
};

/** Autogenerated return type of CurrentUserContactUpdate. */
export type CurrentUserContactUpdatePayload = {
  __typename?: 'CurrentUserContactUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CustomContactField = {
  __typename?: 'CustomContactField';
  deletable: Scalars['Boolean']['output'];
  editable: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: CustomContactFieldTypes;
};

export type CustomContactFieldInput = {
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: CustomContactFieldTypes;
};

export enum CustomContactFieldTypes {
  Date = 'date',
  Text = 'text'
}

/** Custom Domain */
export type CustomDomain = {
  __typename?: 'CustomDomain';
  /** Domain */
  domain?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Active Shops */
  stores?: Maybe<Array<Store>>;
  /** Url */
  url?: Maybe<Scalars['String']['output']>;
};


/** Custom Domain */
export type CustomDomainStoresArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchIndexed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of CustomizeFeaturedSectionMenu */
export type CustomizeFeaturedSectionMenuInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Country iso */
  country: Scalars['String']['input'];
  /** Existing Customized Menu Id */
  menuId?: InputMaybe<Scalars['ID']['input']>;
  /** Store number to identify store */
  number: Scalars['String']['input'];
  /** Ordered Product Catalog Ids */
  orderedProductCatalogIds?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** Ordered Product Ids */
  orderedProductIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of CustomizeFeaturedSectionMenu. */
export type CustomizeFeaturedSectionMenuPayload = {
  __typename?: 'CustomizeFeaturedSectionMenuPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Response */
  response: Response;
};

/** Autogenerated input type of CustomizeProduct */
export type CustomizeProductInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Array of theme IDs that need to be deleted */
  deletedThemeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Preview color */
  previewColor?: InputMaybe<Scalars['String']['input']>;
  /** Preview size */
  previewSize?: InputMaybe<Scalars['String']['input']>;
  /** Data for print image including canvas json and ct_ids */
  printImageData?: InputMaybe<Array<PrintImageInput>>;
  /** Product catalog slug */
  slug: Scalars['String']['input'];
};

/** Autogenerated return type of CustomizeProduct. */
export type CustomizeProductPayload = {
  __typename?: 'CustomizeProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Customize product response */
  response?: Maybe<Response>;
  /** Current user */
  user?: Maybe<User>;
};

/** Customizer Template Type */
export type CustomizerTemplate = {
  __typename?: 'CustomizerTemplate';
  /** Base Image */
  baseImage?: Maybe<Scalars['Attachment']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Inner Canvas JSON ID */
  innerCanvasJsonId?: Maybe<Scalars['ID']['output']>;
  /** Mockup Associated with the customizer template */
  mockupId?: Maybe<Scalars['ID']['output']>;
  /** Name */
  name: Scalars['String']['output'];
  /** Preview Image */
  previewImage?: Maybe<Scalars['Attachment']['output']>;
};

export type CycleOption = {
  __typename?: 'CycleOption';
  /** Whether this is the default cycle option */
  default: Scalars['Boolean']['output'];
  /** Human readable name for the cycle option */
  displayName: Scalars['String']['output'];
  /** End date of the cycle */
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Name of the cycle filter */
  filterName: Scalars['String']['output'];
  /** Start date of the cycle */
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type DateOffset = {
  __typename?: 'DateOffset';
  dateType?: Maybe<Scalars['String']['output']>;
  dateUnit?: Maybe<Scalars['String']['output']>;
  dateValue?: Maybe<Scalars['Int']['output']>;
  excludeWeekends?: Maybe<Scalars['Boolean']['output']>;
  kind: DateOffsetEnum;
};

/** Valid types for date_offset */
export enum DateOffsetEnum {
  Absolute = 'absolute',
  Relative = 'relative'
}

export type DateOffsetInput = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  dateType?: InputMaybe<Scalars['String']['input']>;
  dateUnit?: InputMaybe<Scalars['String']['input']>;
  dateValue?: InputMaybe<Scalars['Int']['input']>;
  excludeWeekends?: InputMaybe<Scalars['Boolean']['input']>;
  kind: DateOffsetEnum;
};

/** Autogenerated input type of DeactivateCampaign */
export type DeactivateCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
};

/** Autogenerated return type of DeactivateCampaign. */
export type DeactivateCampaignPayload = {
  __typename?: 'DeactivateCampaignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeactivateWorkspaceUser */
export type DeactivateWorkspaceUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  workspaceUserId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeactivateWorkspaceUser. */
export type DeactivateWorkspaceUserPayload = {
  __typename?: 'DeactivateWorkspaceUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  serviceStatuses?: Maybe<Array<ServiceStatus>>;
  success: Scalars['Boolean']['output'];
  workspaceUser?: Maybe<WorkspaceUser>;
};

/** User who deactivated, or a display string when not a User */
export type DeactivatedBy = DeactivatedByString | User;

/** Display string for who deactivated (when not a User object) */
export type DeactivatedByString = {
  __typename?: 'DeactivatedByString';
  /** Display name or identifier of who deactivated */
  value: Scalars['String']['output'];
};

export type DeactivatedWorkspaceUsersList = {
  __typename?: 'DeactivatedWorkspaceUsersList';
  meta: PaginationMetadata;
  workspaceUsers: Array<WorkspaceUser>;
};

/** Autogenerated input type of DeclineTeamInvitation */
export type DeclineTeamInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['ID']['input'];
};

/** Autogenerated return type of DeclineTeamInvitation. */
export type DeclineTeamInvitationPayload = {
  __typename?: 'DeclineTeamInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteAsset */
export type DeleteAssetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The number of the asset to delete */
  number: Scalars['String']['input'];
};

/** Autogenerated return type of DeleteAsset. */
export type DeleteAssetPayload = {
  __typename?: 'DeleteAssetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the asset was deleted successfully */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteCampaign */
export type DeleteCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
};

/** Autogenerated return type of DeleteCampaign. */
export type DeleteCampaignPayload = {
  __typename?: 'DeleteCampaignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteContactFilterView */
export type DeleteContactFilterViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteContactFilterView. */
export type DeleteContactFilterViewPayload = {
  __typename?: 'DeleteContactFilterViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeletePost */
export type DeletePostInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeletePost. */
export type DeletePostPayload = {
  __typename?: 'DeletePostPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeletePostReaction */
export type DeletePostReactionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  postReactionId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeletePostReaction. */
export type DeletePostReactionPayload = {
  __typename?: 'DeletePostReactionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteProfileImage */
export type DeleteProfileImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteProfileImage. */
export type DeleteProfileImagePayload = {
  __typename?: 'DeleteProfileImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteProgram */
export type DeleteProgramInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteProgram. */
export type DeleteProgramPayload = {
  __typename?: 'DeleteProgramPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteShop */
export type DeleteShopInput = {
  /** Bundle Shop Number to delete */
  bundleShopNumber: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteShop. */
export type DeleteShopPayload = {
  __typename?: 'DeleteShopPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Response to delete from bundle */
  response?: Maybe<Response>;
};

/** Autogenerated input type of DeleteUserAddress */
export type DeleteUserAddressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of DeleteUserAddress. */
export type DeleteUserAddressPayload = {
  __typename?: 'DeleteUserAddressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteUserContact */
export type DeleteUserContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteUserContact. */
export type DeleteUserContactPayload = {
  __typename?: 'DeleteUserContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteUserContactProvider */
export type DeleteUserContactProviderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

/** Autogenerated return type of DeleteUserContactProvider. */
export type DeleteUserContactProviderPayload = {
  __typename?: 'DeleteUserContactProviderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteUserCreditCard */
export type DeleteUserCreditCardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteUserCreditCard. */
export type DeleteUserCreditCardPayload = {
  __typename?: 'DeleteUserCreditCardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DestroyDigitalAsset */
export type DestroyDigitalAssetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Digital Asset id */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyDigitalAsset. */
export type DestroyDigitalAssetPayload = {
  __typename?: 'DestroyDigitalAssetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Digital Asset */
  digitalAsset?: Maybe<DigitalAsset>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

export type DigitalAsset = {
  __typename?: 'DigitalAsset';
  /** Is approved by designer */
  approvedByDesigner: Scalars['Boolean']['output'];
  /** Content type of attachment */
  attachmentContentType?: Maybe<Scalars['String']['output']>;
  /** File name of attachment */
  attachmentFileName?: Maybe<Scalars['String']['output']>;
  /** File size of attachment */
  attachmentFileSize?: Maybe<Scalars['String']['output']>;
  /** Height of attachment */
  attachmentHeight?: Maybe<Scalars['Int']['output']>;
  /** Updated time of attachment */
  attachmentUpdatedAt?: Maybe<Scalars['Int']['output']>;
  /** Width of attachment */
  attachmentWidth?: Maybe<Scalars['Int']['output']>;
  /** Created at */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Creator of asset */
  creator?: Maybe<User>;
  /** Design guidelines */
  designGuidelines?: Maybe<DigitalAsset>;
  /** Download url for the library asset */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** Estimated print quality */
  estimatedPrintQuality?: Maybe<Scalars['String']['output']>;
  /** extension of file */
  extension?: Maybe<Scalars['String']['output']>;
  /** Folder id of attachment */
  folderId?: Maybe<Scalars['Int']['output']>;
  /** id */
  id: Scalars['ID']['output'];
  /** Kind of asset */
  kind?: Maybe<Scalars['String']['output']>;
  /** Name of asset */
  name?: Maybe<Scalars['String']['output']>;
  /** Notes of asset */
  notes?: Maybe<Scalars['String']['output']>;
  /** Identification Number of asset */
  number?: Maybe<Scalars['String']['output']>;
  /** Position of attachment */
  position?: Maybe<Scalars['Int']['output']>;
  /** Private metadata */
  privateMetadata?: Maybe<Scalars['JSON']['output']>;
  /** Public metadata */
  publicMetadata?: Maybe<Scalars['JSON']['output']>;
  /** Library Asset Thumbnail url */
  thumbnailUrl?: Maybe<Scalars['Attachment']['output']>;
  /** Image url */
  url?: Maybe<Scalars['Attachment']['output']>;
  /** Is user authorized */
  userAuthorized: Scalars['Boolean']['output'];
};


export type DigitalAssetDownloadUrlArgs = {
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for DigitalAsset. */
export type DigitalAssetConnection = {
  __typename?: 'DigitalAssetConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DigitalAssetEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DigitalAsset>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DigitalAssetEdge = {
  __typename?: 'DigitalAssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DigitalAsset>;
};

/** Autogenerated input type of DisableUserWalletAutoTopUp */
export type DisableUserWalletAutoTopUpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DisableUserWalletAutoTopUp. */
export type DisableUserWalletAutoTopUpPayload = {
  __typename?: 'DisableUserWalletAutoTopUpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of DismissWidget */
export type DismissWidgetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Widget title/key to dismiss */
  widgetTitle: Scalars['String']['input'];
};

/** Autogenerated return type of DismissWidget. */
export type DismissWidgetPayload = {
  __typename?: 'DismissWidgetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  widgetState?: Maybe<WidgetState>;
};

/** display currency */
export type DisplayCurrency = {
  __typename?: 'DisplayCurrency';
  /** display currency key */
  currencyKey?: Maybe<Scalars['String']['output']>;
  /** display currency external id */
  externalId?: Maybe<Scalars['String']['output']>;
  /** display currency external source */
  externalSource?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** display currency name */
  name?: Maybe<Scalars['String']['output']>;
  /** display currency symbol */
  symbol?: Maybe<Scalars['String']['output']>;
};

export type Domain = {
  __typename?: 'Domain';
  name: Scalars['String']['output'];
};

/** Product selected in a draft automated mockups catalog with selected colors and CTs */
export type DraftAutomatedCatalogProduct = {
  __typename?: 'DraftAutomatedCatalogProduct';
  /** Countries the product is available in */
  availableCountries?: Maybe<Array<Country>>;
  /** Available globally */
  availableGlobally: Scalars['Boolean']['output'];
  /** Brand */
  brand?: Maybe<Brand>;
  /** Product ID */
  id: Scalars['ID']['output'];
  /** Product images */
  images?: Maybe<Array<Scalars['Attachment']['output']>>;
  /** Product name */
  name?: Maybe<Scalars['String']['output']>;
  /** Product price in requested currency */
  prices?: Maybe<Array<Scalars['Float']['output']>>;
  /** User-selected color option values (from catalog metadata) */
  selectedColorOptions: Array<OptionValue>;
  /** Selected colors with their customizer template for the catalog store */
  selectedColorsWithTemplate: Array<DraftSelectedColor>;
  /** Product slug */
  slug?: Maybe<Scalars['String']['output']>;
};


/** Product selected in a draft automated mockups catalog with selected colors and CTs */
export type DraftAutomatedCatalogProductPricesArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
};

/** Selected product with optional color mapping for draft automated catalog */
export type DraftAutomatedCatalogSelectedProductInput = {
  /** Color option value IDs */
  colorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Product ID */
  productId: Scalars['Int']['input'];
};

/** A selected color option and its customizer template for a draft catalog product */
export type DraftSelectedColor = {
  __typename?: 'DraftSelectedColor';
  /** Customizer template images for color */
  images?: Maybe<Array<Scalars['Attachment']['output']>>;
  /** The selected color option value */
  optionValue: OptionValue;
};

/** Dummy Banner */
export type DummyBanner = {
  __typename?: 'DummyBanner';
  /** Cloudinary Generated URL */
  url: Scalars['String']['output'];
};

/** Dummy Store */
export type DummyStore = {
  __typename?: 'DummyStore';
  /** Banner */
  banner?: Maybe<DigitalAsset>;
  /** Catalog Logo ID */
  catalogLogoId?: Maybe<Scalars['ID']['output']>;
  /** Catalog Logo URL */
  catalogLogoUrl?: Maybe<Scalars['String']['output']>;
  /** Code */
  code?: Maybe<Scalars['String']['output']>;
  /** Create automated catalog or not */
  createAutomatedCatalog?: Maybe<Scalars['Boolean']['output']>;
  /** Currency */
  currency?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Logo */
  logo?: Maybe<Scalars['Attachment']['output']>;
  /** max price cap for products in priceless shop */
  maxPrice?: Maybe<Scalars['Float']['output']>;
  /** min price cap for products in priceless shop */
  minPrice?: Maybe<Scalars['Float']['output']>;
  /** Name */
  name: Scalars['String']['output'];
  /** Number */
  number: Scalars['String']['output'];
  /** Parent Store ID */
  parentId: Scalars['Int']['output'];
  /** Taxon Ids */
  taxonIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Top Banner */
  topBanner?: Maybe<Scalars['Attachment']['output']>;
};

export type DynamicOrderSummary = {
  __typename?: 'DynamicOrderSummary';
  creditsUsed?: Maybe<Scalars['Int']['output']>;
  /** Whether a payment is required */
  paymentRequired: Scalars['Boolean']['output'];
  /** Program available credits */
  programAvailableCredits: Scalars['Int']['output'];
  /** Program order if one needs to be created */
  programOrder?: Maybe<ProgramOrder>;
  /** Refund amount when removed_user_credits > users_allowance */
  refundAmount?: Maybe<Scalars['Float']['output']>;
  /** Removed user credits */
  removedUserCredits: Scalars['Int']['output'];
  totalPointsPurchased?: Maybe<Scalars['Int']['output']>;
  /** Number of users added */
  usersAdded: Scalars['Int']['output'];
  /** Number of users removed */
  usersRemoved: Scalars['Int']['output'];
};

/** Autogenerated input type of EditCatalog */
export type EditCatalogInput = {
  /** select_all/deselect_all/only_custom/select_only_filter */
  action?: InputMaybe<Scalars['String']['input']>;
  /** Swag Store Product Ids need to be activated */
  activateStoreProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Swag Store Product Ids need to be deactivated */
  deactivateStoreProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Non Swag Product Ids need to be disabled */
  disabledProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Taxon Ids need to be activated */
  enableTaxonIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Non Swag Product Ids need to be enabled */
  enabledProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters will be passed as args to stadium search */
  filters?: InputMaybe<Scalars['JSON']['input']>;
  /** Store number to identify store */
  number: Scalars['String']['input'];
};

/** Autogenerated return type of EditCatalog. */
export type EditCatalogPayload = {
  __typename?: 'EditCatalogPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Response */
  response: Response;
};

/** Autogenerated input type of EditLogo */
export type EditLogoInput = {
  /** Is logo approved by designer */
  approvedByDesigner?: InputMaybe<Scalars['Boolean']['input']>;
  /** Catalog Number */
  catalogNumber?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Existing logo id */
  logoId?: InputMaybe<Scalars['String']['input']>;
  /** Logo files */
  logos?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** User authorized to use logos */
  logosAuthorized: Scalars['Boolean']['input'];
  /** Whether to save it as a new catalog */
  saveAsNew?: InputMaybe<Scalars['Boolean']['input']>;
  /** Store number */
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EditLogo. */
export type EditLogoPayload = {
  __typename?: 'EditLogoPayload';
  /** Catalog */
  catalogs?: Maybe<Array<Catalog>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Scalars['String']['output']>;
  /** Current user */
  user?: Maybe<User>;
};

/** Autogenerated input type of EditStoreAdminAccess */
export type EditStoreAdminAccessInput = {
  /** Access level of user */
  access: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email of user */
  email: Scalars['String']['input'];
  /** Store code to identify store */
  number: Scalars['String']['input'];
};

/** Autogenerated return type of EditStoreAdminAccess. */
export type EditStoreAdminAccessPayload = {
  __typename?: 'EditStoreAdminAccessPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Response */
  response: Response;
};

/** Autogenerated input type of EnableWorkspace */
export type EnableWorkspaceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EnableWorkspace. */
export type EnableWorkspacePayload = {
  __typename?: 'EnableWorkspacePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  workspace?: Maybe<Workspace>;
};

/** Entity */
export type Entity = Brand | Catalog | DigitalAsset | Logo | Product | Store | Vendor;

/** Autogenerated input type of ExpireDraftWarehouseProduct */
export type ExpireDraftWarehouseProductInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ExpireDraftWarehouseProduct. */
export type ExpireDraftWarehouseProductPayload = {
  __typename?: 'ExpireDraftWarehouseProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Warehouse Product */
  product?: Maybe<Product>;
};

/** Count of eshops filters tabs */
export type FiltersCount = {
  __typename?: 'FiltersCount';
  /** All */
  all?: Maybe<Scalars['Int']['output']>;
  /** Archived */
  archived?: Maybe<Scalars['Int']['output']>;
  /** Incomplete */
  incomplete?: Maybe<Scalars['Int']['output']>;
  /** Live */
  live?: Maybe<Scalars['Int']['output']>;
};

export type FreeProgramResponse = {
  __typename?: 'FreeProgramResponse';
  program?: Maybe<Program>;
  userCount?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of GeneratePreview */
export type GeneratePreviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Data for print image and ct_ids */
  printImageData?: InputMaybe<Array<PrintImageInput>>;
  /** Product catalog slug */
  slug: Scalars['String']['input'];
};

/** Autogenerated return type of GeneratePreview. */
export type GeneratePreviewPayload = {
  __typename?: 'GeneratePreviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Preview request number */
  previewRequestNumber?: Maybe<Scalars['String']['output']>;
};

export type Gift = {
  __typename?: 'Gift';
  date: Scalars['DateType']['output'];
  recipientsCount: Scalars['Int']['output'];
  recipientsName?: Maybe<Scalars['String']['output']>;
};

/** Valid types for campaign gift types */
export enum GiftTypeEnum {
  Kits = 'kits',
  Shop = 'shop',
  Snackmagic = 'snackmagic',
  Wallet = 'wallet'
}

/** Hashtags */
export type Hashtag = {
  __typename?: 'Hashtag';
  /** Is a company value */
  companyValue: Scalars['Boolean']['output'];
  /** Name of Hashtag */
  name: Scalars['String']['output'];
  /** Count of Hashtag */
  taggingsCount: Scalars['Int']['output'];
};

/** Autogenerated input type of ImportContactEmails */
export type ImportContactEmailsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emails: Array<Scalars['String']['input']>;
  role?: InputMaybe<RoleTypes>;
};

/** Autogenerated return type of ImportContactEmails. */
export type ImportContactEmailsPayload = {
  __typename?: 'ImportContactEmailsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
  userContactIds?: Maybe<Array<Scalars['ID']['output']>>;
  workspace?: Maybe<Workspace>;
};

export type ImportTask = {
  __typename?: 'ImportTask';
  completedAt?: Maybe<Scalars['DateType']['output']>;
  createdAt?: Maybe<Scalars['DateType']['output']>;
  erroredAt?: Maybe<Scalars['DateType']['output']>;
  errorsCount?: Maybe<Scalars['Int']['output']>;
  inputFileUrl?: Maybe<Scalars['String']['output']>;
  mergeDuplicates?: Maybe<Scalars['Boolean']['output']>;
  meta?: Maybe<Scalars['Hash']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  outputFileUrl?: Maybe<Scalars['String']['output']>;
  rolesCount?: Maybe<Scalars['Hash']['output']>;
  startedAt?: Maybe<Scalars['DateType']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateType']['output']>;
  uuid: Scalars['String']['output'];
};

/** Autogenerated input type of ImportTeamInvitations */
export type ImportTeamInvitationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  mergeDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['ID']['input'];
};

/** Autogenerated return type of ImportTeamInvitations. */
export type ImportTeamInvitationsPayload = {
  __typename?: 'ImportTeamInvitationsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
  task?: Maybe<ImportTask>;
};

/** Autogenerated input type of ImportUserContacts */
export type ImportUserContactsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  mergeDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  preferences?: InputMaybe<Scalars['Hash']['input']>;
  role?: InputMaybe<RoleTypes>;
};

/** Autogenerated return type of ImportUserContacts. */
export type ImportUserContactsPayload = {
  __typename?: 'ImportUserContactsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
  task?: Maybe<ImportTask>;
  workspace?: Maybe<Workspace>;
};

/** Autogenerated input type of InstallSlackApp */
export type InstallSlackAppInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  team: SlackTeamInput;
  user: SlackUserInput;
};

/** Autogenerated return type of InstallSlackApp. */
export type InstallSlackAppPayload = {
  __typename?: 'InstallSlackAppPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type Integration = {
  __typename?: 'Integration';
  category: IntegrationCategoryTypes;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
};

export enum IntegrationCategoryTypes {
  Ats = 'ats',
  Crm = 'crm',
  Hris = 'hris'
}

export type Invitation = {
  __typename?: 'Invitation';
  /** Whether the invitation is active or not */
  active: Scalars['Boolean']['output'];
  /** Roles that can be assigned to this team member based on their workspace role */
  allowedRoles: Array<Scalars['String']['output']>;
  approvalRequired: Scalars['Boolean']['output'];
  /** Whether the associated workspace user is deactivated */
  deactivated: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitationToken?: Maybe<Scalars['String']['output']>;
  invitedBy?: Maybe<User>;
  lastName?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  status: Scalars['String']['output'];
  team: Team;
  teamOwner: Scalars['Boolean']['output'];
  totalAllocatedBalance?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<User>;
  walletBalance?: Maybe<Scalars['Float']['output']>;
  /** User role in the workspace */
  workspaceUserRole?: Maybe<Scalars['String']['output']>;
};

/** Input type for invitation */
export type InvitationInput = {
  accept: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};

/** Autogenerated input type of InviteContacts */
export type InviteContactsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  excludeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['Hash']['input']>;
  includeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  orderCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  preApproveAllContacts?: InputMaybe<Scalars['Boolean']['input']>;
  preApproveExcludeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  preApproveIncludeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  selectAllContacts?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
  surpriseOrder?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of InviteContacts. */
export type InviteContactsPayload = {
  __typename?: 'InviteContactsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  invalidEmails?: Maybe<Array<Scalars['String']['output']>>;
  payableCount?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
  validEmails?: Maybe<Array<Scalars['String']['output']>>;
};

export type JobInterviewStage = {
  __typename?: 'JobInterviewStage';
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Lead = {
  __typename?: 'Lead';
  /** ID */
  id: Scalars['ID']['output'];
  /** Kind */
  kind?: Maybe<Scalars['String']['output']>;
  /** Lead variants */
  leadVariants?: Maybe<Array<LeadVariant>>;
  /** Lead Number */
  number?: Maybe<Scalars['String']['output']>;
};

export type LeadVariant = {
  __typename?: 'LeadVariant';
  /** ID */
  id: Scalars['ID']['output'];
  /** Lead Id */
  leadId?: Maybe<Scalars['Int']['output']>;
  /** Quantity */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** Variant */
  variant?: Maybe<Variant>;
  /** Variant Id */
  variantId?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of LeaveTeam */
export type LeaveTeamInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['ID']['input'];
};

/** Autogenerated return type of LeaveTeam. */
export type LeaveTeamPayload = {
  __typename?: 'LeaveTeamPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
  team?: Maybe<Team>;
};

/** Autogenerated input type of LinkedShareQuest */
export type LinkedShareQuestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: QuestInput;
};

/** Autogenerated return type of LinkedShareQuest. */
export type LinkedShareQuestPayload = {
  __typename?: 'LinkedShareQuestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
};

export type List = {
  __typename?: 'List';
  aggregations?: Maybe<Array<Scalars['Hash']['output']>>;
  campaigns?: Maybe<Array<Campaign>>;
  contacts?: Maybe<Array<Contact>>;
  incompleteLockedContactsPresent?: Maybe<Scalars['Boolean']['output']>;
  meta: ListMeta;
};

export type ListMeta = {
  __typename?: 'ListMeta';
  currentPage?: Maybe<Scalars['Int']['output']>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  perPage?: Maybe<Scalars['Int']['output']>;
  prevCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type Logo = {
  __typename?: 'Logo';
  /** Is approved by designer */
  approvedByDesigner: Scalars['Boolean']['output'];
  /** digital asset of logo */
  digitalAsset?: Maybe<DigitalAsset>;
  /** Quality of logo */
  estimatedPrintQuality?: Maybe<Scalars['String']['output']>;
  /** extension of file */
  extension?: Maybe<Scalars['String']['output']>;
  /** File size in bytes */
  fileSize?: Maybe<Scalars['String']['output']>;
  /** File name */
  filename?: Maybe<Scalars['String']['output']>;
  /** id */
  id: Scalars['ID']['output'];
  /** Image url */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** content type of logo */
  type?: Maybe<Scalars['String']['output']>;
  /** url of logo */
  url?: Maybe<Scalars['Attachment']['output']>;
};

/** Autogenerated input type of ManageCatalog */
export type ManageCatalogInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Design guideline */
  designGuideline?: InputMaybe<Scalars['Upload']['input']>;
  /** Update form states for store */
  formStates?: InputMaybe<Scalars['JSON']['input']>;
  /** Catalog ID */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Catalog kind */
  kind?: InputMaybe<Scalars['String']['input']>;
  /** Primary Logo */
  primaryLogo: Scalars['Upload']['input'];
  /** Secondary Logos */
  secondaryLogos?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** Store Number */
  storeNumber: Scalars['String']['input'];
  /** comment on update logo */
  userNotes?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ManageCatalog. */
export type ManageCatalogPayload = {
  __typename?: 'ManageCatalogPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Create/Update catalog response */
  response?: Maybe<Response>;
};

/** Autogenerated input type of ManageCatalogProducts */
export type ManageCatalogProductsInput = {
  /** Catalog number to add to store */
  catalogNumber?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Enable a product */
  enable: Scalars['Boolean']['input'];
  /** Store number to identify store */
  number: Scalars['String']['input'];
  /** Swag Store Product Ids need to be deactivated */
  storeProductId: Scalars['String']['input'];
};

/** Autogenerated return type of ManageCatalogProducts. */
export type ManageCatalogProductsPayload = {
  __typename?: 'ManageCatalogProductsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Response */
  response: Response;
};

/** Autogenerated input type of ManageCatalogVariants */
export type ManageCatalogVariantsInput = {
  /** Swag Variant Ids need to be activated */
  activateStoreVariantsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Broken product */
  broken?: InputMaybe<Scalars['Boolean']['input']>;
  /** Catalog Number */
  catalogNumber: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Swag Variant Ids need to be deactivated */
  deactivateStoreVariantsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Store number to identify store */
  number: Scalars['String']['input'];
  /** Store Product */
  storeProductId: Scalars['String']['input'];
};

/** Autogenerated return type of ManageCatalogVariants. */
export type ManageCatalogVariantsPayload = {
  __typename?: 'ManageCatalogVariantsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Response */
  response: Response;
};

/** Autogenerated input type of ManageDraftAutomatedCatalog */
export type ManageDraftAutomatedCatalogInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Color Group IDs */
  colorGroupIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Catalog ID for update */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Catalog Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Show draft automated mockups */
  showDraftAutomatedMockupBanner?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of ManageDraftAutomatedCatalog. */
export type ManageDraftAutomatedCatalogPayload = {
  __typename?: 'ManageDraftAutomatedCatalogPayload';
  /** Created/Updated draft automated catalog */
  catalog?: Maybe<Catalog>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of ManagePastel */
export type ManagePastelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create pastel url */
  create?: InputMaybe<Scalars['Boolean']['input']>;
  /** Store number, to identify store */
  number: Scalars['String']['input'];
  /** Pastel canvas id */
  pastelCanvasId?: InputMaybe<Scalars['String']['input']>;
  /** Pastel catalog url */
  pastelCatalogUrl?: InputMaybe<Scalars['String']['input']>;
  /** Pastel url */
  pastelUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ManagePastel. */
export type ManagePastelPayload = {
  __typename?: 'ManagePastelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Store */
  store?: Maybe<Store>;
};

/** Autogenerated input type of ManageProductAndVariants */
export type ManageProductAndVariantsInput = {
  /** Swag Variant Ids need to be activated */
  activateStoreVariantsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Catalog number to add to store */
  catalogNumber: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Swag Variant Ids need to be deactivated */
  deactivateStoreVariantsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Enable a product */
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Store Product Ids need to be deactivated */
  storeProductId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ManageProductAndVariants. */
export type ManageProductAndVariantsPayload = {
  __typename?: 'ManageProductAndVariantsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Create/Update catalog response */
  response?: Maybe<Response>;
};

/** Autogenerated input type of ManageTaxons */
export type ManageTaxonsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Taxon Ids need to be deactivated */
  disableTaxonIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Taxon Ids need to be activated */
  enableTaxonIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Store number, to identify store */
  number: Scalars['String']['input'];
};

/** Autogenerated return type of ManageTaxons. */
export type ManageTaxonsPayload = {
  __typename?: 'ManageTaxonsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Response */
  response: Response;
};

/** Marketing Category */
export type MarketingCategory = {
  __typename?: 'MarketingCategory';
  /** Category Description */
  description: Scalars['String']['output'];
  /** Category Enabled */
  enabled: Scalars['Boolean']['output'];
  /** ID */
  id: Scalars['ID']['output'];
  /** Category meta description */
  metaDescription?: Maybe<Scalars['String']['output']>;
  /** Category meta title */
  metaTitle?: Maybe<Scalars['String']['output']>;
  /** Category Name */
  name: Scalars['String']['output'];
  /** Category Position */
  position: Scalars['String']['output'];
  /** Category is restricted or not */
  restricted: Scalars['Boolean']['output'];
  /** Category Slug */
  slug: Scalars['String']['output'];
};

export type MasterCompany = {
  __typename?: 'MasterCompany';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Return images for master variant */
export type MasterImage = {
  __typename?: 'MasterImage';
  /** external id */
  catalogStoreExternalId?: Maybe<Scalars['ID']['output']>;
  /** Images */
  images?: Maybe<Array<Scalars['Attachment']['output']>>;
};

/** Medley Price */
export type MedleyPrice = {
  __typename?: 'MedleyPrice';
  /** Amount in Points */
  amount: Scalars['Int']['output'];
  /** Display Amount in Points */
  amountIn: Scalars['String']['output'];
  /** Display name */
  displayName: Scalars['String']['output'];
  /** Unique Identifier */
  id: Scalars['String']['output'];
};


/** Medley Price */
export type MedleyPriceAmountArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
};


/** Medley Price */
export type MedleyPriceAmountInArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
};

/** Memberships */
export type Membership = {
  __typename?: 'Membership';
  /** Custom Domain */
  customDomain: Scalars['Boolean']['output'];
  /** Custom Point Conversion */
  customPointConversion: Scalars['Boolean']['output'];
  /** User subscribed */
  subscribed: Scalars['Boolean']['output'];
  /** Whitelabel */
  whitelabel: Scalars['Boolean']['output'];
};

export type Mention = {
  __typename?: 'Mention';
  contactRemoved: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  programContact?: Maybe<ProgramContact>;
  recognitionPointsReceived: Scalars['Int']['output'];
  tagged: Scalars['Boolean']['output'];
  user: User;
};

/** Menu */
export type Menu = {
  __typename?: 'Menu';
  /** Count details of categories */
  categoriesCount?: Maybe<Scalars['Int']['output']>;
  /** Enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Locale */
  locale?: Maybe<Scalars['String']['output']>;
  /** Location */
  location?: Maybe<Scalars['String']['output']>;
  /** Menu Items */
  menuItems?: Maybe<Array<MenuItem>>;
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
  /** number of visible products */
  numberOfVisibleItems?: Maybe<Scalars['Int']['output']>;
  /** Count details of products */
  productsCount?: Maybe<Scalars['Int']['output']>;
  /** Show all products */
  showAll?: Maybe<Scalars['Boolean']['output']>;
  /** Show all shop products */
  showAllShopProducts?: Maybe<Scalars['Boolean']['output']>;
  /** Show catalog button */
  showCatalogButton?: Maybe<Scalars['Boolean']['output']>;
  /** Skip title humanization */
  skipTitleHumanization?: Maybe<Scalars['Boolean']['output']>;
  /** Store ID */
  storeId?: Maybe<Scalars['ID']['output']>;
  /** Count details of sub-categories */
  subCategoriesCount?: Maybe<Scalars['Int']['output']>;
};


/** Menu */
export type MenuCategoriesCountArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  globalZone?: InputMaybe<Scalars['Boolean']['input']>;
  intent?: InputMaybe<Scalars['String']['input']>;
  storeCode?: InputMaybe<Scalars['String']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** Menu */
export type MenuMenuItemsArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  forPriceless?: InputMaybe<Scalars['Boolean']['input']>;
  globalZone?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeDeactivatedProducts?: InputMaybe<Scalars['Boolean']['input']>;
  includeDisabledTaxons?: InputMaybe<Scalars['Boolean']['input']>;
  includeLockedSp?: InputMaybe<Scalars['Boolean']['input']>;
  intent?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['String']['input']>;
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  selectedItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  storeCode?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['String']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['String']['input']>;
  withOutOfStock?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Menu */
export type MenuProductsCountArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  globalZone?: InputMaybe<Scalars['Boolean']['input']>;
  intent?: InputMaybe<Scalars['String']['input']>;
  storeCode?: InputMaybe<Scalars['String']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** Menu */
export type MenuSubCategoriesCountArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  globalZone?: InputMaybe<Scalars['Boolean']['input']>;
  intent?: InputMaybe<Scalars['String']['input']>;
  storeCode?: InputMaybe<Scalars['String']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Menu Item */
export type MenuItem = {
  __typename?: 'MenuItem';
  /** Icon */
  attachment?: Maybe<Scalars['Attachment']['output']>;
  /** Icon */
  banner?: Maybe<Scalars['Attachment']['output']>;
  /** Rich Text Content */
  bottomContent?: Maybe<Scalars['String']['output']>;
  /** Catalogs linked with menu item */
  catalogs?: Maybe<Array<Catalog>>;
  /** Code */
  code?: Maybe<Scalars['String']['output']>;
  /** Country linked to resource */
  country?: Maybe<Country>;
  /** Depth */
  depth?: Maybe<Scalars['Int']['output']>;
  /** Description of Menu Item */
  description?: Maybe<Scalars['String']['output']>;
  /** Destination */
  destination?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Item Type */
  itemType?: Maybe<Scalars['String']['output']>;
  /** Left */
  lft?: Maybe<Scalars['Int']['output']>;
  /** Linked resource */
  linkedResource?: Maybe<MenuResource>;
  /** Linked resources */
  linkedResources?: Maybe<Array<MenuResource>>;
  /** Menu ID */
  menuId?: Maybe<Scalars['ID']['output']>;
  /** Whether linked taxon is enabled or not */
  menuItemEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Meta Description */
  metaDescription?: Maybe<Scalars['String']['output']>;
  /** Meta Title */
  metaTitle?: Maybe<Scalars['String']['output']>;
  /** Icon */
  mobileAppIcon?: Maybe<Scalars['Attachment']['output']>;
  /** Mobile Banner */
  mobileBanner?: Maybe<Scalars['Attachment']['output']>;
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
  /** New Window */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** Parent Code for URL */
  parentCode?: Maybe<Scalars['String']['output']>;
  /** Parent ID */
  parentId?: Maybe<Scalars['ID']['output']>;
  /** Portrait Image */
  portraitImage?: Maybe<Scalars['Attachment']['output']>;
  /** Products Image */
  productsImage?: Maybe<Scalars['Attachment']['output']>;
  /** Right */
  rgt?: Maybe<Scalars['Int']['output']>;
  /** SEO Open Graph Image */
  seoImage?: Maybe<Scalars['Attachment']['output']>;
  /** Subtitle */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Swag Banner */
  swagBannerAddable: Scalars['Boolean']['output'];
  /** Menu item is a theme collection */
  themeCollection: Scalars['Boolean']['output'];
  /** Theme Landscape Image */
  themeLandscapeImage?: Maybe<Scalars['Attachment']['output']>;
  /** Theme Portrait Image */
  themePortraitImage?: Maybe<Scalars['Attachment']['output']>;
  /** Thumbnail Image */
  thumbnailImage?: Maybe<Scalars['Attachment']['output']>;
  /** Rich Text Content */
  topContent?: Maybe<Scalars['String']['output']>;
  /** Last Update Date */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** Menu Item */
export type MenuItemAttachmentArgs = {
  height?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['String']['input']>;
};


/** Menu Item */
export type MenuItemLinkedResourcesArgs = {
  number?: InputMaybe<Scalars['String']['input']>;
  onlyEnabledTaxons?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Menu Item */
export type MenuItemMenuItemEnabledArgs = {
  number: Scalars['String']['input'];
};

/** objects which can be linked resource on menu item */
export type MenuResource = AttributeValue | Brand | MenuItem | Product | ProductType | Store | Taxon | Vendor;

/** Mock Up */
export type Mockup = {
  __typename?: 'Mockup';
  /** Automation coordinates to place logo on the image */
  automationPlacementCoords?: Maybe<Scalars['JSON']['output']>;
  /** Bleeding area coordinates for preview generation */
  bleedingAreaCoords?: Maybe<Scalars['JSON']['output']>;
  /** Cloudinary coordinates to place logo on the image */
  cloudinaryCoords?: Maybe<Scalars['JSON']['output']>;
  /** Conflicting placements */
  conflictingPlacements?: Maybe<Array<Scalars['String']['output']>>;
  /** Signifies which part of the product is being designed */
  fileType: Scalars['String']['output'];
  /** ID */
  id: Scalars['ID']['output'];
  /** Print area coordinates to print area on the base image */
  printAreaCoords?: Maybe<Scalars['JSON']['output']>;
  /** Printful coordinates to place logo inside the print area */
  printfulCoords?: Maybe<Scalars['JSON']['output']>;
  /** Quality multiplier */
  qualityMultiplier?: Maybe<Scalars['Float']['output']>;
  /** Whether to expand print image to print area for preview */
  showPrintAreaAsMockupPreview: Scalars['Boolean']['output'];
  /** Color hex codes for which the transparent base image applies */
  transparentBaseImageColors?: Maybe<Array<Scalars['String']['output']>>;
  /** URL for the transparent base image */
  transparentBaseImageUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ModifyUser */
export type ModifyUserInput = {
  /** Automated Catalog Banner Dismissed */
  automatedCatalogBannerDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Automated Catalog Footer Cart Guide Tour Viewed */
  automatedCatalogFooterCartGuideTourViewed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Automated Catalog Guide Tour Viewed */
  automatedCatalogGuideTourViewed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Automated Catalog Logo Drag Tooltip Viewed */
  automatedCatalogLogoDragTooltipViewed?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Customizer Guide Tour Completed */
  customizerGuideTourCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Marketing Announcement Viewed */
  marketingAnnouncementViewed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of ModifyUser. */
export type ModifyUserPayload = {
  __typename?: 'ModifyUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Success */
  success: Scalars['Boolean']['output'];
  /** User Object */
  user: User;
};

export type MostRecognizedUsers = {
  __typename?: 'MostRecognizedUsers';
  endDate?: Maybe<Scalars['DateType']['output']>;
  startDate?: Maybe<Scalars['DateType']['output']>;
  stats: Array<UserStat>;
};

export type MsTeamsChannel = {
  __typename?: 'MsTeamsChannel';
  conversationId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  program?: Maybe<Program>;
  serviceUrl: Scalars['String']['output'];
  teamAadGroupId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/** Input type for ms teams channel */
export type MsTeamsChannelInput = {
  conversationId: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  serviceUrl?: InputMaybe<Scalars['String']['input']>;
  teamAadGroupId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

export type MsTeamsMessageInput = {
  msTeamsId?: InputMaybe<Scalars['String']['input']>;
  msTeamsParentId?: InputMaybe<Scalars['String']['input']>;
};

export type MsTeamsPost = {
  __typename?: 'MsTeamsPost';
  amount?: Maybe<Scalars['Int']['output']>;
  companyValues?: Maybe<Array<Scalars['String']['output']>>;
  mentions?: Maybe<Array<Scalars['String']['output']>>;
  message?: Maybe<Scalars['String']['output']>;
  messageWithDisplayName?: Maybe<Scalars['String']['output']>;
  msTeamsChannelId?: Maybe<Scalars['String']['output']>;
  msTeamsConversationId?: Maybe<Scalars['String']['output']>;
  msTeamsServiceUrl?: Maybe<Scalars['String']['output']>;
  msTeamsTenantId?: Maybe<Scalars['String']['output']>;
  msTeamsUserAadObjectId?: Maybe<Scalars['String']['output']>;
  msTeamsUserId?: Maybe<Scalars['String']['output']>;
  postId?: Maybe<Scalars['Int']['output']>;
  programId?: Maybe<Scalars['Int']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  recipients?: Maybe<Array<Scalars['String']['output']>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tagsStr?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type MsTeamsPostInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  channelConversationId?: InputMaybe<Scalars['String']['input']>;
  companyValues?: InputMaybe<Array<Scalars['String']['input']>>;
  conversationType: Scalars['String']['input'];
  mentions?: InputMaybe<Array<Scalars['String']['input']>>;
  message?: InputMaybe<Scalars['String']['input']>;
  msTeamsChannelId: Scalars['String']['input'];
  msTeamsConversationId: Scalars['String']['input'];
  msTeamsMessageAttributes?: InputMaybe<MsTeamsMessageInput>;
  msTeamsServiceUrl: Scalars['String']['input'];
  msTeamsTenantId: Scalars['String']['input'];
  msTeamsUserAadObjectId: Scalars['String']['input'];
  msTeamsUserId: Scalars['String']['input'];
  programId?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  recognizeVia: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsStr?: InputMaybe<Scalars['String']['input']>;
};

/** MS Teams tenant information */
export type MsTeamsTenant = {
  __typename?: 'MsTeamsTenant';
  id: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  workspaceSlug?: Maybe<Scalars['String']['output']>;
};

/** All Mutations */
export type Mutation = {
  __typename?: 'Mutation';
  acceptOpenTeamInvitation?: Maybe<AcceptOpenTeamInvitationPayload>;
  acceptTeamInvitation?: Maybe<AcceptTeamInvitationPayload>;
  activateCampaign?: Maybe<ActivateCampaignPayload>;
  addAdminSeats?: Maybe<AddAdminSeatsPayload>;
  addContacts?: Maybe<UserContactsAddPayload>;
  addContactsCampaign?: Maybe<AddContactsCampaignPayload>;
  /** Add Product to Shop */
  addProductToShop?: Maybe<AddProductPayload>;
  addProgramSlackChannel?: Maybe<AddProgramSlackChannelPayload>;
  /** Approve Lead */
  approveLead?: Maybe<ApproveLeadPayload>;
  approveOpenTeamInvitation?: Maybe<ApproveOpenTeamInvitationPayload>;
  /** Approve product */
  approveProduct?: Maybe<ApproveProductPayload>;
  /** Archive Eshop */
  archiveEshop?: Maybe<ArchivePayload>;
  associateProgramWithMsTeamsChannel?: Maybe<AssociateProgramWithMsTeamsChannelPayload>;
  bulkAcceptOrDeclineTeamInvitation?: Maybe<BulkAcceptOrDeclineTeamInvitationPayload>;
  bulkRemoveProgramContacts?: Maybe<BulkRemoveProgramContactsPayload>;
  bulkUpdateProgramContacts?: Maybe<BulkUpdateProgramContactsPayload>;
  changePassword?: Maybe<UserChangePasswordPayload>;
  /** Update Eshop Privacy */
  changePrivacy?: Maybe<ChangePrivacyPayload>;
  /** Clone Eshop */
  cloneEshop?: Maybe<ClonePayload>;
  connectContactProvider?: Maybe<ConnectUserContactProviderPayload>;
  consumeAdminPasswordResetLink?: Maybe<ConsumeAdminPasswordResetLinkPayload>;
  createAddress?: Maybe<CreateUserAddressPayload>;
  /** Create Automated Catalog */
  createAutomatedCatalog?: Maybe<CreateAutomatedCatalogPayload>;
  /** Create Automated Products */
  createAutomatedProducts?: Maybe<CreateAutomatedProductsPayload>;
  /** Create multiple Digital Assets */
  createBaseImages?: Maybe<CreateBaseImagesPayload>;
  /** Create Bundles */
  createBundles?: Maybe<CreateShopPayload>;
  createCampaign?: Maybe<CreateCampaignPayload>;
  /** Create/Update multi catalog */
  createCatalog?: Maybe<CreateCatalogPayload>;
  createChildCompany?: Maybe<CreateChildCompanyPayload>;
  createCompanyWorkspace?: Maybe<CreateCompanyWorkspacePayload>;
  createContact?: Maybe<CreateUserContactPayload>;
  createContactFilterView?: Maybe<CreateContactFilterViewPayload>;
  createCreditCard?: Maybe<CreateUserCreditCardPayload>;
  /** Create Digital Asset */
  createDigitalAsset?: Maybe<CreateDigitalAssetPayload>;
  /** Create Dummy Store */
  createDummyStore?: Maybe<CreateDummyStorePayload>;
  /** Create Eshop */
  createEshop?: Maybe<CreatePayload>;
  /** Create Library Assets */
  createLibraryAsset?: Maybe<CreateAssetsPayload>;
  /** Create Logo */
  createLogo?: Maybe<CreateLogoPayload>;
  createMsTeamsPost?: Maybe<CreateMsTeamsPostPayload>;
  createMsTeamsTenant?: Maybe<CreateMsTeamsTenantPayload>;
  createOrUpdateAddress?: Maybe<UserCreateOrUpdateAddressPayload>;
  createPost?: Maybe<CreatePostPayload>;
  createProgram?: Maybe<CreateProgramPayload>;
  createProgramOrder?: Maybe<CreateProgramOrderPayload>;
  createReaction?: Maybe<CreatePostReactionPayload>;
  /** Create request mockup catalog */
  createRequestMockup?: Maybe<CreateRequestMockupPayload>;
  createSession?: Maybe<SessionCreatePayload>;
  createSetupIntentCreditCard?: Maybe<CreateSetupIntentUserCreditCardPayload>;
  createSlackPost?: Maybe<CreateSlackPostPayload>;
  createTeam?: Maybe<CreateTeamPayload>;
  createUser?: Maybe<UserCreatePayload>;
  /** Create Warehouse Product */
  createWarehouseProduct?: Maybe<CreateWarehouseProductPayload>;
  /** Create a new workspace join request */
  createWorkspaceJoinRequest?: Maybe<CreatePayload>;
  /** Update featured section menu */
  customizeFeaturedSectionMenu?: Maybe<CustomizeFeaturedSectionMenuPayload>;
  /** Customize Product */
  customizeProduct?: Maybe<CustomizeProductPayload>;
  deactivateCampaign?: Maybe<DeactivateCampaignPayload>;
  deactivateWorkspaceUser?: Maybe<DeactivateWorkspaceUserPayload>;
  declineTeamInvitation?: Maybe<DeclineTeamInvitationPayload>;
  deleteAccount?: Maybe<UserDeleteAccountPayload>;
  deleteAddress?: Maybe<UserDeleteAddressPayload>;
  /** Delete Bundle */
  deleteBundles?: Maybe<DeleteShopPayload>;
  deleteCampaign?: Maybe<DeleteCampaignPayload>;
  deleteContact?: Maybe<DeleteUserContactPayload>;
  deleteContactFilterView?: Maybe<DeleteContactFilterViewPayload>;
  deleteContactProvider?: Maybe<DeleteUserContactProviderPayload>;
  deleteContacts?: Maybe<BulkDeleteUserContactPayload>;
  deleteCreditCard?: Maybe<DeleteUserCreditCardPayload>;
  /** Delete Library Assets */
  deleteLibraryAsset?: Maybe<DeleteAssetPayload>;
  deletePost?: Maybe<DeletePostPayload>;
  deleteProfileImage?: Maybe<DeleteProfileImagePayload>;
  deleteProgram?: Maybe<DeleteProgramPayload>;
  deleteReaction?: Maybe<DeletePostReactionPayload>;
  deleteSession?: Maybe<SessionDeletePayload>;
  deleteUserAddress?: Maybe<DeleteUserAddressPayload>;
  deleteWorkspaceUser?: Maybe<WorkspaceUserDeletePayload>;
  /** Destroy Digital Asset */
  destroyDigitalAsset?: Maybe<DestroyDigitalAssetPayload>;
  disableUserWalletAutoTopUp?: Maybe<DisableUserWalletAutoTopUpPayload>;
  dismissWidget?: Maybe<DismissWidgetPayload>;
  downloadPersonalData?: Maybe<UserDownloadPersonalDataPayload>;
  /** Eshop Edit Catalog */
  editCatalogEshop?: Maybe<EditCatalogPayload>;
  /** Edit logo of catalog */
  editLogo?: Maybe<EditLogoPayload>;
  /** Edit Store Admin Access */
  editStoreAdminAccess?: Maybe<EditStoreAdminAccessPayload>;
  enableWorkspace?: Maybe<EnableWorkspacePayload>;
  /** Expire Draft Warehouse Product */
  expireWarehouseProduct?: Maybe<ExpireDraftWarehouseProductPayload>;
  /** Generate Preview for customizer */
  generatePreview?: Maybe<GeneratePreviewPayload>;
  importContactEmails?: Maybe<ImportContactEmailsPayload>;
  importContacts?: Maybe<ImportUserContactsPayload>;
  importTeamInvitations?: Maybe<ImportTeamInvitationsPayload>;
  installSlackApp?: Maybe<InstallSlackAppPayload>;
  inviteContacts?: Maybe<InviteContactsPayload>;
  inviteTeamMember?: Maybe<TeamInviteMembersPayload>;
  leaveTeam?: Maybe<LeaveTeamPayload>;
  linkedinShare?: Maybe<LinkedShareQuestPayload>;
  /** Create/Update single catalog */
  manageCatalog?: Maybe<ManageCatalogPayload>;
  /** Activate Deactivate Products And Variants */
  manageCatalogProductsAndVariants?: Maybe<ManageProductAndVariantsPayload>;
  /** Activate Deactivate Store Variants */
  manageCatalogProductsEshop?: Maybe<ManageCatalogProductsPayload>;
  /** Activate Deactivate Store Variants */
  manageCatalogVariantsEshop?: Maybe<ManageCatalogVariantsPayload>;
  /** Create/Update draft automated catalog */
  manageDraftAutomatedCatalog?: Maybe<ManageDraftAutomatedCatalogPayload>;
  /** Update Eshop pastel fields */
  manageShopPastel?: Maybe<ManagePastelPayload>;
  /** Enable/Disable Taxons */
  manageTaxonsEshop?: Maybe<ManageTaxonsPayload>;
  markNotifiedQuests?: Maybe<QuestTransactionNotifiedPayload>;
  /** Modify User */
  modifyUser?: Maybe<ModifyUserPayload>;
  /** Populate Bundle */
  populateBundle?: Maybe<PopulateBundlePayload>;
  /** Enable/Disable Catalog */
  populateCatalog?: Maybe<PopulateCatalogPayload>;
  /** Populate draft automated catalog */
  populateDraftAutomatedCatalog?: Maybe<PopulateDraftAutomatedCatalogPayload>;
  processFreeProgram?: Maybe<ProcessFreeProgramPayload>;
  programAddUsersCheckout?: Maybe<CheckoutAddProgramOrderPayload>;
  programContactsBulkUpdate?: Maybe<ProgramContactsBulkUpdatePayload>;
  /** Create Eshop from Dummy Store */
  publish?: Maybe<PublishPayload>;
  reactivateWorkspaceUser?: Maybe<ReactivateWorkspaceUserPayload>;
  regenerateCampaignApiKey?: Maybe<RegenerateCampaignApiKeyPayload>;
  removeAdminSeat?: Maybe<RemoveAdminSeatPayload>;
  /** Remove admin to users */
  removeAdminToStore?: Maybe<RemoveStoreAdminPayload>;
  removeAllProgramSlackChannels?: Maybe<RemoveAllProgramSlackChannelsPayload>;
  removeContacts?: Maybe<UserContactsRemovePayload>;
  removeContactsCampaign?: Maybe<RemoveContactsCampaignPayload>;
  removeMsTeamsChannel?: Maybe<RemoveMsTeamsChannelPayload>;
  removeOpenTeamInvitation?: Maybe<RemoveOpenTeamInvitationPayload>;
  /** Remove product from draft automated catalog */
  removeProductFromDraftAutomatedCatalog?: Maybe<RemoveProductFromDraftAutomatedCatalogPayload>;
  removeProgramContact?: Maybe<RemoveProgramContactPayload>;
  removeProgramFromMsTeamsTeam?: Maybe<RemoveProgramFromMsTeamsTeamPayload>;
  removeProgramSlackChannel?: Maybe<RemoveProgramSlackChannelPayload>;
  removeTeamMember?: Maybe<RemoveTeamMemberPayload>;
  removeWorkspaceUser?: Maybe<RemoveWorkspaceUserPayload>;
  reorderContactProvider?: Maybe<ReorderUserContactProviderPayload>;
  /** Reset workspace user permissions to default */
  resetWorkspaceUserToDefault?: Maybe<ResetToDefaultPayload>;
  /** Restock Warehouse Product */
  restockWarehouseProduct?: Maybe<RestockWarehouseProductPayload>;
  /** Restore Catalog */
  restoreCatalogEshop?: Maybe<RestoreCatalogPayload>;
  resyncContactProvider?: Maybe<ResyncUserContactProviderPayload>;
  rewardRedemption?: Maybe<RewardRedemptionPayload>;
  saveSession?: Maybe<SessionCreatePayload>;
  sendVerificationEmail?: Maybe<UserSendVerificationEmailPayload>;
  setDefaultAddress?: Maybe<UserSetDefaultAddressPayload>;
  /** Set or clear default contact filter view for the current workspace user */
  setDefaultContactFilterView?: Maybe<SetDefaultContactFilterViewPayload>;
  setDefaultCreditCard?: Maybe<UserSetDefaultCreditCardPayload>;
  setDefaultPermissions?: Maybe<SetDefaultPermissionsPayload>;
  /** Set workspace permissions for a workspace user */
  setWorkspaceUserPermissions?: Maybe<SetWorkspaceUserPermissionsPayload>;
  teamInviteContacts?: Maybe<TeamInviteContactsPayload>;
  /** An example field added by the generator */
  testField: Scalars['String']['output'];
  /** Toggle Archive catalog */
  toggleArchiveCatalog?: Maybe<ToggleArchiveCatalogPayload>;
  transferWorkspaceOwnership?: Maybe<TransferWorkspaceOwnershipPayload>;
  uninstallSlackApp?: Maybe<UninstallSlackAppPayload>;
  unlockPersonalWorkspace?: Maybe<UnlockPersonalWorkspacePayload>;
  updateAddress?: Maybe<UpdateUserAddressPayload>;
  /** Update Bundle */
  updateBundles?: Maybe<UpdateShopPayload>;
  updateCampaign?: Maybe<UpdateCampaignPayload>;
  updateCampaignMailerPreferences?: Maybe<UpdateCampaignMailerPreferencesPayload>;
  /** Update catalog */
  updateCatalog?: Maybe<UpdateCatalogPayload>;
  updateChildCompanyStatus?: Maybe<UpdateChildCompanyStatusPayload>;
  updateCompanyValue?: Maybe<UpdateCompanyValuePayload>;
  updateContact?: Maybe<UpdateUserContactPayload>;
  updateContactFilterView?: Maybe<UpdateContactFilterViewPayload>;
  updateContactProvider?: Maybe<UpdateUserContactProviderPayload>;
  updateContacts?: Maybe<BulkUpdateUserContactPayload>;
  updateContactsColumn?: Maybe<BulkUpdateUserContactColumnPayload>;
  updateCurrentUserProgramContact?: Maybe<CurrentUserContactUpdatePayload>;
  updateCustomContactFields?: Maybe<UpdateCustomContactFieldsPayload>;
  updateDefaultWorkspace?: Maybe<UpdateDefaultWorkspacePayload>;
  /** Update Digital Asset */
  updateDigitalAsset?: Maybe<UpdateDigitalAssetPayload>;
  /** Update Draft Warehouse Product */
  updateDraftWarehouseProduct?: Maybe<UpdateDraftWarehouseProductPayload>;
  /** Update Dummy Store */
  updateDummyStore?: Maybe<UpdateDummyStorePayload>;
  updateEmailPreferences?: Maybe<UserUpdateEmailPreferencesPayload>;
  /** Update Eshop */
  updateEshop?: Maybe<UpdatePayload>;
  /** Update featured section menu */
  updateFeaturedSectionMenu?: Maybe<UpdateFeaturedSectionMenuPayload>;
  /** Update Library Assets */
  updateLibraryAsset?: Maybe<UpdateAssetsPayload>;
  /** @deprecated To be depreciated with Stadium Rewards FE */
  updateNotifiedQuest?: Maybe<QuestTransactionUpdatePayload>;
  updatePost?: Maybe<UpdatePostPayload>;
  /** Update Product Mapping */
  updateProductMapping?: Maybe<UpdateProductMappingPayload>;
  updateProfile?: Maybe<UserUpdateProfilePayload>;
  updateProgram?: Maybe<UpdateProgramPayload>;
  updateProgramContact?: Maybe<UpdateProgramContactPayload>;
  updateRole?: Maybe<WorkspaceUsersUpdateRolePayload>;
  updateSenderRlpMessage?: Maybe<UpdateSenderRlpMessagePayload>;
  updateSlackPost?: Maybe<UpdateSlackPostPayload>;
  updateTasteProfile?: Maybe<UserUpdateTasteProfilePayload>;
  updateTeam?: Maybe<UpdateTeamPayload>;
  updateTeamMemberPermission?: Maybe<UpdateTeamMemberPermissionPayload>;
  updateUser?: Maybe<UserUpdatePayload>;
  /** Update Warehouse Product */
  updateWarehouseProduct?: Maybe<UpdateWarehouseProductPayload>;
  updateWorkspace?: Maybe<WorkspaceUpdatePayload>;
  /** Update the status of a workspace join request */
  updateWorkspaceJoinRequestStatus?: Maybe<UpdateStatusPayload>;
  userAllocateWorkspacePoints?: Maybe<UserAllocateWorkspacePointsPayload>;
  userSetDefaultAddress?: Maybe<UserStadiumSetDefaultAddressPayload>;
  /** Checks and processes a user's subscription. */
  validateCompanySubscription?: Maybe<ValidateCompanySubscriptionPayload>;
  validateTeamInvitationToken?: Maybe<ValidateTeamInvitationTokenPayload>;
  validateTeamOpenInvitationToken?: Maybe<ValidateTeamOpenInvitationTokenPayload>;
};


/** All Mutations */
export type MutationAcceptOpenTeamInvitationArgs = {
  input: AcceptOpenTeamInvitationInput;
};


/** All Mutations */
export type MutationAcceptTeamInvitationArgs = {
  input: AcceptTeamInvitationInput;
};


/** All Mutations */
export type MutationActivateCampaignArgs = {
  input: ActivateCampaignInput;
};


/** All Mutations */
export type MutationAddAdminSeatsArgs = {
  input: AddAdminSeatsInput;
};


/** All Mutations */
export type MutationAddContactsArgs = {
  input: UserContactsAddInput;
};


/** All Mutations */
export type MutationAddContactsCampaignArgs = {
  input: AddContactsCampaignInput;
};


/** All Mutations */
export type MutationAddProductToShopArgs = {
  input: AddProductInput;
};


/** All Mutations */
export type MutationAddProgramSlackChannelArgs = {
  input: AddProgramSlackChannelInput;
};


/** All Mutations */
export type MutationApproveLeadArgs = {
  input: ApproveLeadInput;
};


/** All Mutations */
export type MutationApproveOpenTeamInvitationArgs = {
  input: ApproveOpenTeamInvitationInput;
};


/** All Mutations */
export type MutationApproveProductArgs = {
  input: ApproveProductInput;
};


/** All Mutations */
export type MutationArchiveEshopArgs = {
  input: ArchiveInput;
};


/** All Mutations */
export type MutationAssociateProgramWithMsTeamsChannelArgs = {
  input: AssociateProgramWithMsTeamsChannelInput;
};


/** All Mutations */
export type MutationBulkAcceptOrDeclineTeamInvitationArgs = {
  input: BulkAcceptOrDeclineTeamInvitationInput;
};


/** All Mutations */
export type MutationBulkRemoveProgramContactsArgs = {
  input: BulkRemoveProgramContactsInput;
};


/** All Mutations */
export type MutationBulkUpdateProgramContactsArgs = {
  input: BulkUpdateProgramContactsInput;
};


/** All Mutations */
export type MutationChangePasswordArgs = {
  input: UserChangePasswordInput;
};


/** All Mutations */
export type MutationChangePrivacyArgs = {
  input: ChangePrivacyInput;
};


/** All Mutations */
export type MutationCloneEshopArgs = {
  input: CloneInput;
};


/** All Mutations */
export type MutationConnectContactProviderArgs = {
  input: ConnectUserContactProviderInput;
};


/** All Mutations */
export type MutationConsumeAdminPasswordResetLinkArgs = {
  input: ConsumeAdminPasswordResetLinkInput;
};


/** All Mutations */
export type MutationCreateAddressArgs = {
  input: CreateUserAddressInput;
};


/** All Mutations */
export type MutationCreateAutomatedCatalogArgs = {
  input: CreateAutomatedCatalogInput;
};


/** All Mutations */
export type MutationCreateAutomatedProductsArgs = {
  input: CreateAutomatedProductsInput;
};


/** All Mutations */
export type MutationCreateBaseImagesArgs = {
  input: CreateBaseImagesInput;
};


/** All Mutations */
export type MutationCreateBundlesArgs = {
  input: CreateShopInput;
};


/** All Mutations */
export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput;
};


/** All Mutations */
export type MutationCreateCatalogArgs = {
  input: CreateCatalogInput;
};


/** All Mutations */
export type MutationCreateChildCompanyArgs = {
  input: CreateChildCompanyInput;
};


/** All Mutations */
export type MutationCreateCompanyWorkspaceArgs = {
  input: CreateCompanyWorkspaceInput;
};


/** All Mutations */
export type MutationCreateContactArgs = {
  input: CreateUserContactInput;
};


/** All Mutations */
export type MutationCreateContactFilterViewArgs = {
  input: CreateContactFilterViewInput;
};


/** All Mutations */
export type MutationCreateCreditCardArgs = {
  input: CreateUserCreditCardInput;
};


/** All Mutations */
export type MutationCreateDigitalAssetArgs = {
  input: CreateDigitalAssetInput;
};


/** All Mutations */
export type MutationCreateDummyStoreArgs = {
  input: CreateDummyStoreInput;
};


/** All Mutations */
export type MutationCreateEshopArgs = {
  input: CreateInput;
};


/** All Mutations */
export type MutationCreateLibraryAssetArgs = {
  input: CreateAssetsInput;
};


/** All Mutations */
export type MutationCreateLogoArgs = {
  input: CreateLogoInput;
};


/** All Mutations */
export type MutationCreateMsTeamsPostArgs = {
  input: CreateMsTeamsPostInput;
};


/** All Mutations */
export type MutationCreateMsTeamsTenantArgs = {
  input: CreateMsTeamsTenantInput;
};


/** All Mutations */
export type MutationCreateOrUpdateAddressArgs = {
  input: UserCreateOrUpdateAddressInput;
};


/** All Mutations */
export type MutationCreatePostArgs = {
  input: CreatePostInput;
};


/** All Mutations */
export type MutationCreateProgramArgs = {
  input: CreateProgramInput;
};


/** All Mutations */
export type MutationCreateProgramOrderArgs = {
  input: CreateProgramOrderInput;
};


/** All Mutations */
export type MutationCreateReactionArgs = {
  input: CreatePostReactionInput;
};


/** All Mutations */
export type MutationCreateRequestMockupArgs = {
  input: CreateRequestMockupInput;
};


/** All Mutations */
export type MutationCreateSessionArgs = {
  input: SessionCreateInput;
};


/** All Mutations */
export type MutationCreateSetupIntentCreditCardArgs = {
  input: CreateSetupIntentUserCreditCardInput;
};


/** All Mutations */
export type MutationCreateSlackPostArgs = {
  input: CreateSlackPostInput;
};


/** All Mutations */
export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


/** All Mutations */
export type MutationCreateUserArgs = {
  input: UserCreateInput;
};


/** All Mutations */
export type MutationCreateWarehouseProductArgs = {
  input: CreateWarehouseProductInput;
};


/** All Mutations */
export type MutationCreateWorkspaceJoinRequestArgs = {
  workspaceSlug: Scalars['String']['input'];
};


/** All Mutations */
export type MutationCustomizeFeaturedSectionMenuArgs = {
  input: CustomizeFeaturedSectionMenuInput;
};


/** All Mutations */
export type MutationCustomizeProductArgs = {
  input: CustomizeProductInput;
};


/** All Mutations */
export type MutationDeactivateCampaignArgs = {
  input: DeactivateCampaignInput;
};


/** All Mutations */
export type MutationDeactivateWorkspaceUserArgs = {
  input: DeactivateWorkspaceUserInput;
};


/** All Mutations */
export type MutationDeclineTeamInvitationArgs = {
  input: DeclineTeamInvitationInput;
};


/** All Mutations */
export type MutationDeleteAccountArgs = {
  input: UserDeleteAccountInput;
};


/** All Mutations */
export type MutationDeleteAddressArgs = {
  input: UserDeleteAddressInput;
};


/** All Mutations */
export type MutationDeleteBundlesArgs = {
  input: DeleteShopInput;
};


/** All Mutations */
export type MutationDeleteCampaignArgs = {
  input: DeleteCampaignInput;
};


/** All Mutations */
export type MutationDeleteContactArgs = {
  input: DeleteUserContactInput;
};


/** All Mutations */
export type MutationDeleteContactFilterViewArgs = {
  input: DeleteContactFilterViewInput;
};


/** All Mutations */
export type MutationDeleteContactProviderArgs = {
  input: DeleteUserContactProviderInput;
};


/** All Mutations */
export type MutationDeleteContactsArgs = {
  input: BulkDeleteUserContactInput;
};


/** All Mutations */
export type MutationDeleteCreditCardArgs = {
  input: DeleteUserCreditCardInput;
};


/** All Mutations */
export type MutationDeleteLibraryAssetArgs = {
  input: DeleteAssetInput;
};


/** All Mutations */
export type MutationDeletePostArgs = {
  input: DeletePostInput;
};


/** All Mutations */
export type MutationDeleteProfileImageArgs = {
  input: DeleteProfileImageInput;
};


/** All Mutations */
export type MutationDeleteProgramArgs = {
  input: DeleteProgramInput;
};


/** All Mutations */
export type MutationDeleteReactionArgs = {
  input: DeletePostReactionInput;
};


/** All Mutations */
export type MutationDeleteSessionArgs = {
  input: SessionDeleteInput;
};


/** All Mutations */
export type MutationDeleteUserAddressArgs = {
  input: DeleteUserAddressInput;
};


/** All Mutations */
export type MutationDeleteWorkspaceUserArgs = {
  input: WorkspaceUserDeleteInput;
};


/** All Mutations */
export type MutationDestroyDigitalAssetArgs = {
  input: DestroyDigitalAssetInput;
};


/** All Mutations */
export type MutationDisableUserWalletAutoTopUpArgs = {
  input: DisableUserWalletAutoTopUpInput;
};


/** All Mutations */
export type MutationDismissWidgetArgs = {
  input: DismissWidgetInput;
};


/** All Mutations */
export type MutationDownloadPersonalDataArgs = {
  input: UserDownloadPersonalDataInput;
};


/** All Mutations */
export type MutationEditCatalogEshopArgs = {
  input: EditCatalogInput;
};


/** All Mutations */
export type MutationEditLogoArgs = {
  input: EditLogoInput;
};


/** All Mutations */
export type MutationEditStoreAdminAccessArgs = {
  input: EditStoreAdminAccessInput;
};


/** All Mutations */
export type MutationEnableWorkspaceArgs = {
  input: EnableWorkspaceInput;
};


/** All Mutations */
export type MutationExpireWarehouseProductArgs = {
  input: ExpireDraftWarehouseProductInput;
};


/** All Mutations */
export type MutationGeneratePreviewArgs = {
  input: GeneratePreviewInput;
};


/** All Mutations */
export type MutationImportContactEmailsArgs = {
  input: ImportContactEmailsInput;
};


/** All Mutations */
export type MutationImportContactsArgs = {
  input: ImportUserContactsInput;
};


/** All Mutations */
export type MutationImportTeamInvitationsArgs = {
  input: ImportTeamInvitationsInput;
};


/** All Mutations */
export type MutationInstallSlackAppArgs = {
  input: InstallSlackAppInput;
};


/** All Mutations */
export type MutationInviteContactsArgs = {
  input: InviteContactsInput;
};


/** All Mutations */
export type MutationInviteTeamMemberArgs = {
  input: TeamInviteMembersInput;
};


/** All Mutations */
export type MutationLeaveTeamArgs = {
  input: LeaveTeamInput;
};


/** All Mutations */
export type MutationLinkedinShareArgs = {
  input: LinkedShareQuestInput;
};


/** All Mutations */
export type MutationManageCatalogArgs = {
  input: ManageCatalogInput;
};


/** All Mutations */
export type MutationManageCatalogProductsAndVariantsArgs = {
  input: ManageProductAndVariantsInput;
};


/** All Mutations */
export type MutationManageCatalogProductsEshopArgs = {
  input: ManageCatalogProductsInput;
};


/** All Mutations */
export type MutationManageCatalogVariantsEshopArgs = {
  input: ManageCatalogVariantsInput;
};


/** All Mutations */
export type MutationManageDraftAutomatedCatalogArgs = {
  input: ManageDraftAutomatedCatalogInput;
};


/** All Mutations */
export type MutationManageShopPastelArgs = {
  input: ManagePastelInput;
};


/** All Mutations */
export type MutationManageTaxonsEshopArgs = {
  input: ManageTaxonsInput;
};


/** All Mutations */
export type MutationMarkNotifiedQuestsArgs = {
  input: QuestTransactionNotifiedInput;
};


/** All Mutations */
export type MutationModifyUserArgs = {
  input: ModifyUserInput;
};


/** All Mutations */
export type MutationPopulateBundleArgs = {
  input: PopulateBundleInput;
};


/** All Mutations */
export type MutationPopulateCatalogArgs = {
  input: PopulateCatalogInput;
};


/** All Mutations */
export type MutationPopulateDraftAutomatedCatalogArgs = {
  input: PopulateDraftAutomatedCatalogInput;
};


/** All Mutations */
export type MutationProcessFreeProgramArgs = {
  input: ProcessFreeProgramInput;
};


/** All Mutations */
export type MutationProgramAddUsersCheckoutArgs = {
  input: CheckoutAddProgramOrderInput;
};


/** All Mutations */
export type MutationProgramContactsBulkUpdateArgs = {
  input: ProgramContactsBulkUpdateInput;
};


/** All Mutations */
export type MutationPublishArgs = {
  input: PublishInput;
};


/** All Mutations */
export type MutationReactivateWorkspaceUserArgs = {
  input: ReactivateWorkspaceUserInput;
};


/** All Mutations */
export type MutationRegenerateCampaignApiKeyArgs = {
  input: RegenerateCampaignApiKeyInput;
};


/** All Mutations */
export type MutationRemoveAdminSeatArgs = {
  input: RemoveAdminSeatInput;
};


/** All Mutations */
export type MutationRemoveAdminToStoreArgs = {
  input: RemoveStoreAdminInput;
};


/** All Mutations */
export type MutationRemoveAllProgramSlackChannelsArgs = {
  input: RemoveAllProgramSlackChannelsInput;
};


/** All Mutations */
export type MutationRemoveContactsArgs = {
  input: UserContactsRemoveInput;
};


/** All Mutations */
export type MutationRemoveContactsCampaignArgs = {
  input: RemoveContactsCampaignInput;
};


/** All Mutations */
export type MutationRemoveMsTeamsChannelArgs = {
  input: RemoveMsTeamsChannelInput;
};


/** All Mutations */
export type MutationRemoveOpenTeamInvitationArgs = {
  input: RemoveOpenTeamInvitationInput;
};


/** All Mutations */
export type MutationRemoveProductFromDraftAutomatedCatalogArgs = {
  input: RemoveProductFromDraftAutomatedCatalogInput;
};


/** All Mutations */
export type MutationRemoveProgramContactArgs = {
  input: RemoveProgramContactInput;
};


/** All Mutations */
export type MutationRemoveProgramFromMsTeamsTeamArgs = {
  input: RemoveProgramFromMsTeamsTeamInput;
};


/** All Mutations */
export type MutationRemoveProgramSlackChannelArgs = {
  input: RemoveProgramSlackChannelInput;
};


/** All Mutations */
export type MutationRemoveTeamMemberArgs = {
  input: RemoveTeamMemberInput;
};


/** All Mutations */
export type MutationRemoveWorkspaceUserArgs = {
  input: RemoveWorkspaceUserInput;
};


/** All Mutations */
export type MutationReorderContactProviderArgs = {
  input: ReorderUserContactProviderInput;
};


/** All Mutations */
export type MutationResetWorkspaceUserToDefaultArgs = {
  input: ResetToDefaultInput;
};


/** All Mutations */
export type MutationRestockWarehouseProductArgs = {
  input: RestockWarehouseProductInput;
};


/** All Mutations */
export type MutationRestoreCatalogEshopArgs = {
  input: RestoreCatalogInput;
};


/** All Mutations */
export type MutationResyncContactProviderArgs = {
  input: ResyncUserContactProviderInput;
};


/** All Mutations */
export type MutationRewardRedemptionArgs = {
  input: RewardRedemptionInput;
};


/** All Mutations */
export type MutationSaveSessionArgs = {
  input: SessionCreateInput;
};


/** All Mutations */
export type MutationSendVerificationEmailArgs = {
  input: UserSendVerificationEmailInput;
};


/** All Mutations */
export type MutationSetDefaultAddressArgs = {
  input: UserSetDefaultAddressInput;
};


/** All Mutations */
export type MutationSetDefaultContactFilterViewArgs = {
  input: SetDefaultContactFilterViewInput;
};


/** All Mutations */
export type MutationSetDefaultCreditCardArgs = {
  input: UserSetDefaultCreditCardInput;
};


/** All Mutations */
export type MutationSetDefaultPermissionsArgs = {
  input: SetDefaultPermissionsInput;
};


/** All Mutations */
export type MutationSetWorkspaceUserPermissionsArgs = {
  input: SetWorkspaceUserPermissionsInput;
};


/** All Mutations */
export type MutationTeamInviteContactsArgs = {
  input: TeamInviteContactsInput;
};


/** All Mutations */
export type MutationToggleArchiveCatalogArgs = {
  input: ToggleArchiveCatalogInput;
};


/** All Mutations */
export type MutationTransferWorkspaceOwnershipArgs = {
  input: TransferWorkspaceOwnershipInput;
};


/** All Mutations */
export type MutationUninstallSlackAppArgs = {
  input: UninstallSlackAppInput;
};


/** All Mutations */
export type MutationUnlockPersonalWorkspaceArgs = {
  input: UnlockPersonalWorkspaceInput;
};


/** All Mutations */
export type MutationUpdateAddressArgs = {
  input: UpdateUserAddressInput;
};


/** All Mutations */
export type MutationUpdateBundlesArgs = {
  input: UpdateShopInput;
};


/** All Mutations */
export type MutationUpdateCampaignArgs = {
  input: UpdateCampaignInput;
};


/** All Mutations */
export type MutationUpdateCampaignMailerPreferencesArgs = {
  input: UpdateCampaignMailerPreferencesInput;
};


/** All Mutations */
export type MutationUpdateCatalogArgs = {
  input: UpdateCatalogInput;
};


/** All Mutations */
export type MutationUpdateChildCompanyStatusArgs = {
  input: UpdateChildCompanyStatusInput;
};


/** All Mutations */
export type MutationUpdateCompanyValueArgs = {
  input: UpdateCompanyValueInput;
};


/** All Mutations */
export type MutationUpdateContactArgs = {
  input: UpdateUserContactInput;
};


/** All Mutations */
export type MutationUpdateContactFilterViewArgs = {
  input: UpdateContactFilterViewInput;
};


/** All Mutations */
export type MutationUpdateContactProviderArgs = {
  input: UpdateUserContactProviderInput;
};


/** All Mutations */
export type MutationUpdateContactsArgs = {
  input: BulkUpdateUserContactInput;
};


/** All Mutations */
export type MutationUpdateContactsColumnArgs = {
  input: BulkUpdateUserContactColumnInput;
};


/** All Mutations */
export type MutationUpdateCurrentUserProgramContactArgs = {
  input: CurrentUserContactUpdateInput;
};


/** All Mutations */
export type MutationUpdateCustomContactFieldsArgs = {
  input: UpdateCustomContactFieldsInput;
};


/** All Mutations */
export type MutationUpdateDefaultWorkspaceArgs = {
  input: UpdateDefaultWorkspaceInput;
};


/** All Mutations */
export type MutationUpdateDigitalAssetArgs = {
  input: UpdateDigitalAssetInput;
};


/** All Mutations */
export type MutationUpdateDraftWarehouseProductArgs = {
  input: UpdateDraftWarehouseProductInput;
};


/** All Mutations */
export type MutationUpdateDummyStoreArgs = {
  input: UpdateDummyStoreInput;
};


/** All Mutations */
export type MutationUpdateEmailPreferencesArgs = {
  input: UserUpdateEmailPreferencesInput;
};


/** All Mutations */
export type MutationUpdateEshopArgs = {
  input: UpdateInput;
};


/** All Mutations */
export type MutationUpdateFeaturedSectionMenuArgs = {
  input: UpdateFeaturedSectionMenuInput;
};


/** All Mutations */
export type MutationUpdateLibraryAssetArgs = {
  input: UpdateAssetsInput;
};


/** All Mutations */
export type MutationUpdateNotifiedQuestArgs = {
  input: QuestTransactionUpdateInput;
};


/** All Mutations */
export type MutationUpdatePostArgs = {
  input: UpdatePostInput;
};


/** All Mutations */
export type MutationUpdateProductMappingArgs = {
  input: UpdateProductMappingInput;
};


/** All Mutations */
export type MutationUpdateProfileArgs = {
  input: UserUpdateProfileInput;
};


/** All Mutations */
export type MutationUpdateProgramArgs = {
  input: UpdateProgramInput;
};


/** All Mutations */
export type MutationUpdateProgramContactArgs = {
  input: UpdateProgramContactInput;
};


/** All Mutations */
export type MutationUpdateRoleArgs = {
  input: WorkspaceUsersUpdateRoleInput;
};


/** All Mutations */
export type MutationUpdateSenderRlpMessageArgs = {
  input: UpdateSenderRlpMessageInput;
};


/** All Mutations */
export type MutationUpdateSlackPostArgs = {
  input: UpdateSlackPostInput;
};


/** All Mutations */
export type MutationUpdateTasteProfileArgs = {
  input: UserUpdateTasteProfileInput;
};


/** All Mutations */
export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
};


/** All Mutations */
export type MutationUpdateTeamMemberPermissionArgs = {
  input: UpdateTeamMemberPermissionInput;
};


/** All Mutations */
export type MutationUpdateUserArgs = {
  input: UserUpdateInput;
};


/** All Mutations */
export type MutationUpdateWarehouseProductArgs = {
  input: UpdateWarehouseProductInput;
};


/** All Mutations */
export type MutationUpdateWorkspaceArgs = {
  input: WorkspaceUpdateInput;
};


/** All Mutations */
export type MutationUpdateWorkspaceJoinRequestStatusArgs = {
  id: Scalars['ID']['input'];
  status: WorkspaceJoinRequestStatus;
};


/** All Mutations */
export type MutationUserAllocateWorkspacePointsArgs = {
  input: UserAllocateWorkspacePointsInput;
};


/** All Mutations */
export type MutationUserSetDefaultAddressArgs = {
  input: UserStadiumSetDefaultAddressInput;
};


/** All Mutations */
export type MutationValidateCompanySubscriptionArgs = {
  input: ValidateCompanySubscriptionInput;
};


/** All Mutations */
export type MutationValidateTeamInvitationTokenArgs = {
  input: ValidateTeamInvitationTokenInput;
};


/** All Mutations */
export type MutationValidateTeamOpenInvitationTokenArgs = {
  input: ValidateTeamOpenInvitationTokenInput;
};

export type OpportunityStage = {
  __typename?: 'OpportunityStage';
  active?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  pipelineName?: Maybe<Scalars['String']['output']>;
  remoteWasDeleted?: Maybe<Scalars['Boolean']['output']>;
};

/** Option Group */
export type OptionGroup = {
  __typename?: 'OptionGroup';
  /** color mapping file url */
  colorMappingUrl?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** key */
  key?: Maybe<Scalars['String']['output']>;
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
  /** position */
  position?: Maybe<Scalars['Int']['output']>;
  /** pre_selected */
  preSelected?: Maybe<Scalars['Boolean']['output']>;
  /** presentation name */
  presentation?: Maybe<Scalars['String']['output']>;
};

/** Option Type */
export type OptionType = {
  __typename?: 'OptionType';
  /** Option Type ID */
  filterable?: Maybe<Scalars['Boolean']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** key */
  key?: Maybe<Scalars['String']['output']>;
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
  /** option value */
  optionValues?: Maybe<Array<OptionValue>>;
  /** position */
  position?: Maybe<Scalars['Int']['output']>;
  /** presentation name */
  presentation?: Maybe<Scalars['String']['output']>;
};


/** Option Type */
export type OptionTypeOptionValuesArgs = {
  forLocker?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Option type value hash Input */
export type OptionTypeValueHashInput = {
  /** Option Type Id */
  optionTypeId: Scalars['Int']['input'];
  /** Size Id */
  optionValueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** OptionValue */
export type OptionValue = {
  __typename?: 'OptionValue';
  /** ID */
  id: Scalars['ID']['output'];
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
  /** Option Type */
  optionType: OptionType;
  /** Option Type ID */
  optionTypeId?: Maybe<Scalars['ID']['output']>;
  /** position */
  position?: Maybe<Scalars['Int']['output']>;
  /** presentation name */
  presentation?: Maybe<Scalars['String']['output']>;
};

export type OrderSetting = {
  __typename?: 'OrderSetting';
  allowRecipientViewBundleItems: Scalars['Boolean']['output'];
  billedCurrency?: Maybe<Scalars['String']['output']>;
  billedCurrencyId?: Maybe<Scalars['Int']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  billingNote?: Maybe<Scalars['String']['output']>;
  billingZipcode?: Maybe<Scalars['String']['output']>;
  budgetInCurrency?: Maybe<Scalars['Float']['output']>;
  budgetInPoints?: Maybe<Scalars['Float']['output']>;
  corporateBilled?: Maybe<Scalars['Boolean']['output']>;
  creditCard?: Maybe<CreditCard>;
  creditCardId?: Maybe<Scalars['Int']['output']>;
  feUrl?: Maybe<Scalars['String']['output']>;
  rlpFrom?: Maybe<Scalars['String']['output']>;
  rlpMessage?: Maybe<Scalars['String']['output']>;
  sendUsToNonUs: Scalars['Boolean']['output'];
  storeCurrency?: Maybe<Scalars['String']['output']>;
  storeName?: Maybe<Scalars['String']['output']>;
  storeNumber?: Maybe<Scalars['String']['output']>;
  teamWallet?: Maybe<TeamWallet>;
  teamWalletId?: Maybe<Scalars['Int']['output']>;
  useGlobalPoint?: Maybe<Scalars['Boolean']['output']>;
  useWalletMoney?: Maybe<Scalars['Boolean']['output']>;
};

export type OrderSettingInput = {
  allowRecipientViewBundleItems?: InputMaybe<Scalars['Boolean']['input']>;
  billedCurrency?: InputMaybe<Scalars['String']['input']>;
  billedCurrencyId?: InputMaybe<Scalars['Int']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingNote?: InputMaybe<Scalars['String']['input']>;
  billingZipcode?: InputMaybe<Scalars['String']['input']>;
  budgetInCurrency?: InputMaybe<Scalars['Float']['input']>;
  budgetInPoints?: InputMaybe<Scalars['Float']['input']>;
  corporateBilled?: InputMaybe<Scalars['Boolean']['input']>;
  creditCardId?: InputMaybe<Scalars['Int']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  currencyPrefix?: InputMaybe<Scalars['String']['input']>;
  currencySuffix?: InputMaybe<Scalars['String']['input']>;
  rlpFrom?: InputMaybe<Scalars['String']['input']>;
  rlpMessage?: InputMaybe<Scalars['String']['input']>;
  sendUsToNonUs?: InputMaybe<Scalars['Boolean']['input']>;
  storeName?: InputMaybe<Scalars['String']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
  teamWalletId?: InputMaybe<Scalars['Int']['input']>;
  useGlobalPoint?: InputMaybe<Scalars['Boolean']['input']>;
  useWalletMoney?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderStats = {
  __typename?: 'OrderStats';
  awaitingApproval?: Maybe<Scalars['Int']['output']>;
  cartOrdersCount?: Maybe<Scalars['Int']['output']>;
  expiredOrdersCount?: Maybe<Scalars['Int']['output']>;
  inProgress?: Maybe<Scalars['Int']['output']>;
  liveOrdersCount?: Maybe<Scalars['Int']['output']>;
  notRedeemed?: Maybe<Scalars['Int']['output']>;
  redeemed?: Maybe<Scalars['Int']['output']>;
  rejected?: Maybe<Scalars['Int']['output']>;
  scheduled?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalOrdersCount?: Maybe<Scalars['Int']['output']>;
};

export type Package = {
  __typename?: 'Package';
  /** Indicates if the package is active */
  active: Scalars['Boolean']['output'];
  /** Timestamp when the package was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Indicates if the package is displayed on the front end */
  displayOnFe: Scalars['Boolean']['output'];
  /** Unique identifier for the package */
  id: Scalars['ID']['output'];
  /** The intent or purpose of the package */
  intent?: Maybe<Scalars['String']['output']>;
  /** Monthly Price */
  monthlyPrice: Scalars['Float']['output'];
  /** Name of the package */
  name?: Maybe<Scalars['String']['output']>;
  /** Details associated with the package */
  packageDetail?: Maybe<PackageDetail>;
  /** Associated Package Features */
  packageFeatures?: Maybe<Array<PackageFeature>>;
  /** Maps intent key based on input */
  packageIntentMappingKey?: Maybe<Scalars['String']['output']>;
  /** Position of the package */
  position: Scalars['Int']['output'];
  /** Cost of the package */
  price?: Maybe<Scalars['Float']['output']>;
  /** Timestamp when the package was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PackageDetail = {
  __typename?: 'PackageDetail';
  /** URL for background image */
  bgImageUrl?: Maybe<Scalars['String']['output']>;
  /** Color code associated with the package detail */
  colorCode?: Maybe<Scalars['String']['output']>;
  /** Background color */
  colorCodeBg?: Maybe<Scalars['String']['output']>;
  /** Darker variant of the color code */
  colorCodeDark?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the package detail was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Custom Pricing */
  customPricing?: Maybe<Scalars['Boolean']['output']>;
  /** Default */
  default?: Maybe<Scalars['Boolean']['output']>;
  /** Display Markup */
  displayMarkup?: Maybe<Scalars['String']['output']>;
  /** Admin Icon stroke color */
  iconColor?: Maybe<Scalars['String']['output']>;
  /** URL for icon image */
  iconImageUrl?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the package detail */
  id: Scalars['ID']['output'];
  /** URL for intake or additional information */
  intakeFormUrl?: Maybe<Scalars['String']['output']>;
  /** Package Details Column Ordering */
  orderedPreferenceKeys?: Maybe<Array<Scalars['String']['output']>>;
  /** Identifier for the associated package */
  packageId?: Maybe<Scalars['Int']['output']>;
  /** Indicates if the package detail is popular */
  popular?: Maybe<Scalars['Boolean']['output']>;
  /** Preferences */
  preferences?: Maybe<PackageDetailPreference>;
  /** Timestamp when the package detail was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PackageDetailPreference = {
  __typename?: 'PackageDetailPreference';
  additionalFeatures?: Maybe<Scalars['String']['output']>;
  additionalFeaturesTooltip?: Maybe<Scalars['String']['output']>;
  commonFeatures?: Maybe<Scalars['String']['output']>;
  freeSwag?: Maybe<Scalars['String']['output']>;
  netTerms?: Maybe<Scalars['String']['output']>;
  onDemandSwagDesigns?: Maybe<Scalars['String']['output']>;
  onDemandSwagDesignsTooltip?: Maybe<Scalars['String']['output']>;
  onboarding?: Maybe<Scalars['String']['output']>;
  recipientSupport?: Maybe<Scalars['String']['output']>;
  recommendedFor?: Maybe<Scalars['String']['output']>;
  recommendedForTooltip?: Maybe<Scalars['String']['output']>;
  serviceFee?: Maybe<Scalars['String']['output']>;
  serviceFeeTooltip?: Maybe<Scalars['String']['output']>;
  sharedAdmins?: Maybe<Scalars['String']['output']>;
  support?: Maybe<Scalars['String']['output']>;
};

export type PackageFeature = {
  __typename?: 'PackageFeature';
  active: Scalars['Boolean']['output'];
  amount?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayOnFe: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  intent?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onboardingRequired: Scalars['Boolean']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  roleId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  usageLimits?: Maybe<Scalars['Int']['output']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Paginated Collection */
export type PaginatedCollection = {
  __typename?: 'PaginatedCollection';
  /** Collection of current page */
  collection?: Maybe<Array<Entity>>;
  /** Total counts of each filter tab */
  metadata?: Maybe<FiltersCount>;
  /** Total results */
  total: Scalars['Int']['output'];
};

export type PaginatedCompanyUsers = {
  __typename?: 'PaginatedCompanyUsers';
  data: Array<CompanyUser>;
  meta: PaginationMetadata;
};

/** Paginated list of draft products for a draft_automated_mockups catalog */
export type PaginatedDraftCatalogProducts = {
  __typename?: 'PaginatedDraftCatalogProducts';
  /** Map of country ISO code to count of products available only in that set of countries (not global) */
  countryWiseProductCount: Scalars['JSON']['output'];
  /** Products available in a global zone; these are excluded from countryWiseProductCount */
  globalProductCount: Scalars['Int']['output'];
  /** Products added to draft_automated_mockups catalog */
  products?: Maybe<Array<DraftAutomatedCatalogProduct>>;
  /** Total number of selected products in the catalog (after filters if any) */
  total: Scalars['Int']['output'];
  /** Total number of color option values in the catalog */
  totalColorOptions?: Maybe<Scalars['Int']['output']>;
  /** Total number of products in the catalog */
  totalProductsCount: Scalars['Int']['output'];
};

export type PaginatedTeamMembers = {
  __typename?: 'PaginatedTeamMembers';
  /** List of team members */
  data: Array<Invitation>;
  /** Pagination metadata */
  meta: PaginationMetadata;
};

export type PaginatedUsers = {
  __typename?: 'PaginatedUsers';
  data: Array<User>;
  meta: PaginationMetadata;
};

export type PaginationMetadata = {
  __typename?: 'PaginationMetadata';
  currentPage?: Maybe<Scalars['Int']['output']>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  perPage?: Maybe<Scalars['Int']['output']>;
  prevCursor?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  amount: Scalars['Float']['output'];
  currencyCode: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  paymentMethod: Scalars['String']['output'];
  paymentMethodId?: Maybe<Scalars['ID']['output']>;
};

export enum PermissionTypes {
  Custom = 'custom',
  Default = 'default'
}

/** Autogenerated input type of PopulateBundle */
export type PopulateBundleInput = {
  /** Bundle Number to add/remove products from */
  bundleNumber: Scalars['String']['input'];
  /** Bundle Items */
  bundleProductAttributes?: InputMaybe<Array<BundleProductInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PopulateBundle. */
export type PopulateBundlePayload = {
  __typename?: 'PopulateBundlePayload';
  /** Bundle */
  bundle?: Maybe<Product>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error */
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of PopulateCatalog */
export type PopulateCatalogInput = {
  /** Add/Remove the products */
  activate: Scalars['Boolean']['input'];
  /** Catalog Id to add/remove products from */
  catalogId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Store Number */
  storeNumber: Scalars['String']['input'];
};

/** Autogenerated return type of PopulateCatalog. */
export type PopulateCatalogPayload = {
  __typename?: 'PopulateCatalogPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Response to add/remove products from catalog */
  response?: Maybe<Response>;
};

/** Autogenerated input type of PopulateDraftAutomatedCatalog */
export type PopulateDraftAutomatedCatalogInput = {
  /** Catalog Number */
  catalogNumber: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Filters will be passed as args to stadium search */
  filters?: InputMaybe<Scalars['JSON']['input']>;
  /** Page number */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Items per page */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Selected Products Ids With color mapping */
  selectedProduct?: InputMaybe<DraftAutomatedCatalogSelectedProductInput>;
};

/** Autogenerated return type of PopulateDraftAutomatedCatalog. */
export type PopulateDraftAutomatedCatalogPayload = {
  __typename?: 'PopulateDraftAutomatedCatalogPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Products added to catalog */
  paginatedProducts?: Maybe<PaginatedDraftCatalogProducts>;
};

export type Post = {
  __typename?: 'Post';
  amount: Scalars['Int']['output'];
  body: Scalars['String']['output'];
  comments?: Maybe<Array<Comment>>;
  commentsAmount?: Maybe<Scalars['Int']['output']>;
  commentsCount: Scalars['Int']['output'];
  createdAt: Scalars['DateType']['output'];
  creator: User;
  creatorExist: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<PostImage>>;
  lockAt: Scalars['DateType']['output'];
  locked: Scalars['Boolean']['output'];
  mentions?: Maybe<Array<Mention>>;
  number?: Maybe<Scalars['String']['output']>;
  ownerContact?: Maybe<ProgramContact>;
  parent?: Maybe<Post>;
  program: Program;
  reactions?: Maybe<Array<PostReaction>>;
  sendersCount?: Maybe<Scalars['Int']['output']>;
  stickers?: Maybe<Array<PostSticker>>;
};


export type PostCommentsArgs = {
  allComments?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PostFilters = {
  __typename?: 'PostFilters';
  hashtags: Array<Scalars['String']['output']>;
  receivedBy: Array<ProgramContact>;
  sentBy: Array<ProgramContact>;
};

export type PostImage = {
  __typename?: 'PostImage';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type PostInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  parser?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<PostSourceTypeEnum>;
  stickers?: InputMaybe<Array<PostStickerInput>>;
};

export type PostList = {
  __typename?: 'PostList';
  meta: ListMeta;
  posts?: Maybe<Array<Post>>;
};

export type PostReaction = {
  __typename?: 'PostReaction';
  body: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reactionId: Scalars['ID']['output'];
  reactor: User;
};

/** Allowed source types for manual post creation */
export enum PostSourceTypeEnum {
  ProgramFeed = 'program_feed',
  QuickRecognition = 'quick_recognition'
}

export type PostSticker = {
  __typename?: 'PostSticker';
  altText: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type PostStickerInput = {
  altText: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** Preference object type */
export type Preference = {
  __typename?: 'Preference';
  category: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Input type for email preferences */
export type PreferenceInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Preview Request */
export type PreviewRequest = {
  __typename?: 'PreviewRequest';
  /** ID */
  id: Scalars['ID']['output'];
  /** Number */
  number: Scalars['String']['output'];
  /** Response */
  response?: Maybe<Scalars['JSON']['output']>;
  /** Status */
  status: Scalars['String']['output'];
};

/** Price */
export type Price = {
  __typename?: 'Price';
  /** Amnount */
  amount?: Maybe<Scalars['String']['output']>;
  /** Display Amnount */
  amountIn?: Maybe<Scalars['String']['output']>;
  /** description */
  description?: Maybe<Scalars['String']['output']>;
  /** Display name */
  displayName?: Maybe<Scalars['String']['output']>;
  /** External ID */
  externalId?: Maybe<Scalars['String']['output']>;
  /** External Source */
  externalSource?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Images */
  images?: Maybe<Array<Scalars['Attachment']['output']>>;
  /** Maximum Qty */
  max?: Maybe<Scalars['Int']['output']>;
  /** Minimum Qty */
  min?: Maybe<Scalars['Int']['output']>;
  /** Amount */
  priceIn?: Maybe<Scalars['Float']['output']>;
};


/** Price */
export type PriceAmountInArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
};


/** Price */
export type PricePriceInArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
};

/** Print Type */
export type Print = {
  __typename?: 'Print';
  /** Display */
  display: Scalars['Boolean']['output'];
  /** Id */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
};

/** Data type for print image data */
export type PrintImageData = {
  /** JSON data for canvas inner content */
  canvasInnerJson?: InputMaybe<Scalars['JSON']['input']>;
  /** Array of customizer template IDs */
  colors: Array<Scalars['String']['input']>;
  /** Mockup ID */
  mockupId: Scalars['ID']['input'];
  /** Print image file to be uploaded */
  printImage?: InputMaybe<Scalars['Upload']['input']>;
  /** Left position of the print image */
  printImageLeft?: InputMaybe<Scalars['Float']['input']>;
  /** Top position of the print image */
  printImageTop?: InputMaybe<Scalars['Float']['input']>;
  /** Left position of the template print image */
  templatePrintImageLeft?: InputMaybe<Scalars['Float']['input']>;
  /** Top position of the template print image */
  templatePrintImageTop?: InputMaybe<Scalars['Float']['input']>;
  /** Theme Creation Time */
  themeCreatedAt?: InputMaybe<Scalars['String']['input']>;
  /** Theme ID */
  themeId?: InputMaybe<Scalars['ID']['input']>;
  /** Theme name */
  themeName?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for print image data */
export type PrintImageInput = {
  /** Print image data */
  data: Array<PrintImageData>;
  /** Size */
  size: Scalars['String']['input'];
};

/** Autogenerated input type of ProcessFreeProgram */
export type ProcessFreeProgramInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

/** Autogenerated return type of ProcessFreeProgram. */
export type ProcessFreeProgramPayload = {
  __typename?: 'ProcessFreeProgramPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  response?: Maybe<FreeProgramResponse>;
  success: Scalars['Boolean']['output'];
};

/** Product */
export type Product = {
  __typename?: 'Product';
  /** Whether the product should be added to automated catalog */
  addToAutomatedCatalog: Scalars['Boolean']['output'];
  /** AI Description */
  aiDescription?: Maybe<AiDescription>;
  /** All Variant Images */
  allVariantImages?: Maybe<Array<Logo>>;
  /** All variants available globally */
  allVariantsAvailableGlobally?: Maybe<Scalars['Boolean']['output']>;
  /** variants */
  allVariantsIncludingMaster?: Maybe<Array<Variant>>;
  /** Whether new mockups can be created (all existing mockups are PMT) */
  allowPmtEdit: Scalars['Boolean']['output'];
  /** Price in currency */
  amountIn?: Maybe<Scalars['String']['output']>;
  /** Approval required */
  approvalRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Ask for Preference */
  askForPreference?: Maybe<Scalars['Boolean']['output']>;
  /** Ask for Preference Message */
  askForPreferenceMessage?: Maybe<Scalars['String']['output']>;
  /** Ask for restrictions */
  askForRestriction?: Maybe<Scalars['Boolean']['output']>;
  /** Has An Enabled Global Zone */
  availableGlobally: Scalars['Boolean']['output'];
  /** If warehouse products associated designed product discontinued */
  blankProductDiscontinued?: Maybe<Scalars['Boolean']['output']>;
  /** brand name or vendor by country or global zone */
  brand?: Maybe<Brand>;
  /** is bulk */
  bulkAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** Bundle Products info */
  bundleProducts?: Maybe<Array<BundleProduct>>;
  /** Bundle Products catalog types */
  bundleProductsCatalogTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** Bundle Products count */
  bundleProductsCount?: Maybe<Scalars['Int']['output']>;
  /** Bundle Zone */
  bundleZone?: Maybe<Scalars['String']['output']>;
  /** Can add product to shop */
  canAddToStore?: Maybe<Scalars['Boolean']['output']>;
  /** Can Approve Product */
  canApprove?: Maybe<Scalars['Boolean']['output']>;
  /** Can request bulk shipment */
  canBulkRequest?: Maybe<Scalars['Boolean']['output']>;
  /** Can Edit Product */
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  /** Can Restock Product */
  canRestock?: Maybe<Scalars['Boolean']['output']>;
  /** Canvas JSON assets for product mapping tool */
  canvasJsons?: Maybe<Array<DigitalAsset>>;
  /** Catalog of the product viewing */
  catalogStoreId?: Maybe<Scalars['ID']['output']>;
  /** Clip Print Area Customizer FE Enabled */
  clipPrintAreaCustomizerFeEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Hex code and color name mapping for PMT variants */
  colorHexMapping: Array<Array<Scalars['String']['output']>>;
  /** Color variants of product */
  colorOptionValues?: Maybe<Array<OptionValue>>;
  /** first few colors */
  colors?: Maybe<Array<Scalars['String']['output']>>;
  /** byo medley component product ids */
  componentProductIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Core On Demand */
  coreOnDemand?: Maybe<Scalars['Boolean']['output']>;
  /** Enabled Countries */
  countries?: Maybe<Array<Country>>;
  /** Current Catalog */
  currentCatalog?: Maybe<Catalog>;
  /** Catalog of the product viewing */
  currentCatalogExternalStoreId?: Maybe<Scalars['ID']['output']>;
  /** Current store id with product id */
  currentStoreIdWithId?: Maybe<Scalars['String']['output']>;
  /** Whether the product is customizable */
  customizable: Scalars['Boolean']['output'];
  /** Variant mockup data grouped by size and color */
  customizerData?: Maybe<Scalars['JSON']['output']>;
  /** Customizer Templates */
  customizerTemplates?: Maybe<Array<CustomizerTemplate>>;
  /** Customizer Themes Enabled */
  customizerThemesEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Unsaved Changes Warning Enabled */
  customizerUnsavedChangesWarningEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Decoration technique from the store product for the resolved store */
  decorationTechnique?: Maybe<Scalars['String']['output']>;
  /** All possible decoration techniques for this product (from mockups) */
  decorationTechniques: Array<Scalars['String']['output']>;
  /** Default Decoration Technique */
  defaultDecorationTechnique?: Maybe<Scalars['String']['output']>;
  /** description */
  description?: Maybe<Scalars['String']['output']>;
  /** Dietary Restrictions */
  dietaryRestrictions: Array<Taxon>;
  /** Discontinue On */
  discontinueOn?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** display brand name */
  displayBrand?: Maybe<Brand>;
  /** Display Brands */
  displayBrands?: Maybe<Scalars['Boolean']['output']>;
  /** Product specific DPI quality tiers */
  dpiQualityTiers?: Maybe<Scalars['JSON']['output']>;
  /** Lead */
  draftLead?: Maybe<Lead>;
  /** Eco Friendly */
  ecoFriendly: Scalars['Boolean']['output'];
  /** Embroidery product status */
  embroideryProduct: Scalars['Boolean']['output'];
  /** Shop enabled Taxon Ids */
  enabledTaxonIds: Array<Scalars['ID']['output']>;
  /** Estimated Item value */
  estimatedItemValue?: Maybe<Scalars['Float']['output']>;
  /** Font Colors */
  fontColors?: Maybe<Array<Array<Scalars['String']['output']>>>;
  /** Has Tier Pricing */
  hasTierPricing?: Maybe<Scalars['Boolean']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Ingredients */
  ingredients?: Maybe<Scalars['String']['output']>;
  /** Mockup Data for customizer */
  innerCanvasJsons?: Maybe<Array<DigitalAsset>>;
  /** type */
  intent?: Maybe<Scalars['String']['output']>;
  /** Whether to treat different sizes as customizable */
  isSizeCustomizable: Scalars['Boolean']['output'];
  /** Last Lead tracking number */
  leadTrackingNumber?: Maybe<Scalars['String']['output']>;
  /** Is product locked */
  locked?: Maybe<Scalars['Boolean']['output']>;
  /** Does this product belongs to users locker */
  lockerProduct: Scalars['Boolean']['output'];
  /**
   * Product mapping tool data with mockups, print areas,
   *                                                                   and automation coordinates
   */
  mappingToolData?: Maybe<Scalars['JSON']['output']>;
  /** Master Variant */
  masterVariant?: Maybe<Variant>;
  /** meta description */
  metaDescription?: Maybe<Scalars['String']['output']>;
  /** meta keywords */
  metaKeywords?: Maybe<Scalars['String']['output']>;
  /** meta title */
  metaTitle?: Maybe<Scalars['String']['output']>;
  /** minimum byo budget price */
  minimumByoBudgetPrice?: Maybe<Scalars['Float']['output']>;
  /** Mockup Styles */
  mockupStyles?: Maybe<Array<Scalars['String']['output']>>;
  /** Mockup Data for customizer */
  mockups?: Maybe<Array<Mockup>>;
  /** name */
  name?: Maybe<Scalars['String']['output']>;
  /** number */
  number?: Maybe<Scalars['String']['output']>;
  /** Only User Locker Product */
  onlyUserLockerProduct?: Maybe<Scalars['Boolean']['output']>;
  /** variants */
  optionTypes?: Maybe<Array<OptionType>>;
  /** Out of Stock */
  outOfStock?: Maybe<Scalars['Boolean']['output']>;
  /** Pastel URL */
  pastelUrl?: Maybe<Scalars['String']['output']>;
  /** True Price in currency */
  priceIn?: Maybe<Scalars['Float']['output']>;
  /** prices in points */
  prices?: Maybe<Array<Scalars['Float']['output']>>;
  /** Product specific print area configuration */
  printAreaConfig?: Maybe<Scalars['JSON']['output']>;
  /** Product catalog slug */
  productCatalogSlug?: Maybe<Scalars['String']['output']>;
  /** product details */
  productDetail?: Maybe<ProductDetail>;
  /** Prodution Days */
  productionDays?: Maybe<Scalars['Int']['output']>;
  /** Published at */
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether the product is purchasable */
  purchasable?: Maybe<Scalars['Boolean']['output']>;
  /** Quality Multiplier */
  qualityMultiplier?: Maybe<Scalars['Int']['output']>;
  /** raw description without html tags */
  rawDescription?: Maybe<Scalars['String']['output']>;
  /** Related Taxon */
  relatedTaxon?: Maybe<Taxon>;
  /** Report Images */
  reportsImage?: Maybe<Scalars['Attachment']['output']>;
  /** Selected Color Options for draft automated catalog */
  selectedColorOptionsForAutomatedDesign?: Maybe<Array<OptionValue>>;
  /** Selected for automated design */
  selectedForAutomatedDesign?: Maybe<Scalars['Boolean']['output']>;
  /** Serving Info */
  servingInfo?: Maybe<Scalars['String']['output']>;
  /** Shipped From Stadium */
  shippedFromStadium?: Maybe<Scalars['Boolean']['output']>;
  /** Shipped Separately */
  shippedSeparately?: Maybe<Scalars['Boolean']['output']>;
  /** whether to generate previews for the product */
  shouldFeGeneratePreview: Scalars['Boolean']['output'];
  /** whether to show print area overlay on customizer */
  shouldShowPrintAreaOverlay: Scalars['Boolean']['output'];
  /** Show discard warning on customizer */
  showDiscardWarning?: Maybe<Scalars['Boolean']['output']>;
  /** whether to expand print image to print area */
  showPrintAreaAsMockupPreview: Scalars['Boolean']['output'];
  /** Size chart */
  sizeChart?: Maybe<Scalars['String']['output']>;
  /** Size chart enabled */
  sizeChartEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Size chart link */
  sizeChartLink?: Maybe<Scalars['String']['output']>;
  /** slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** state */
  state?: Maybe<Scalars['String']['output']>;
  /** Bundle Store */
  store?: Maybe<Store>;
  /** Store number */
  storeNumber?: Maybe<Scalars['String']['output']>;
  /** Store Product for a store */
  storeProduct?: Maybe<StoreProduct>;
  /** Sustainable */
  sustainable: Scalars['Boolean']['output'];
  /** taxons */
  taxons?: Maybe<Array<Taxon>>;
  /** Themes associated with CTs of this product */
  themes?: Maybe<Array<Theme>>;
  /** track inventory */
  trackInventory?: Maybe<Scalars['Boolean']['output']>;
  /** type */
  type?: Maybe<Scalars['String']['output']>;
  /** us only */
  usOnly?: Maybe<Scalars['Boolean']['output']>;
  /** User */
  user?: Maybe<User>;
  /** Print types with display true */
  validPrintTypes?: Maybe<Array<Print>>;
  /** Variant Images */
  variantImages?: Maybe<Array<Scalars['Attachment']['output']>>;
  /** Apply MOQ per variant (SKU) */
  variantLevelCommerce: Scalars['Boolean']['output'];
  /** variants */
  variantsIncludingMaster?: Maybe<Array<VariantResource>>;
  /** vendor by country */
  vendorByCountry?: Maybe<Vendor>;
  /** vendor by country or global zone */
  vendorByCountryOrGlobalZone?: Maybe<Vendor>;
  /** Vendors */
  vendors?: Maybe<Array<Vendor>>;
  /** all eligible vendors by country */
  vendorsByCountryOrGlobalZone?: Maybe<Array<Vendor>>;
  /** Warehouse product metadata */
  warehouseProductMetadata?: Maybe<WarehouseProductMetadata>;
};


/** Product */
export type ProductAmountInArgs = {
  currency: Scalars['String']['input'];
};


/** Product */
export type ProductBrandArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  globalZone?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Product */
export type ProductBundleProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Product */
export type ProductColorOptionValuesArgs = {
  isDummy?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** Product */
export type ProductColorsArgs = {
  number: Scalars['Int']['input'];
  storeCode?: InputMaybe<Scalars['String']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** Product */
export type ProductCustomizableArgs = {
  storeCode?: InputMaybe<Scalars['String']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** Product */
export type ProductCustomizerDataArgs = {
  storeCode?: InputMaybe<Scalars['String']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** Product */
export type ProductCustomizerTemplatesArgs = {
  storeCode?: InputMaybe<Scalars['String']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** Product */
export type ProductDecorationTechniqueArgs = {
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** Product */
export type ProductEnabledTaxonIdsArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  globalZone?: InputMaybe<Scalars['Boolean']['input']>;
  menuId?: InputMaybe<Scalars['ID']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** Product */
export type ProductInnerCanvasJsonsArgs = {
  storeCode?: InputMaybe<Scalars['String']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** Product */
export type ProductLockedArgs = {
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** Product */
export type ProductMockupsArgs = {
  includeDisabledMockups?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Product */
export type ProductOptionTypesArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


/** Product */
export type ProductPriceInArgs = {
  currency: Scalars['String']['input'];
};


/** Product */
export type ProductPricesArgs = {
  currency: Scalars['String']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
};


/** Product */
export type ProductReportsImageArgs = {
  productStoreMapping: Scalars['JSON']['input'];
};


/** Product */
export type ProductSelectedColorOptionsForAutomatedDesignArgs = {
  number: Scalars['String']['input'];
};


/** Product */
export type ProductSelectedForAutomatedDesignArgs = {
  number: Scalars['String']['input'];
};


/** Product */
export type ProductStoreProductArgs = {
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** Product */
export type ProductThemesArgs = {
  storeCode?: InputMaybe<Scalars['String']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** Product */
export type ProductVariantImagesArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** Product */
export type ProductVariantsIncludingMasterArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  includeInactiveVariants?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  viewingInsideByoMedley?: InputMaybe<Scalars['Boolean']['input']>;
  withOutOfStock?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Product */
export type ProductVendorByCountryArgs = {
  country: Scalars['String']['input'];
};


/** Product */
export type ProductVendorByCountryOrGlobalZoneArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  globalZone?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Product */
export type ProductVendorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Product */
export type ProductVendorsByCountryOrGlobalZoneArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  globalZone?: InputMaybe<Scalars['Boolean']['input']>;
};

/** product details */
export type ProductDetail = {
  __typename?: 'ProductDetail';
  /** order instructions */
  orderInstructions?: Maybe<Scalars['String']['output']>;
  /** print type ids */
  printTypeIds?: Maybe<Array<Scalars['Int']['output']>>;
};

/** Product Type */
export type ProductType = {
  __typename?: 'ProductType';
  /** ID */
  id: Scalars['ID']['output'];
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
  /** Associated Taxon */
  taxon?: Maybe<Taxon>;
  /** Associated Taxon ID */
  taxonId?: Maybe<Scalars['ID']['output']>;
};

export type Program = {
  __typename?: 'Program';
  admin: Scalars['Boolean']['output'];
  allHashtags?: Maybe<Array<Scalars['String']['output']>>;
  allowWithoutPoints: Scalars['Boolean']['output'];
  amount?: Maybe<Scalars['Int']['output']>;
  attachMonetaryValue: Scalars['Boolean']['output'];
  availableCredits?: Maybe<Scalars['Int']['output']>;
  /** Available cycle options with their date ranges */
  availableCycleOptions: Array<CycleOption>;
  companyValues?: Maybe<Array<CompanyValue>>;
  companyValuesRequired: Scalars['Boolean']['output'];
  completed: Scalars['Boolean']['output'];
  contactExistWithPositiveNewAmount: Scalars['Boolean']['output'];
  contactFilters?: Maybe<Scalars['Hash']['output']>;
  contactsAmount?: Maybe<Scalars['Int']['output']>;
  contactsNewAmount?: Maybe<Scalars['Int']['output']>;
  conversionRate?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateType']['output']>;
  creatorEmail: Scalars['String']['output'];
  creatorId: Scalars['Int']['output'];
  currencyName?: Maybe<Scalars['String']['output']>;
  customContactNewAmounts?: Maybe<Array<Scalars['Int']['output']>>;
  cycleEndAt?: Maybe<Scalars['DateType']['output']>;
  cycleStartAt?: Maybe<Scalars['DateType']['output']>;
  defaultKudos?: Maybe<Scalars['Int']['output']>;
  dynamicOrderFailed?: Maybe<Scalars['Boolean']['output']>;
  /** Preview order for contact changes based on new filters */
  dynamicOrderSummary?: Maybe<DynamicOrderSummary>;
  failedDynamicOrderData?: Maybe<ProgramOrder>;
  formState?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  generalConfig?: Maybe<Scalars['Hash']['output']>;
  id: Scalars['ID']['output'];
  includesCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  incompleteOrder?: Maybe<ProgramOrder>;
  integrationNotificationDisabled: Scalars['Boolean']['output'];
  manual?: Maybe<Scalars['Boolean']['output']>;
  msTeamsChannel?: Maybe<MsTeamsChannel>;
  msTeamsInstallDeepLink?: Maybe<Scalars['String']['output']>;
  msTeamsIntegrated: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  newAmount?: Maybe<Scalars['Int']['output']>;
  newFrequency?: Maybe<Scalars['String']['output']>;
  nextCycleStartAt?: Maybe<Scalars['DateType']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  orderSetting?: Maybe<OrderSetting>;
  pausedAt?: Maybe<Scalars['DateType']['output']>;
  pausedOrder?: Maybe<ProgramOrder>;
  pausedOrderNumber?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  /** User permissions for this program */
  permissions: Scalars['Hash']['output'];
  postFilters: PostFilters;
  provider?: Maybe<Scalars['String']['output']>;
  slackChannels?: Maybe<Array<SlackChannel>>;
  slackConfig?: Maybe<Scalars['Hash']['output']>;
  slackConnectUrl?: Maybe<Scalars['String']['output']>;
  slackIntegrated: Scalars['Boolean']['output'];
  stadiumPointsConversionRate?: Maybe<Scalars['Float']['output']>;
  startImmediately: Scalars['Boolean']['output'];
  startedAt?: Maybe<Scalars['DateType']['output']>;
  status: Scalars['String']['output'];
  teamsConfig?: Maybe<Scalars['Hash']['output']>;
  totalPointsPurchased?: Maybe<Scalars['Int']['output']>;
  totalPointsUsed?: Maybe<Scalars['Int']['output']>;
  totalUsers?: Maybe<Scalars['Int']['output']>;
  upcomingOrderSummary?: Maybe<ProgramOrder>;
  user?: Maybe<User>;
  userFilters?: Maybe<Scalars['Hash']['output']>;
  userStats: UserStat;
  /** Total points received by the user in all cycles */
  userTotalRecognitionPointsReceived?: Maybe<Scalars['Int']['output']>;
  workspaceSlug?: Maybe<Scalars['String']['output']>;
};


export type ProgramDynamicOrderSummaryArgs = {
  contactFilters: Scalars['Hash']['input'];
  defaultKudos?: InputMaybe<Scalars['Int']['input']>;
  keepExistingContacts?: InputMaybe<Scalars['Boolean']['input']>;
  skipProgramOrder?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgramPostFiltersArgs = {
  hashtagLimit?: InputMaybe<Scalars['Int']['input']>;
  userLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type ProgramContact = {
  __typename?: 'ProgramContact';
  addedBy?: Maybe<User>;
  admin: Scalars['Boolean']['output'];
  amount: Scalars['Int']['output'];
  avatarUrl?: Maybe<Scalars['AttachmentType']['output']>;
  email: Scalars['String']['output'];
  enabledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeactivated: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  manageAll: Scalars['Boolean']['output'];
  manual: Scalars['Boolean']['output'];
  newAmount: Scalars['Int']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
  workspaceAdmin: Scalars['Boolean']['output'];
  workspaceRole?: Maybe<Scalars['String']['output']>;
};

export type ProgramContactList = {
  __typename?: 'ProgramContactList';
  meta: ListMeta;
  programContacts?: Maybe<Array<ProgramContact>>;
};

/** Autogenerated input type of ProgramContactsBulkUpdate */
export type ProgramContactsBulkUpdateInput = {
  attributes?: InputMaybe<Scalars['Hash']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  excludeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['Hash']['input']>;
  includeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  selectAllContacts?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
};

/** Autogenerated return type of ProgramContactsBulkUpdate. */
export type ProgramContactsBulkUpdatePayload = {
  __typename?: 'ProgramContactsBulkUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ProgramInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  attachMonetaryValue?: InputMaybe<Scalars['Boolean']['input']>;
  companyValuesRequired?: InputMaybe<Scalars['Boolean']['input']>;
  contactFilters?: InputMaybe<Scalars['Hash']['input']>;
  conversionRate?: InputMaybe<Scalars['Float']['input']>;
  currencyName?: InputMaybe<Scalars['String']['input']>;
  defaultKudos?: InputMaybe<Scalars['Int']['input']>;
  formState?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  keepExistingContacts?: InputMaybe<Scalars['Boolean']['input']>;
  manual?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newAmount?: InputMaybe<Scalars['Int']['input']>;
  newFrequency?: InputMaybe<Scalars['String']['input']>;
  orderSetting?: InputMaybe<OrderSettingInput>;
  startImmediately?: InputMaybe<Scalars['Boolean']['input']>;
  startedAt?: InputMaybe<Scalars['DateType']['input']>;
  startedAtWithZone?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramIntegration = {
  __typename?: 'ProgramIntegration';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  programId: Scalars['ID']['output'];
  programName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ProgramList = {
  __typename?: 'ProgramList';
  meta?: Maybe<ListMeta>;
  programs?: Maybe<Array<Program>>;
};

export type ProgramOrder = {
  __typename?: 'ProgramOrder';
  allowancePerUser?: Maybe<Scalars['String']['output']>;
  availableCredits?: Maybe<Scalars['String']['output']>;
  creditsUsed?: Maybe<Scalars['String']['output']>;
  estimatedTaxes?: Maybe<Scalars['Float']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  platformFee?: Maybe<Scalars['Float']['output']>;
  program?: Maybe<Program>;
  total?: Maybe<Scalars['Float']['output']>;
  totalCredits?: Maybe<Scalars['Int']['output']>;
  totalCreditsAmount?: Maybe<Scalars['Float']['output']>;
  totalPointsPurchased?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of Publish */
export type PublishInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create automted catalog or not */
  createAutomatedCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  /** Dummy Store Number */
  number: Scalars['String']['input'];
  /** Taxon Ids */
  taxonIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Autogenerated return type of Publish. */
export type PublishPayload = {
  __typename?: 'PublishPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Response */
  response: Response;
};

/** All queries */
export type Query = {
  __typename?: 'Query';
  /** All admins of users company */
  accountAdmins?: Maybe<UserList>;
  /** The user's addresses */
  addresses: Array<Address>;
  /** The admin data */
  admin?: Maybe<Admin>;
  /** The user's teams that are not approved */
  approvalRequiredTeams: Array<Team>;
  /** Asset library kinds */
  assetLibraryKinds: Array<AssetLibraryKind>;
  /** The user's contacts selected for a particular program */
  assignedContacts: List;
  /** Associated store from a product and catalog */
  associatedStoreList?: Maybe<Array<StoreCatalog>>;
  /** Public blank bundle shop data */
  blankBundleShop?: Maybe<Store>;
  /** fetch bundle shop by shop Number */
  bundleShop?: Maybe<Store>;
  /** Return users bundle shops */
  bundleShops?: Maybe<PaginatedCollection>;
  campaign?: Maybe<Campaign>;
  campaignConfig: CampaignConfig;
  /** the user's automations */
  campaigns: List;
  /** fetch catalog by number */
  catalog?: Maybe<Catalog>;
  /** Return catalog product list */
  catalogProducts: PaginatedCollection;
  /** Catalog url */
  catalogUrl: Scalars['String']['output'];
  /**
   * Return all catalogs of current
   * @deprecated Use paginatedCatalogs
   */
  catalogs?: Maybe<Array<Catalog>>;
  /** ChildCompany show */
  childCompany?: Maybe<ChildCompany>;
  /** Return color groups list */
  colorGroupList?: Maybe<Array<OptionGroup>>;
  /** Return color list */
  colorList?: Maybe<OptionType>;
  /** List of comments for a post */
  comments?: Maybe<CommentList>;
  /** The configuration data */
  config: Config;
  /** Saved contact filter view by id */
  contactFilterView?: Maybe<ContactFilterView>;
  /** Saved contact filter views for the current workspace user */
  contactFilterViews: Array<ContactFilterView>;
  /** Contact Filters Selected */
  contactFilters?: Maybe<ContactFilter>;
  /** The user's contacts */
  contacts: List;
  /** The user's contacts data */
  contactsList: ContactList;
  /** Return country list */
  countries: Array<Country>;
  /** The user's credit cards */
  creditCards: Array<CreditCard>;
  /** The user accessing the application */
  currentUser: User;
  /** User catalog collection store */
  currentUserCatalogCollectionStore?: Maybe<Store>;
  /** Current user primary locker catalog */
  currentUserLockerCatalog?: Maybe<Catalog>;
  /** Current workspace user */
  currentWorkspaceUser?: Maybe<WorkspaceUser>;
  /** Return custom domain */
  customDomain?: Maybe<CustomDomain>;
  /** List of deactivated workspace users */
  deactivatedWorkspaceUsers: DeactivatedWorkspaceUsersList;
  /** List of deactivating workspace users */
  deactivatingWorkspaceUsers: DeactivatedWorkspaceUsersList;
  /** The user's default address */
  defaultAddress?: Maybe<Address>;
  /** Designed Catalogs which requires any action */
  designedCatalogsList?: Maybe<Array<Catalog>>;
  /** Digital asset */
  digitalAsset?: Maybe<DigitalAsset>;
  /** paginated digital asset */
  digitalAssets?: Maybe<DigitalAssetConnection>;
  /** Draft automated catalog */
  draftAutomatedCatalog?: Maybe<Catalog>;
  /** Map of product id to whether that product is in the draft automated catalog */
  draftCatalogSelectedProductsPresence: Scalars['JSON']['output'];
  /** Cloudinary Generated URL of banner */
  dummyBanner: DummyBanner;
  /** fetch dummy store by number */
  dummyStore?: Maybe<DummyStore>;
  /** Email preferences of the current user */
  emailPreferences: Array<Preference>;
  /** Return Company Logos */
  fetchCompanyDetail?: Maybe<CompanyDetail>;
  /** Return logo */
  fetchLogo?: Maybe<Logo>;
  /** Return preview images */
  fetchPreview?: Maybe<PreviewRequest>;
  /** Fetch Lead */
  fetchWarehouseLead?: Maybe<Lead>;
  findProgramsByStoreNumber?: Maybe<ProgramList>;
  /** Force company workspace creation */
  forceCompanyWorkspaceCreation: Scalars['Boolean']['output'];
  /** Get workspace slug by workspace ID */
  getWorkspaceSlug?: Maybe<WorkspaceSlug>;
  /** List of Hashtags for a program */
  hashtags?: Maybe<Array<Hashtag>>;
  /** List of Hashtags Suggestions */
  hashtagsSuggestions?: Maybe<Array<Hashtag>>;
  /** The import task */
  importTask?: Maybe<ImportTask>;
  /** All supported Integrations */
  integrations: Array<Integration>;
  /** The user's addresses */
  legacyAddresses: Array<Address>;
  /** Library Asset */
  libraryAsset?: Maybe<DigitalAsset>;
  /** Library Assets */
  libraryAssets?: Maybe<AssetLibraryPaginated>;
  /** Public locker shop data */
  lockerShop?: Maybe<Store>;
  /** Return locker sizes list */
  lockerSizes?: Maybe<OptionType>;
  /** Return locker taxon list */
  lockerTaxonList?: Maybe<Array<Taxon>>;
  /** Return marketing Categories list */
  marketingCategories: Array<MarketingCategory>;
  /** Return Marketing Catergory Object */
  marketingCategory?: Maybe<MarketingCategory>;
  /** Masked fields */
  maskedFields?: Maybe<Array<Scalars['String']['output']>>;
  /** Return a menu */
  menu?: Maybe<Menu>;
  mostRecognizedUsers?: Maybe<Array<UserStat>>;
  mostRecognizedUsersWithFilters?: Maybe<MostRecognizedUsers>;
  msTeamsChannel?: Maybe<MsTeamsChannel>;
  /** On Demand Designs */
  onDemandDesignsList?: Maybe<Array<Catalog>>;
  /** Returns attribute types visible on FE ordered by position */
  orderedAttributeTypes: Array<AttributeType>;
  /** Package Feature list */
  packageFeatures: Array<PackageFeature>;
  /** Package list */
  packageList: Array<Package>;
  /** Package show */
  packageShow?: Maybe<Package>;
  /** Return catalogs of current user */
  paginatedCatalogs?: Maybe<PaginatedCollection>;
  /** Paginated draft products for a draft_automated_mockups catalog (from metadata selected_products) */
  paginatedDraftCatalogProducts?: Maybe<PaginatedDraftCatalogProducts>;
  /** Saved Designs */
  paginatedSavedDesigns?: Maybe<PaginatedCollection>;
  /** Return store list */
  paginatedStores?: Maybe<PaginatedCollection>;
  /** Return current user logos */
  paginatedUserLogosList?: Maybe<PaginatedCollection>;
  /** The user's pending team invitations */
  pendingInvitations: Array<Invitation>;
  /** Permission exists for user */
  permissible?: Maybe<Scalars['Boolean']['output']>;
  /** All Permissions of user */
  permissionsList?: Maybe<Array<Scalars['String']['output']>>;
  /** Return store list */
  pinnedStores?: Maybe<Array<Store>>;
  post?: Maybe<Post>;
  /** List of recipients of post */
  postRecipients?: Maybe<Array<Mention>>;
  /** List of posts for a program */
  posts?: Maybe<PostList>;
  /** Return a product */
  product?: Maybe<Product>;
  /** Return product list */
  products: Array<Product>;
  program?: Maybe<Program>;
  /** List of contacts in a program */
  programContacts: ProgramContactList;
  programOrder?: Maybe<ProgramOrder>;
  /** list of user's programs */
  programs: ProgramList;
  /** List of all program integrations */
  programsIntegrations: Array<ProgramIntegration>;
  /** List all the channels of the ms teams team of program */
  programsMsTeamsAllChannels?: Maybe<Array<MsTeamsChannel>>;
  /** List of active quests */
  questsInfo?: Maybe<QuestsInfo>;
  reactions?: Maybe<Array<Reaction>>;
  /** Return product list */
  reportsProducts: Array<Product>;
  /** Returns creators of resources for current user */
  resourceCreators: Array<User>;
  /**
   * History of reward points earned or spent
   * @deprecated To be depriciated with stadium Rewards FE
   */
  rewardPointsHistory: RewardPointsHistoryConnection;
  /** History of reward points earned or spent */
  rewardPointsTransactions: RewardPointsHistoryConnection;
  /**
   * Saved Designs
   * @deprecated use paginatedSavedDesignsList instead
   */
  savedDesignsList?: Maybe<Array<Catalog>>;
  /** The user's searched contacts */
  searchContacts: List;
  selectedCampaignContacts?: Maybe<Array<Scalars['Int']['output']>>;
  selectedCampaignContactsByEmails?: Maybe<Array<Scalars['String']['output']>>;
  /** Shipping SLA configuration per product type */
  shippingSlaSettings: Array<ShippingSlaSettings>;
  slackTeam?: Maybe<SlackTeam>;
  slackUser?: Maybe<SlackUser>;
  /** Return a store */
  store?: Maybe<Store>;
  /** Return Store Products */
  storeProducts?: Maybe<Array<StoreProduct>>;
  /** Return store list */
  stores?: Maybe<Array<Store>>;
  /** Admin Info for swag store */
  swagStoreAdmins?: Maybe<Array<StoreUser>>;
  /** The user's active taste profile filters */
  tasteProfileFilters: TasteProfileFilter;
  /** Return product list */
  taxon: Taxon;
  /** Spree taxons data */
  taxons: Array<Taxon>;
  /** The user's team */
  team?: Maybe<Team>;
  /** Paginated list of team members */
  teamMembers: PaginatedTeamMembers;
  /** The user's teams */
  teams: Array<Team>;
  /** List of tiers with active rewards */
  tiers: Array<Tier>;
  /** Transactions history for current user for a company */
  transactionsList?: Maybe<TransactionDetailList>;
  /** Returns wallets (teams) where user is wallet owner, wallet admin, or default workspace wallet - applicable for transferring funds from */
  transferFromWallets: Array<Team>;
  /** Returns wallets (teams) where user is wallet owner, wallet admin, or default workspace wallet - applicable for transferring funds to */
  transferToWallets: Array<Team>;
  /** Fetch unavailable variants */
  unavailableVariants?: Maybe<Array<Variant>>;
  /** Paginated upcoming campaign orders */
  upcomingCampaignGifts: CampaignOrderList;
  /** Return details of a user */
  user?: Maybe<User>;
  /** Return all current user banners */
  userBannersList?: Maybe<Array<DigitalAsset>>;
  /** Return all current user logos */
  userLogosList?: Maybe<Array<Logo>>;
  /** Return Variant */
  variant?: Maybe<Variant>;
  /** Return product list */
  variants?: Maybe<Array<Variant>>;
  /** Return Vendor or Brand */
  vendorOrBrand?: Maybe<Entity>;
  /** returns vendors list */
  vendors?: Maybe<Array<Vendor>>;
  /** Warehouse product minimum price */
  warehouseProductMinPriceInDollars: Scalars['Float']['output'];
  /** Workspace */
  workspace?: Maybe<Workspace>;
  /** Workspace join request */
  workspaceJoinRequest?: Maybe<WorkspaceJoinRequest>;
  /** List of workspace join requests */
  workspaceJoinRequests: Array<WorkspaceJoinRequest>;
  /** List of all available workspace permissions */
  workspacePermissions: Array<WorkspacePermission>;
  /** List of resources owned by a workspace user with metadata */
  workspaceUserResources: WorkspaceUserResourcesList;
  /** List of wallet balances owned by a workspace user with metadata */
  workspaceUserWalletBalances: WorkspaceUserWalletBalancesList;
  /** Workspaces list */
  workspaces?: Maybe<Array<Workspace>>;
};


/** All queries */
export type QueryAccountAdminsArgs = {
  companyNumber: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['Hash']['input']>;
};


/** All queries */
export type QueryAdminArgs = {
  email: Scalars['String']['input'];
};


/** All queries */
export type QueryAssignedContactsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['Hash']['input']>;
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skipAggregations?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['Hash']['input']>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryAssociatedStoreListArgs = {
  shopType?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};


/** All queries */
export type QueryBundleShopArgs = {
  authorize?: InputMaybe<Scalars['Boolean']['input']>;
  bundleShopNumber: Scalars['String']['input'];
};


/** All queries */
export type QueryBundleShopsArgs = {
  createdByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


/** All queries */
export type QueryCampaignArgs = {
  number: Scalars['String']['input'];
};


/** All queries */
export type QueryCampaignsArgs = {
  filters?: InputMaybe<Scalars['Hash']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryCatalogArgs = {
  authorized?: InputMaybe<Scalars['Boolean']['input']>;
  draftAutomatedCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryCatalogProductsArgs = {
  page: Scalars['Int']['input'];
  perPage?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryCatalogsArgs = {
  createdByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  onlyArchived?: InputMaybe<Scalars['Boolean']['input']>;
  onlyLocker?: InputMaybe<Scalars['Boolean']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryChildCompanyArgs = {
  id: Scalars['ID']['input'];
};


/** All queries */
export type QueryColorGroupListArgs = {
  number?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryCommentsArgs = {
  commentId?: InputMaybe<Scalars['ID']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  postId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
};


/** All queries */
export type QueryContactFilterViewArgs = {
  id: Scalars['ID']['input'];
};


/** All queries */
export type QueryContactFiltersArgs = {
  sourceId: Scalars['Int']['input'];
  sourceType: Scalars['String']['input'];
};


/** All queries */
export type QueryContactsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['Hash']['input']>;
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skipAggregations?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['Hash']['input']>;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryContactsListArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  skipAggregations?: InputMaybe<Scalars['Boolean']['input']>;
};


/** All queries */
export type QueryCountriesArgs = {
  onlyUnrestricted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** All queries */
export type QueryCurrentWorkspaceUserArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryCustomDomainArgs = {
  domain: Scalars['String']['input'];
};


/** All queries */
export type QueryDeactivatedWorkspaceUsersArgs = {
  filters?: InputMaybe<Scalars['Hash']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryDeactivatingWorkspaceUsersArgs = {
  filters?: InputMaybe<Scalars['Hash']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryDigitalAssetArgs = {
  id: Scalars['Int']['input'];
};


/** All queries */
export type QueryDigitalAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  kind?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** All queries */
export type QueryDraftCatalogSelectedProductsPresenceArgs = {
  number: Scalars['String']['input'];
  productIds: Array<Scalars['Int']['input']>;
};


/** All queries */
export type QueryDummyBannerArgs = {
  bannerBackground: Scalars['String']['input'];
  bannerBackgroundImageType?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  logoBackground?: InputMaybe<Scalars['String']['input']>;
  logoId?: InputMaybe<Scalars['String']['input']>;
  removeBackgroundPattern?: InputMaybe<Scalars['Boolean']['input']>;
  removeLogo?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  textBackground?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryDummyStoreArgs = {
  number: Scalars['String']['input'];
};


/** All queries */
export type QueryFetchCompanyDetailArgs = {
  domain: Scalars['String']['input'];
  forceFetchAndUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};


/** All queries */
export type QueryFetchLogoArgs = {
  id: Scalars['String']['input'];
};


/** All queries */
export type QueryFetchPreviewArgs = {
  previewRequestNumber: Scalars['String']['input'];
};


/** All queries */
export type QueryFetchWarehouseLeadArgs = {
  number: Scalars['String']['input'];
};


/** All queries */
export type QueryFindProgramsByStoreNumberArgs = {
  storeNumber: Scalars['String']['input'];
};


/** All queries */
export type QueryGetWorkspaceSlugArgs = {
  uuid: Scalars['String']['input'];
};


/** All queries */
export type QueryHashtagsArgs = {
  minimumMentions?: InputMaybe<Scalars['Int']['input']>;
  programId: Scalars['ID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryHashtagsSuggestionsArgs = {
  includeAllCycles?: InputMaybe<Scalars['Boolean']['input']>;
  programId: Scalars['ID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryImportTaskArgs = {
  uuid: Scalars['String']['input'];
};


/** All queries */
export type QueryLibraryAssetArgs = {
  number: Scalars['String']['input'];
};


/** All queries */
export type QueryLibraryAssetsArgs = {
  addedBy?: InputMaybe<Array<Scalars['Int']['input']>>;
  kinds?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryMarketingCategoriesArgs = {
  atleastOneLiveStore?: InputMaybe<Scalars['Boolean']['input']>;
  includeRestrictions?: InputMaybe<Array<Scalars['String']['input']>>;
  onlyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


/** All queries */
export type QueryMarketingCategoryArgs = {
  slug: Scalars['String']['input'];
};


/** All queries */
export type QueryMenuArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  forceCache?: InputMaybe<Scalars['Boolean']['input']>;
  globalZone?: InputMaybe<Scalars['Boolean']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  isDesigner?: InputMaybe<Scalars['Boolean']['input']>;
  location: Scalars['String']['input'];
  storeCode?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['String']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryMostRecognizedUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  programId: Scalars['ID']['input'];
};


/** All queries */
export type QueryMostRecognizedUsersWithFiltersArgs = {
  endDate: Scalars['ISO8601DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  programId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
};


/** All queries */
export type QueryMsTeamsChannelArgs = {
  conversationId: Scalars['String']['input'];
  teamAadGroupId: Scalars['String']['input'];
};


/** All queries */
export type QueryPackageShowArgs = {
  id: Scalars['ID']['input'];
};


/** All queries */
export type QueryPaginatedCatalogsArgs = {
  createdByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  onlyArchived?: InputMaybe<Scalars['Boolean']['input']>;
  onlyLocker?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  perPage?: InputMaybe<Scalars['Int']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryPaginatedDraftCatalogProductsArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  iso?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


/** All queries */
export type QueryPaginatedSavedDesignsArgs = {
  createdByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeTransferredLockers?: InputMaybe<Scalars['Boolean']['input']>;
  onlyArchived?: InputMaybe<Scalars['Boolean']['input']>;
  onlySharedLocker?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


/** All queries */
export type QueryPaginatedStoresArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  catalogKind?: InputMaybe<Scalars['String']['input']>;
  createdByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  excludePriceless?: InputMaybe<Scalars['Boolean']['input']>;
  externalIds?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noCache?: InputMaybe<Scalars['Boolean']['input']>;
  onlyAdminRole?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryPaginatedUserLogosListArgs = {
  catalogNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


/** All queries */
export type QueryPermissibleArgs = {
  permissionKey: Scalars['String']['input'];
};


/** All queries */
export type QueryPinnedStoresArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  noCache?: InputMaybe<Scalars['Boolean']['input']>;
};


/** All queries */
export type QueryPostArgs = {
  postId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
};


/** All queries */
export type QueryPostRecipientsArgs = {
  postId: Scalars['ID']['input'];
};


/** All queries */
export type QueryPostsArgs = {
  filters?: InputMaybe<Scalars['Hash']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['ID']['input']>;
  programId: Scalars['ID']['input'];
};


/** All queries */
export type QueryProductArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  noCache?: InputMaybe<Scalars['Boolean']['input']>;
  privateAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryProductsArgs = {
  country: Scalars['String']['input'];
  externalIds?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  storeCode?: InputMaybe<Scalars['String']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
  taxons?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryProgramArgs = {
  id: Scalars['ID']['input'];
};


/** All queries */
export type QueryProgramContactsArgs = {
  excludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludeSelf?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Scalars['Hash']['input']>;
  includeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  programId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Hash']['input']>;
};


/** All queries */
export type QueryProgramOrderArgs = {
  number: Scalars['String']['input'];
};


/** All queries */
export type QueryProgramsArgs = {
  filters?: InputMaybe<Scalars['Hash']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryProgramsMsTeamsAllChannelsArgs = {
  programId: Scalars['ID']['input'];
};


/** All queries */
export type QueryReportsProductsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


/** All queries */
export type QueryResourceCreatorsArgs = {
  resourceType: Scalars['String']['input'];
};


/** All queries */
export type QueryRewardPointsHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** All queries */
export type QueryRewardPointsTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters: Array<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** All queries */
export type QuerySavedDesignsListArgs = {
  createdByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeTransferredLockers?: InputMaybe<Scalars['Boolean']['input']>;
  onlyArchived?: InputMaybe<Scalars['Boolean']['input']>;
  onlySharedLocker?: InputMaybe<Scalars['Boolean']['input']>;
};


/** All queries */
export type QuerySearchContactsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  excludeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['Hash']['input']>;
  includeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  previewSearch?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  selectAllContacts?: InputMaybe<Scalars['Boolean']['input']>;
  skipAggregations?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['Hash']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QuerySelectedCampaignContactsArgs = {
  contactIds: Array<Scalars['Int']['input']>;
  number: Scalars['String']['input'];
};


/** All queries */
export type QuerySelectedCampaignContactsByEmailsArgs = {
  emails: Array<Scalars['String']['input']>;
  number: Scalars['String']['input'];
};


/** All queries */
export type QuerySlackTeamArgs = {
  id: Scalars['ID']['input'];
};


/** All queries */
export type QuerySlackUserArgs = {
  id: Scalars['ID']['input'];
};


/** All queries */
export type QueryStoreArgs = {
  authorize?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  customDomainRoot?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  noCache?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  privateAttributes?: InputMaybe<Scalars['Boolean']['input']>;
};


/** All queries */
export type QueryStoreProductsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


/** All queries */
export type QueryStoresArgs = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  catalogKind?: InputMaybe<Scalars['String']['input']>;
  createdByIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  externalIds?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyAdminRole?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QuerySwagStoreAdminsArgs = {
  storeId: Scalars['Int']['input'];
  storeType?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryTaxonArgs = {
  name: Scalars['String']['input'];
};


/** All queries */
export type QueryTeamArgs = {
  teamId: Scalars['ID']['input'];
};


/** All queries */
export type QueryTeamMembersArgs = {
  filters?: InputMaybe<Scalars['Hash']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['Hash']['input']>;
  teamId: Scalars['ID']['input'];
};


/** All queries */
export type QueryTiersArgs = {
  filterBy?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryTransactionsListArgs = {
  companyNumber: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['Hash']['input']>;
};


/** All queries */
export type QueryUnavailableVariantsArgs = {
  catalogId: Scalars['Int']['input'];
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** All queries */
export type QueryUpcomingCampaignGiftsArgs = {
  campaignNumber: Scalars['String']['input'];
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Hash']['input']>;
};


/** All queries */
export type QueryUserArgs = {
  workspaceSlug?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryUserLogosListArgs = {
  catalogNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryVariantArgs = {
  id: Scalars['Int']['input'];
};


/** All queries */
export type QueryVariantsArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  externalSourceIds?: InputMaybe<Scalars['String']['input']>;
  privateAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  showDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  storeCode?: InputMaybe<Scalars['String']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** All queries */
export type QueryVendorOrBrandArgs = {
  key: Scalars['String']['input'];
};


/** All queries */
export type QueryVendorsArgs = {
  ids: Scalars['String']['input'];
};


/** All queries */
export type QueryWorkspaceArgs = {
  slug: Scalars['String']['input'];
};


/** All queries */
export type QueryWorkspaceJoinRequestArgs = {
  id: Scalars['ID']['input'];
};


/** All queries */
export type QueryWorkspaceJoinRequestsArgs = {
  status?: InputMaybe<WorkspaceJoinRequestStatus>;
};


/** All queries */
export type QueryWorkspaceUserResourcesArgs = {
  workspaceUserId: Scalars['ID']['input'];
};


/** All queries */
export type QueryWorkspaceUserWalletBalancesArgs = {
  workspaceUserId: Scalars['ID']['input'];
};


/** All queries */
export type QueryWorkspacesArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Quests information */
export type Quest = {
  __typename?: 'Quest';
  /** flexible/fixed */
  category: Scalars['String']['output'];
  /** Quest image to be used on eshop */
  eshopImage: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  /** purchase/social */
  kind: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  points: Scalars['Int']['output'];
  /** SM/SW/DSD..ETC */
  programType: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type QuestInput = {
  id: Scalars['ID']['input'];
};

export type QuestTransaction = {
  __typename?: 'QuestTransaction';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  points: Scalars['Int']['output'];
};

export type QuestTransactionInput = {
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of QuestTransactionNotified */
export type QuestTransactionNotifiedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of QuestTransactionNotified. */
export type QuestTransactionNotifiedPayload = {
  __typename?: 'QuestTransactionNotifiedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of QuestTransactionUpdate */
export type QuestTransactionUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: QuestTransactionInput;
};

/** Autogenerated return type of QuestTransactionUpdate. */
export type QuestTransactionUpdatePayload = {
  __typename?: 'QuestTransactionUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
};

export type QuestsInfo = {
  __typename?: 'QuestsInfo';
  completedQuestIds?: Maybe<Array<Scalars['ID']['output']>>;
  quests?: Maybe<Array<Quest>>;
};

/** Reaction Asset for post */
export type Reaction = {
  __typename?: 'Reaction';
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  shortCode: Scalars['String']['output'];
};

/** Autogenerated input type of ReactivateWorkspaceUser */
export type ReactivateWorkspaceUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  workspaceUserId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReactivateWorkspaceUser. */
export type ReactivateWorkspaceUserPayload = {
  __typename?: 'ReactivateWorkspaceUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  workspaceUser?: Maybe<WorkspaceUser>;
};

/** Autogenerated input type of RegenerateCampaignApiKey */
export type RegenerateCampaignApiKeyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
};

/** Autogenerated return type of RegenerateCampaignApiKey. */
export type RegenerateCampaignApiKeyPayload = {
  __typename?: 'RegenerateCampaignApiKeyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveAdminSeat */
export type RemoveAdminSeatInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveAdminSeat. */
export type RemoveAdminSeatPayload = {
  __typename?: 'RemoveAdminSeatPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<ChildCompany>;
  data?: Maybe<Scalars['Hash']['output']>;
};

/** Autogenerated input type of RemoveAllProgramSlackChannels */
export type RemoveAllProgramSlackChannelsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveAllProgramSlackChannels. */
export type RemoveAllProgramSlackChannelsPayload = {
  __typename?: 'RemoveAllProgramSlackChannelsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveContactsCampaign */
export type RemoveContactsCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  number: Scalars['String']['input'];
};

/** Autogenerated return type of RemoveContactsCampaign. */
export type RemoveContactsCampaignPayload = {
  __typename?: 'RemoveContactsCampaignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveMsTeamsChannel */
export type RemoveMsTeamsChannelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: MsTeamsChannelInput;
};

/** Autogenerated return type of RemoveMsTeamsChannel. */
export type RemoveMsTeamsChannelPayload = {
  __typename?: 'RemoveMsTeamsChannelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveOpenTeamInvitation */
export type RemoveOpenTeamInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  tokens: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of RemoveOpenTeamInvitation. */
export type RemoveOpenTeamInvitationPayload = {
  __typename?: 'RemoveOpenTeamInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveProductFromDraftAutomatedCatalog */
export type RemoveProductFromDraftAutomatedCatalogInput = {
  /** Catalog Number */
  catalogNumber: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Color Option Value ID */
  colorOptionValueId?: InputMaybe<Scalars['Int']['input']>;
  /** Global zone */
  globalZone?: InputMaybe<Scalars['Boolean']['input']>;
  /** Country ISO code */
  iso?: InputMaybe<Scalars['String']['input']>;
  /** Page number */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Items per page */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Product ID */
  productId?: InputMaybe<Scalars['Int']['input']>;
  /** Remove all products from catalog */
  removeAllProducts?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of RemoveProductFromDraftAutomatedCatalog. */
export type RemoveProductFromDraftAutomatedCatalogPayload = {
  __typename?: 'RemoveProductFromDraftAutomatedCatalogPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Products selected for designing */
  paginatedProducts?: Maybe<PaginatedDraftCatalogProducts>;
};

/** Autogenerated input type of RemoveProgramContact */
export type RemoveProgramContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveProgramContact. */
export type RemoveProgramContactPayload = {
  __typename?: 'RemoveProgramContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveProgramFromMsTeamsTeam */
export type RemoveProgramFromMsTeamsTeamInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveProgramFromMsTeamsTeam. */
export type RemoveProgramFromMsTeamsTeamPayload = {
  __typename?: 'RemoveProgramFromMsTeamsTeamPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveProgramSlackChannel */
export type RemoveProgramSlackChannelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['ID']['input'];
  slackId: Scalars['String']['input'];
};

/** Autogenerated return type of RemoveProgramSlackChannel. */
export type RemoveProgramSlackChannelPayload = {
  __typename?: 'RemoveProgramSlackChannelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveStoreAdmin */
export type RemoveStoreAdminInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Emails to be added */
  email: Scalars['String']['input'];
  /** Store code to identify store */
  number: Scalars['String']['input'];
};

/** Autogenerated return type of RemoveStoreAdmin. */
export type RemoveStoreAdminPayload = {
  __typename?: 'RemoveStoreAdminPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Response */
  response?: Maybe<Response>;
};

/** Autogenerated input type of RemoveTeamMember */
export type RemoveTeamMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberEmail: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveTeamMember. */
export type RemoveTeamMemberPayload = {
  __typename?: 'RemoveTeamMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
  team?: Maybe<Team>;
};

/** Autogenerated input type of RemoveWorkspaceUser */
export type RemoveWorkspaceUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  workspaceUserId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveWorkspaceUser. */
export type RemoveWorkspaceUserPayload = {
  __typename?: 'RemoveWorkspaceUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Scalars['JSON']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success?: Maybe<Scalars['Boolean']['output']>;
  workspace?: Maybe<Workspace>;
};

/** Autogenerated input type of ReorderUserContactProvider */
export type ReorderUserContactProviderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};

/** Autogenerated return type of ReorderUserContactProvider. */
export type ReorderUserContactProviderPayload = {
  __typename?: 'ReorderUserContactProviderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contactProviders?: Maybe<Array<ContactProvider>>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Attribtues for request mockup catalog creation */
export type RequestMockupCatalogInput = {
  /** Digital Asset Logo Id */
  logoId: Scalars['Int']['input'];
  /** Store Id */
  storeId: Scalars['Int']['input'];
  /** Variant details */
  variantDetails: Array<RequestMockupVariantInput>;
};

/** Attributes for customization detail while creating mockup_request catalog */
export type RequestMockupCustomizationDetailInput = {
  /** Decoration Method */
  decorationMethod?: InputMaybe<Scalars['String']['input']>;
  /** Logo placement */
  logoPlacement?: InputMaybe<Scalars['String']['input']>;
  /** Notes for designer */
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Attributes for variants while creating mockup_request catalog */
export type RequestMockupVariantInput = {
  /** Customization Detail */
  customizationDetail?: InputMaybe<RequestMockupCustomizationDetailInput>;
  /** Variant Id */
  variantId: Scalars['ID']['input'];
};

/** Autogenerated input type of ResetToDefault */
export type ResetToDefaultInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set to true to reset to default permissions */
  default: Scalars['Boolean']['input'];
  /** ID of the workspace user */
  workspaceUserId: Scalars['ID']['input'];
};

/** Autogenerated return type of ResetToDefault. */
export type ResetToDefaultPayload = {
  __typename?: 'ResetToDefaultPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  workspaceUser?: Maybe<WorkspaceUser>;
};

export type ResourceGroup = {
  __typename?: 'ResourceGroup';
  /** Metadata about this resource group */
  meta: ResourceGroupMeta;
  /** List of resources in this group */
  resources: Array<WorkspaceUserResource>;
};

export type ResourceGroupMeta = {
  __typename?: 'ResourceGroupMeta';
  /** Number of resources in this group */
  count: Scalars['Int']['output'];
  /** Type of the resources in this group (e.g., Product, Order) */
  type: Scalars['String']['output'];
};

/** Response of any mutation */
export type Response = {
  __typename?: 'Response';
  /** Entity */
  entity?: Maybe<Entity>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Success */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RestockWarehouseProduct */
export type RestockWarehouseProductInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Quantity */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Size Data */
  sizeData?: InputMaybe<SizeDataInput>;
  /** Tracking number */
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  /** WarehouseProductMetaData */
  warehouseProductMetadataAttributes?: InputMaybe<WarehouseProductMetadataInput>;
};

/** Autogenerated return type of RestockWarehouseProduct. */
export type RestockWarehouseProductPayload = {
  __typename?: 'RestockWarehouseProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Warehouse Product */
  warehouseProduct?: Maybe<Product>;
};

/** Autogenerated input type of RestoreCatalog */
export type RestoreCatalogInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Store number to identify store */
  number: Scalars['String']['input'];
};

/** Autogenerated return type of RestoreCatalog. */
export type RestoreCatalogPayload = {
  __typename?: 'RestoreCatalogPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Response */
  response: Response;
};

/** Autogenerated input type of ResyncUserContactProvider */
export type ResyncUserContactProviderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

/** Autogenerated return type of ResyncUserContactProvider. */
export type ResyncUserContactProviderPayload = {
  __typename?: 'ResyncUserContactProviderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contactProvider?: Maybe<ContactProvider>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Reward information */
export type Reward = {
  __typename?: 'Reward';
  amount: Scalars['Float']['output'];
  category: Category;
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  points: Scalars['Int']['output'];
  programCategory: Scalars['String']['output'];
  /** large image url */
  rectangleImage: Scalars['String']['output'];
  /** small image url */
  squareImage: Scalars['String']['output'];
  tier: Tier;
};

/** Reward points history information */
export type RewardPointsHistory = {
  __typename?: 'RewardPointsHistory';
  createdAt: Scalars['ISO8601Date']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  /** @deprecated To be depreciated with stadium rewards FE */
  event: Scalars['String']['output'];
  eventDescription: Scalars['String']['output'];
  eventName: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  orderNumber?: Maybe<Scalars['String']['output']>;
  points: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601Date']['output'];
};

/** The connection type for RewardPointsHistory. */
export type RewardPointsHistoryConnection = {
  __typename?: 'RewardPointsHistoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RewardPointsHistoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RewardPointsHistory>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RewardPointsHistoryEdge = {
  __typename?: 'RewardPointsHistoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RewardPointsHistory>;
};

/** Input type for reward redemption */
export type RewardRedeemInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  receiverName?: InputMaybe<Scalars['String']['input']>;
  rewardId: Scalars['Int']['input'];
  senderName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of RewardRedemption */
export type RewardRedemptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: RewardRedeemInput;
};

/** Autogenerated return type of RewardRedemption. */
export type RewardRedemptionPayload = {
  __typename?: 'RewardRedemptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type Role = {
  __typename?: 'Role';
  auth0RoleId?: Maybe<Scalars['String']['output']>;
  fusionauthRoleId?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export enum RoleTypes {
  Admin = 'admin',
  Member = 'member',
  NonMember = 'non_member',
  Owner = 'owner',
  Sender = 'sender',
  StadiumExpert = 'stadium_expert'
}

/** Input type for sender RLP message */
export type SenderRlpMessageInput = {
  content: Scalars['String']['input'];
  header: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
  stickerAltText?: InputMaybe<Scalars['String']['input']>;
  stickerId?: InputMaybe<Scalars['ID']['input']>;
  stickerUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceStatus = {
  __typename?: 'ServiceStatus';
  attemptCount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  initiator?: Maybe<User>;
  lastAttemptAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  requestUuid?: Maybe<Scalars['String']['output']>;
  serviceName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  toWorkspaceUser?: Maybe<WorkspaceUser>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  workspace: Workspace;
  workspaceUser: WorkspaceUser;
};

/** Autogenerated input type of SessionCreate */
export type SessionCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SessionCreate. */
export type SessionCreatePayload = {
  __typename?: 'SessionCreatePayload';
  channel?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
  uid?: Maybe<Scalars['String']['output']>;
  user?: Maybe<BasicUser>;
};

/** Autogenerated input type of SessionDelete */
export type SessionDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SessionDelete. */
export type SessionDeletePayload = {
  __typename?: 'SessionDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SetDefaultContactFilterView */
export type SetDefaultContactFilterViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactFilterViewId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of SetDefaultContactFilterView. */
export type SetDefaultContactFilterViewPayload = {
  __typename?: 'SetDefaultContactFilterViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
  workspaceUser?: Maybe<WorkspaceUser>;
};

/** Autogenerated input type of SetDefaultPermissions */
export type SetDefaultPermissionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** List of permissions to set as default */
  permissions: Array<Scalars['String']['input']>;
  /** UUID of the workspace */
  workspaceUuid: Scalars['String']['input'];
};

/** Autogenerated return type of SetDefaultPermissions. */
export type SetDefaultPermissionsPayload = {
  __typename?: 'SetDefaultPermissionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  /** Updated workspace */
  workspace?: Maybe<Workspace>;
};

/** Autogenerated input type of SetWorkspaceUserPermissions */
export type SetWorkspaceUserPermissionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Array of workspace permission keys to set */
  workspacePermissions: Array<Scalars['String']['input']>;
  /** ID of the workspace user */
  workspaceUserId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetWorkspaceUserPermissions. */
export type SetWorkspaceUserPermissionsPayload = {
  __typename?: 'SetWorkspaceUserPermissionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  workspaceUser?: Maybe<WorkspaceUser>;
};

/** Shipping SLA settings */
export type ShippingSlaSettings = {
  __typename?: 'ShippingSlaSettings';
  /** Number of expected delivery days */
  days: Scalars['Int']['output'];
  /** Display text with days interpolated */
  displayText: Scalars['String']['output'];
  /** Shipping SLA preference key */
  key: Scalars['String']['output'];
  /** Display text shown to the customer */
  text: Scalars['String']['output'];
};

/** Attribtues for SizeData */
export type SizeDataInput = {
  /** Size Inventory data */
  inventoryData?: InputMaybe<Array<SizeInventoryInput>>;
  /** Size Option Type Id */
  optionTypeId: Scalars['Int']['input'];
};

/** Attribtues for SizeInventory */
export type SizeInventoryInput = {
  /** Quantity */
  quantity: Scalars['Int']['input'];
  /** Size Id */
  sizeId?: InputMaybe<Scalars['ID']['input']>;
};

export type SlackChannel = {
  __typename?: 'SlackChannel';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slackId?: Maybe<Scalars['String']['output']>;
  slackTeamId?: Maybe<Scalars['String']['output']>;
  slackUserId?: Maybe<Scalars['String']['output']>;
};

/** Input type for slack channel */
export type SlackChannelInput = {
  configurationUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  slackId: Scalars['String']['input'];
  slackTeamId?: InputMaybe<Scalars['String']['input']>;
  slackUserId?: InputMaybe<Scalars['String']['input']>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type SlackPost = {
  __typename?: 'SlackPost';
  amount?: Maybe<Scalars['Int']['output']>;
  companyValues?: Maybe<Array<Scalars['String']['output']>>;
  mentions?: Maybe<Array<Scalars['String']['output']>>;
  message?: Maybe<Scalars['String']['output']>;
  messageWithMentionDisplayName?: Maybe<Scalars['String']['output']>;
  postId?: Maybe<Scalars['Int']['output']>;
  programId?: Maybe<Scalars['Int']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  recipients?: Maybe<Array<Scalars['String']['output']>>;
  slackChannelId?: Maybe<Scalars['String']['output']>;
  slackMessageTs?: Maybe<Scalars['String']['output']>;
  slackResponseUrl?: Maybe<Scalars['String']['output']>;
  slackTeamId?: Maybe<Scalars['String']['output']>;
  slackUserId?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tagsStr?: Maybe<Scalars['String']['output']>;
  threadTs?: Maybe<Scalars['String']['output']>;
  ts?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type SlackPostInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  companyValues?: InputMaybe<Array<Scalars['String']['input']>>;
  mentions?: InputMaybe<Array<Scalars['String']['input']>>;
  message?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  slackChannelId?: InputMaybe<Scalars['String']['input']>;
  slackMessageTs?: InputMaybe<Scalars['String']['input']>;
  slackResponseUrl?: InputMaybe<Scalars['String']['input']>;
  slackTeamId?: InputMaybe<Scalars['String']['input']>;
  slackUserId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsStr?: InputMaybe<Scalars['String']['input']>;
  threadTs?: InputMaybe<Scalars['String']['input']>;
  ts?: InputMaybe<Scalars['String']['input']>;
};

export type SlackTeam = {
  __typename?: 'SlackTeam';
  botId?: Maybe<Scalars['String']['output']>;
  botScopes: Array<Scalars['String']['output']>;
  botToken?: Maybe<Scalars['String']['output']>;
  botUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slackId: Scalars['String']['output'];
};

/** Input type for slack team */
export type SlackTeamInput = {
  botId?: InputMaybe<Scalars['String']['input']>;
  botScopes?: InputMaybe<Array<Scalars['String']['input']>>;
  botToken?: InputMaybe<Scalars['String']['input']>;
  botUserId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  slackId: Scalars['String']['input'];
};

export type SlackUser = {
  __typename?: 'SlackUser';
  id: Scalars['ID']['output'];
  scopes: Array<Scalars['String']['output']>;
  slackId: Scalars['String']['output'];
  teamId?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

/** Input type for slack user */
export type SlackUserInput = {
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
  slackId: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

/** Store/Moment/Eshops */
export type Store = {
  __typename?: 'Store';
  /** accessibility tools enabled for store */
  accessibilityEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** accessibility tools enabled for store for custom domain */
  accessibilityEnabledOnCustomDomain?: Maybe<Scalars['Boolean']['output']>;
  /** Accessible to current user */
  accessible: Scalars['Boolean']['output'];
  /** Accounts */
  account?: Maybe<Account>;
  /** Display as a locker shop */
  actAsLockerShop?: Maybe<Scalars['Boolean']['output']>;
  /** active */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** address */
  address?: Maybe<Scalars['String']['output']>;
  /** admins count */
  adminsCount?: Maybe<Scalars['Int']['output']>;
  /** Allowed locker products with global zone */
  allowGlobalLockerProducts?: Maybe<Scalars['Boolean']['output']>;
  /** Store current display and current user display currencies */
  availableDisplayCurrencies?: Maybe<Array<DisplayCurrency>>;
  /** Related banner */
  banner?: Maybe<DigitalAsset>;
  /** User email blacklisted */
  blacklisted: Scalars['Boolean']['output'];
  /** Branding & Theme Configuration */
  brandingTheme?: Maybe<StoreBrandingTheme>;
  /** Bundle for a country */
  bundle?: Maybe<Product>;
  /** bundle number */
  bundleNumber?: Maybe<Scalars['String']['output']>;
  /** bundle state */
  bundleState?: Maybe<Scalars['String']['output']>;
  /** Bundle Store Data */
  bundleStore?: Maybe<BundleStore>;
  /** Bundles */
  bundles?: Maybe<Array<Product>>;
  /** Cache key */
  cacheKey?: Maybe<Scalars['String']['output']>;
  /** Catalog */
  catalog?: Maybe<Catalog>;
  /** catalogs */
  catalogCache?: Maybe<CatalogCache>;
  /** Catalog Store Ids */
  catalogStoreIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** organizer emails which have visited catalogs */
  catalogVisitedOrganizers: Array<Scalars['String']['output']>;
  /** catalogs */
  catalogs?: Maybe<Array<Catalog>>;
  /** Clone ID */
  cloneId?: Maybe<Scalars['ID']['output']>;
  /** Cloning in Progress */
  cloningInProgress?: Maybe<Scalars['Boolean']['output']>;
  /** associated CMS pages */
  cmsPages?: Maybe<Array<CmsPage>>;
  /** unique code */
  code?: Maybe<Scalars['String']['output']>;
  /** Compressed Product Image */
  compressedProductImage?: Maybe<Scalars['Attachment']['output']>;
  /** Compressed Top Banner */
  compressedTopBanner?: Maybe<Scalars['Attachment']['output']>;
  /** Config */
  config: StoreConfig;
  /** contact phone */
  contactPhone?: Maybe<Scalars['String']['output']>;
  /** Status for a taxon with for_swag as true attached to this store */
  containsMerch: Scalars['Boolean']['output'];
  /** created at */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Store Creator */
  creator?: Maybe<User>;
  /** Store Creator Domain */
  creatorDomain?: Maybe<Scalars['String']['output']>;
  /** fiat/custom/priceless */
  currencyType?: Maybe<Scalars['String']['output']>;
  /** custom currency membership applied */
  customCurrencyAddon?: Maybe<Scalars['Boolean']['output']>;
  /** Store Custom Domain Enabled */
  customDomainEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Store Custom Domain */
  customDomainRoot?: Maybe<Scalars['String']['output']>;
  /** Store Custom Domain Url */
  customDomainUrl?: Maybe<Scalars['String']['output']>;
  /** Store Custom Domain Verified */
  customDomainVerified?: Maybe<Scalars['Boolean']['output']>;
  /** customer support email */
  customerSupportEmail?: Maybe<Scalars['String']['output']>;
  /** customizer logos, will be used to customize swag */
  customizerLogos?: Maybe<Array<Scalars['Attachment']['output']>>;
  /** default */
  default?: Maybe<Scalars['Boolean']['output']>;
  /** default country id */
  defaultCountryId?: Maybe<Scalars['Int']['output']>;
  /** default currency */
  defaultCurrency?: Maybe<Scalars['String']['output']>;
  /** default locale */
  defaultLocale?: Maybe<Scalars['String']['output']>;
  /** description */
  description?: Maybe<Scalars['String']['output']>;
  /** Display warehouse address for locker shop */
  displayWarehouseAddress?: Maybe<Scalars['Boolean']['output']>;
  /** Store Admins with Read only access */
  editAccessStoreAdmins: Array<User>;
  /** organizers who have visited edit catalogs */
  editCatalogVisitedOrganizers: Array<Scalars['String']['output']>;
  /** identify whether price rouding is enabled or not */
  enableCeilPrices?: Maybe<Scalars['Boolean']['output']>;
  /** Store does not have non swag magic store products */
  enabledGlobalCatalog?: Maybe<Scalars['Boolean']['output']>;
  /** Store has active, enabled products or not */
  enabledProductsPresent?: Maybe<Scalars['Boolean']['output']>;
  /** External ID */
  externalId?: Maybe<Scalars['ID']['output']>;
  /** facebook */
  facebook?: Maybe<Scalars['String']['output']>;
  /** favicon */
  favicon?: Maybe<Scalars['Attachment']['output']>;
  /** Frontend Store URL */
  feUrl: Scalars['String']['output'];
  /** Frontend Store URL with workspace slug */
  feUrlWithWorkspaceSlug: Scalars['String']['output'];
  /** Store Featured or not */
  featured?: Maybe<Scalars['Boolean']['output']>;
  /** First marketing Category */
  firstMarketingCategory?: Maybe<MarketingCategory>;
  /** Form states for store */
  formStates?: Maybe<Scalars['JSON']['output']>;
  /** hex code */
  hexCode?: Maybe<Scalars['String']['output']>;
  /** Hide Bulk Pricing */
  hideBulkPricing?: Maybe<Scalars['Boolean']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** instagram */
  instagram?: Maybe<Scalars['String']['output']>;
  /** Whether products of this store are customizable */
  isCustomizable: Scalars['Boolean']['output'];
  /** current user is store owner or not */
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  /** is subscribed */
  isSubscribed?: Maybe<Scalars['Boolean']['output']>;
  /** logo */
  logo?: Maybe<Scalars['Attachment']['output']>;
  /** logo file extension */
  logoType?: Maybe<Scalars['String']['output']>;
  /** mail from address */
  mailFromAddress?: Maybe<Scalars['String']['output']>;
  /** max price cap for products in priceless shop */
  maxPrice?: Maybe<Scalars['Float']['output']>;
  /** Memberships */
  membership: Membership;
  /** Return a menu */
  menu?: Maybe<Menu>;
  /** meta description */
  metaDescription?: Maybe<Scalars['String']['output']>;
  /** meta keywords */
  metaKeywords?: Maybe<Scalars['String']['output']>;
  /** min price cap for products in priceless shop */
  minPrice?: Maybe<Scalars['Float']['output']>;
  /** top banner for mobile view */
  mobileTopBanner?: Maybe<Scalars['Attachment']['output']>;
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
  /** new order notifications email */
  newOrderNotificationsEmail?: Maybe<Scalars['String']['output']>;
  /** Friendly Id */
  number: Scalars['String']['output'];
  /** Optimized Search Required */
  optimizedSearch?: Maybe<Scalars['Boolean']['output']>;
  /** Is shop owned by stadium */
  ownedByStadium: Scalars['Boolean']['output'];
  /** Parent object */
  parent?: Maybe<Store>;
  /** Parent ID */
  parentId?: Maybe<Scalars['ID']['output']>;
  /** Current user permissions for the store */
  permissions?: Maybe<Scalars['JSON']['output']>;
  /** Migration of Shop points to stadium points */
  pointsMigrationAllowed: Scalars['Boolean']['output'];
  /** Preview Image */
  previewImage?: Maybe<Scalars['Attachment']['output']>;
  /** Private Shop */
  private: Scalars['Boolean']['output'];
  /** Product Image */
  productImage?: Maybe<Scalars['Attachment']['output']>;
  /** whether to display variants as products or not */
  productsBroken?: Maybe<Scalars['Boolean']['output']>;
  /** whether the products creation is completed or not */
  productsCreationCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** Store frontend url link qr code */
  qrCodeImage?: Maybe<Scalars['Attachment']['output']>;
  /** Store Admins with Read only access */
  readAccessStoreAdmins: Array<User>;
  /** Restrict category widgets */
  restrictCategoryWidgets: Scalars['Boolean']['output'];
  /** seo robots */
  seoRobots?: Maybe<Scalars['String']['output']>;
  /** seo title */
  seoTitle?: Maybe<Scalars['String']['output']>;
  /** Shop code with workspace slug */
  shopCodeWithWorkspaceSlug?: Maybe<Scalars['String']['output']>;
  /** Shop Top Banner */
  shopTopBanner?: Maybe<Scalars['Attachment']['output']>;
  /** Type of Shop */
  shopType: Scalars['String']['output'];
  /** Show loader when cloning in progress */
  showLoader?: Maybe<Scalars['Boolean']['output']>;
  /** Show You might also like */
  showMoreFromThisBrand: Scalars['Boolean']['output'];
  /** Show More from this brand */
  showYouMightAlsoLike: Scalars['Boolean']['output'];
  /** state */
  state?: Maybe<Scalars['String']['output']>;
  /**  Store admins */
  storeAdmins: Array<User>;
  /** Store Detail */
  storeDetail?: Maybe<StoreDetail>;
  /** Locker Shop Store IDS */
  storeIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** store owners */
  storeOwners?: Maybe<Array<User>>;
  /** supported currencies */
  supportedCurrencies?: Maybe<Scalars['String']['output']>;
  /** supported locales */
  supportedLocales?: Maybe<Scalars['String']['output']>;
  /** Swag Only Shop enabled/disabled on store */
  swagOnlyShop?: Maybe<Scalars['Boolean']['output']>;
  /** verify if the products have been synced to ES or not */
  syncedToEs?: Maybe<Scalars['Boolean']['output']>;
  /** tagline */
  tagline?: Maybe<Scalars['String']['output']>;
  /** Taxon IDs */
  taxonIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Moment Shop Name */
  templateName?: Maybe<Scalars['String']['output']>;
  /** theme */
  theme?: Maybe<Scalars['String']['output']>;
  /** Theme details */
  themeDetails?: Maybe<Scalars['String']['output']>;
  /** top banner */
  topBanner?: Maybe<Scalars['Attachment']['output']>;
  /** twitter */
  twitter?: Maybe<Scalars['String']['output']>;
  /** unavailable products */
  unavailableBundleProducts?: Maybe<Array<BundleProduct>>;
  /** updated at */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** url */
  url?: Maybe<Scalars['String']['output']>;
  /** verify if the variants have been associated or not */
  variantsAssociated?: Maybe<Scalars['Boolean']['output']>;
  /** organizer emails which have visited */
  visitedOrganizers: Array<Scalars['String']['output']>;
  /** Working on Fallback or cloned actually */
  workingOnFallback?: Maybe<Scalars['Boolean']['output']>;
  /** Workspace ID */
  workspaceId?: Maybe<Scalars['String']['output']>;
};


/** Store/Moment/Eshops */
export type StoreAccessibilityEnabledArgs = {
  customDomainRoot?: InputMaybe<Scalars['String']['input']>;
};


/** Store/Moment/Eshops */
export type StoreBundleArgs = {
  country: Scalars['String']['input'];
  sendUsToNonUs?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Store/Moment/Eshops */
export type StoreCmsPagesArgs = {
  selectedTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


/** Store/Moment/Eshops */
export type StoreMenuArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  forceCache?: InputMaybe<Scalars['Boolean']['input']>;
  globalZone?: InputMaybe<Scalars['Boolean']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  isDesigner?: InputMaybe<Scalars['Boolean']['input']>;
  location: Scalars['String']['input'];
  storeCode?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['String']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** Store/Moment/Eshops */
export type StorePermissionsArgs = {
  dashboardPermissions?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Store/Moment/Eshops */
export type StoreTaxonIdsArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
};

/** Store Branding & Theme Configuration */
export type StoreBrandingTheme = {
  __typename?: 'StoreBrandingTheme';
  /** Theme Buttons */
  buttons: Scalars['Hash']['output'];
  /** Theme Colors */
  colors: Scalars['Hash']['output'];
  /** Theme Typography */
  typography: ThemeTypography;
};

/** Store Catalog */
export type StoreCatalog = {
  __typename?: 'StoreCatalog';
  /** All products added */
  allProductsAdded: Scalars['Boolean']['output'];
  /** Catalog */
  catalog: Catalog;
  /** created at */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Store */
  store: Store;
  /** Visibility */
  visible: Scalars['Boolean']['output'];
};

/** Store Config */
export type StoreConfig = {
  __typename?: 'StoreConfig';
  /** Currency Code */
  currencyCode?: Maybe<Scalars['String']['output']>;
  /** Currency factor */
  currencyFactor?: Maybe<Scalars['Int']['output']>;
  /** Currency Name */
  currencyName?: Maybe<Scalars['String']['output']>;
  /** Currency Prefix */
  currencyPrefix?: Maybe<Scalars['String']['output']>;
  /** Currency Suffix */
  currencySuffix?: Maybe<Scalars['String']['output']>;
  /** Custom Currency */
  customCurrency?: Maybe<Scalars['Boolean']['output']>;
  /** Display Currency ID */
  displayCurrencyId?: Maybe<Scalars['String']['output']>;
  /** Type */
  medleyPrices: Array<MedleyPrice>;
  /** Program Name */
  programName?: Maybe<Scalars['String']['output']>;
  /** Type */
  type: Scalars['String']['output'];
  /** Shop Upcharge */
  upcharge: Scalars['Float']['output'];
};

/** Store Detail */
export type StoreDetail = {
  __typename?: 'StoreDetail';
  /** Additional Billing Note (WYSIWYG) */
  additionalBillingNote?: Maybe<Scalars['String']['output']>;
  /** Allow all users to send items from this shop */
  allowAllUsersSendItems: Scalars['Boolean']['output'];
  /** Allow all users to send points from this shop */
  allowAllUsersSendPoints: Scalars['Boolean']['output'];
  /** Allow Corporate Billing on store */
  allowCorporateBilling: Scalars['Boolean']['output'];
  /** User consent to send points from storefront */
  allowSendPointsFromStorefront: Scalars['Boolean']['output'];
  /** User consent for customer showcase */
  allowToPublish: Scalars['Boolean']['output'];
  /** Store Analytics Tool Keys */
  analytics: Scalars['JSON']['output'];
  /** Audience */
  audience: Array<Scalars['String']['output']>;
  /** Available to All Recipients */
  availableToAll?: Maybe<Scalars['Boolean']['output']>;
  /** Visibility of Billing Note on Self Order */
  billingNoteOnSelfOrder: Scalars['Boolean']['output'];
  /** Billing Note Required */
  billingNoteRequired: Scalars['Boolean']['output'];
  /** Blacklisted countries */
  blacklistedCountries: Array<Scalars['String']['output']>;
  /** Blacklisted emails */
  blacklistedEmails: Array<Scalars['String']['output']>;
  /** Category Page */
  categoryPageJson?: Maybe<Scalars['JSON']['output']>;
  /** Celebrated By */
  celebratedBy: Array<Scalars['String']['output']>;
  /** Evergreen Shop */
  evergreenShop?: Maybe<Scalars['Boolean']['output']>;
  /** Hide Featured Menu */
  featuredMenuHidden?: Maybe<Scalars['Boolean']['output']>;
  /** Filter Location */
  filterLocation?: Maybe<Scalars['String']['output']>;
  /** Footer Text */
  footerText?: Maybe<Scalars['String']['output']>;
  /** Great For */
  greatFor?: Maybe<Scalars['String']['output']>;
  /** Hide Country Flags */
  hideCountryFlags: Scalars['Boolean']['output'];
  /** Hide Nav bar from Store */
  hideMenuBar: Scalars['Boolean']['output'];
  /** Hide Thank You Message placeholder */
  hideThankYouMessagePlaceholder?: Maybe<Scalars['Boolean']['output']>;
  /** Hide Thank You Message prompts for recipients */
  hideThankYouMessagePrompts?: Maybe<Scalars['Boolean']['output']>;
  /** Homepage */
  homepageJson?: Maybe<Scalars['JSON']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Long Description */
  longDescription?: Maybe<Scalars['String']['output']>;
  /** Mini Account Dropdown on Shop's FE */
  miniAccountDropdown: Scalars['Boolean']['output'];
  /** Nav Bar Theme Dark/Light */
  navBarTheme: Scalars['String']['output'];
  /** Enable New Routes on store */
  newRoutesEnabled: Scalars['Boolean']['output'];
  /** Pastel canvas id */
  pastelCanvasId?: Maybe<Scalars['String']['output']>;
  /** Pastel catalog url */
  pastelCatalogUrl?: Maybe<Scalars['String']['output']>;
  /** Pastel feedback url */
  pastelUrl?: Maybe<Scalars['String']['output']>;
  /** Product Page */
  productPageJson?: Maybe<Scalars['JSON']['output']>;
  /** Whether Shop is Searched Indexed or not */
  searchIndexed: Scalars['Boolean']['output'];
  /** Send to many enabled */
  sendToManyEnabled: Scalars['Boolean']['output'];
  /** Short Description */
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** Show Book a Call CTA on Shop */
  showBookACall: Scalars['Boolean']['output'];
  /** Show Category Images */
  showCategoryImages: Scalars['Boolean']['output'];
  /** Pomp Fee Enabled/Disabled on Shop */
  showPompFee: Scalars['Boolean']['output'];
  /** Tags */
  tags: Array<Scalars['String']['output']>;
  /** Template type */
  templateType?: Maybe<Scalars['String']['output']>;
  /** Thank you modal message */
  thankYouMessage?: Maybe<Scalars['String']['output']>;
  /** Thank you modal title */
  thankYouTitle?: Maybe<Scalars['String']['output']>;
  /** Whitelisted domains */
  whitelistedDomains: Array<Scalars['String']['output']>;
  /** Whitelisted emails */
  whitelistedEmails: Array<Scalars['String']['output']>;
  /** Restrict shop access to workspace members */
  workspaceAccessible: Scalars['Boolean']['output'];
};

/** Store Product */
export type StoreProduct = {
  __typename?: 'StoreProduct';
  /** Active */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Active status of catalog store product in shop */
  activeForShop?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not the store_product is broken */
  broken: Scalars['Boolean']['output'];
  /** Can request changes to the product */
  canRequestChanges: Scalars['Boolean']['output'];
  /** ID with store ID appended */
  catalogIdForShop?: Maybe<Scalars['ID']['output']>;
  /** Is created_by_ai or not */
  createdByAi: Scalars['Boolean']['output'];
  /** Product image */
  displayImage?: Maybe<Scalars['Attachment']['output']>;
  /** Dummy Cloudinary Id */
  dummyCloudinaryUrl?: Maybe<Scalars['String']['output']>;
  /** Variants with color and cloudinary urls */
  dummyVariantsData?: Maybe<Scalars['JSON']['output']>;
  /** Is embroidery product */
  embroidery?: Maybe<Scalars['Boolean']['output']>;
  /** Enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Print quality */
  printQuality?: Maybe<Scalars['String']['output']>;
  /** Is processing preview image */
  processingPreviewImage?: Maybe<Scalars['Boolean']['output']>;
  /** Store for this store product */
  store?: Maybe<Store>;
  /** Is upfront preview generated */
  upfrontPreviewGenerated?: Maybe<Scalars['Boolean']['output']>;
  /** Has Variant/s that is disabled at Top Level */
  variantDisabledAtTopLevel?: Maybe<Scalars['Boolean']['output']>;
};


/** Store Product */
export type StoreProductActiveForShopArgs = {
  number?: InputMaybe<Scalars['String']['input']>;
};


/** Store Product */
export type StoreProductCatalogIdForShopArgs = {
  number?: InputMaybe<Scalars['String']['input']>;
};

/** User object type */
export type StoreUser = {
  __typename?: 'StoreUser';
  /** Whether the store user is active or not */
  active: Scalars['Boolean']['output'];
  avatarUrl?: Maybe<Scalars['AttachmentType']['output']>;
  /** User can manage the object */
  canManage?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** User is admin of active company package */
  isActivePackageAdmin: Scalars['Boolean']['output'];
  /** User is admin of workspace */
  isWorkspaceAdmin?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** User can manage_all the stores */
  manageAll?: Maybe<Scalars['Boolean']['output']>;
  roleTitle?: Maybe<Scalars['String']['output']>;
  spreeId: Scalars['ID']['output'];
  /** User role in the current workspace */
  workspaceUserRole?: Maybe<Scalars['String']['output']>;
};

/** Store Variant */
export type StoreVariant = {
  __typename?: 'StoreVariant';
  /** Active Status */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Active for Shop Status */
  activeForShop?: Maybe<Scalars['Boolean']['output']>;
  /** Enabled status */
  enabled: Scalars['Boolean']['output'];
  /** Store Variant ID */
  id: Scalars['ID']['output'];
};


/** Store Variant */
export type StoreVariantActiveArgs = {
  number?: InputMaybe<Scalars['String']['input']>;
};


/** Store Variant */
export type StoreVariantActiveForShopArgs = {
  number?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Active or not */
  active: Scalars['Boolean']['output'];
  /** Package purchase amount */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Billing Address */
  billingAddress?: Maybe<Address>;
  /** Company Package ID */
  companyPackageId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Days left for subscription */
  daysLeft?: Maybe<Scalars['Int']['output']>;
  /** Package Discount */
  discount?: Maybe<Scalars['Float']['output']>;
  /** Subscription end date */
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Subscription renewal date */
  renewalDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Subscription renewal overdue */
  renewalOverdue?: Maybe<Scalars['Boolean']['output']>;
  /** Seat Discount */
  seatDiscount?: Maybe<Scalars['Float']['output']>;
  /** Subscription start date */
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Subscription status */
  status?: Maybe<Scalars['String']['output']>;
  /** Total amount including package cost and additional seats */
  totalAmountWithSeatsPurchased?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** User ID */
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Address */
export type SwagAddress = {
  __typename?: 'SwagAddress';
  /** Address Line 1 */
  address1?: Maybe<Scalars['String']['output']>;
  /** Address Line 2 */
  address2?: Maybe<Scalars['String']['output']>;
  /** Address Printable Image */
  addressImage?: Maybe<Scalars['Attachment']['output']>;
  /** Alternative Phone */
  alternativePhone?: Maybe<Scalars['String']['output']>;
  /** City */
  city?: Maybe<Scalars['String']['output']>;
  /** Company */
  company?: Maybe<Scalars['String']['output']>;
  /** Country */
  country?: Maybe<Country>;
  /** First Name */
  firstname?: Maybe<Scalars['String']['output']>;
  /** Formatted Address */
  formattedAddress?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Label */
  label?: Maybe<Scalars['String']['output']>;
  /** Last Name */
  lastname?: Maybe<Scalars['String']['output']>;
  /** Phone */
  phone?: Maybe<Scalars['String']['output']>;
  /** State Name */
  stateName?: Maybe<Scalars['String']['output']>;
  /** Zipcode */
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type TasteProfileFilter = {
  __typename?: 'TasteProfileFilter';
  taxons: Array<Taxon>;
};

/** Taxon */
export type Taxon = {
  __typename?: 'Taxon';
  backEndOnly: Scalars['Boolean']['output'];
  childIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** colored_icon */
  coloredIcon?: Maybe<Scalars['Attachment']['output']>;
  /** depth */
  depth?: Maybe<Scalars['Int']['output']>;
  /** descendant taxons */
  descendants?: Maybe<Array<Taxon>>;
  /** enabled */
  enabled: Scalars['Boolean']['output'];
  /** External ID */
  externalId?: Maybe<Scalars['String']['output']>;
  /** External Source */
  externalSource?: Maybe<Scalars['String']['output']>;
  /** show in eshop or not */
  forEshop: Scalars['Boolean']['output'];
  /** taxon for swag or not */
  forSwag: Scalars['Boolean']['output'];
  /** hide_from_nav */
  hideFromNav: Scalars['Boolean']['output'];
  /** icon */
  icon?: Maybe<Scalars['Attachment']['output']>;
  /** id */
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** lft */
  lft?: Maybe<Scalars['Int']['output']>;
  /** meta_description */
  metaDescription?: Maybe<Scalars['String']['output']>;
  /** meta_keywords */
  metaKeywords?: Maybe<Scalars['String']['output']>;
  /** meta_title */
  metaTitle?: Maybe<Scalars['String']['output']>;
  /** name */
  name: Scalars['String']['output'];
  nonUs: Scalars['Boolean']['output'];
  /** Parent Taxon */
  parent?: Maybe<Taxon>;
  /** parent_id */
  parentId?: Maybe<Scalars['ID']['output']>;
  /** permalink */
  permalink?: Maybe<Scalars['String']['output']>;
  /** position */
  position?: Maybe<Scalars['Int']['output']>;
  /** rgt */
  rgt?: Maybe<Scalars['Int']['output']>;
  /** taxon available for locker or not */
  showInLocker: Scalars['Boolean']['output'];
  showInTastePreferenceModal: Scalars['Boolean']['output'];
  /** taxonomy */
  taxonomy?: Maybe<Taxonomy>;
  /** taxonomy_id */
  taxonomyId?: Maybe<Scalars['ID']['output']>;
};

/** Taxonomy */
export type Taxonomy = {
  __typename?: 'Taxonomy';
  /** id */
  id: Scalars['ID']['output'];
  /** name */
  name: Scalars['String']['output'];
};

export type Team = {
  __typename?: 'Team';
  approvalRequiredMembers?: Maybe<Array<Invitation>>;
  autoTopUpLimits?: Maybe<Scalars['JSON']['output']>;
  completed: Scalars['Boolean']['output'];
  currencyCode?: Maybe<Scalars['String']['output']>;
  currentUserRole?: Maybe<Scalars['String']['output']>;
  defaultTeam: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isCurrentUserOwner: Scalars['Boolean']['output'];
  lowFundNotificationMembers?: Maybe<Array<Invitation>>;
  lowFundsNotifications?: Maybe<Scalars['JSON']['output']>;
  members?: Maybe<Array<Invitation>>;
  myWalletBalance?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  openInviteLink: Scalars['String']['output'];
  permissions?: Maybe<Scalars['JSON']['output']>;
  totalWalletBalance: Scalars['Float']['output'];
  unallocatedWalletBalance: Scalars['Float']['output'];
  walletCurrency?: Maybe<Scalars['String']['output']>;
};

export type TeamInput = {
  creatorRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  creatorRolesOther?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  giftPreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  giftPreferencesOther?: InputMaybe<Scalars['String']['input']>;
  memberEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of TeamInviteContacts */
export type TeamInviteContactsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  excludeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  includeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  selectAllContacts?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['ID']['input'];
};

/** Autogenerated return type of TeamInviteContacts. */
export type TeamInviteContactsPayload = {
  __typename?: 'TeamInviteContactsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of TeamInviteMembers */
export type TeamInviteMembersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberEmails: Array<Scalars['String']['input']>;
  teamId: Scalars['ID']['input'];
};

/** Autogenerated return type of TeamInviteMembers. */
export type TeamInviteMembersPayload = {
  __typename?: 'TeamInviteMembersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
  team?: Maybe<Team>;
};

export type TeamWallet = {
  __typename?: 'TeamWallet';
  currencyCode?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Theme = {
  __typename?: 'Theme';
  /** Colors added in this theme */
  colors: Array<Scalars['String']['output']>;
  /** Creation Time of the theme */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The unique identifier of the theme */
  id: Scalars['ID']['output'];
  /** The name of the theme */
  name: Scalars['String']['output'];
  /** Size for this theme */
  size: Scalars['String']['output'];
};

/** Theme Typography Configuration */
export type ThemeTypography = {
  __typename?: 'ThemeTypography';
  /** Font Families */
  fontFamilies: Scalars['Hash']['output'];
  /** Font Sizes */
  fontSizes: Scalars['Hash']['output'];
};

/** Tier information */
export type Tier = {
  __typename?: 'Tier';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  points: Scalars['Int']['output'];
  rewards: Array<Reward>;
};

/** Autogenerated input type of ToggleArchiveCatalog */
export type ToggleArchiveCatalogInput = {
  /** Archive */
  archive: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Catalog ID */
  id: Scalars['String']['input'];
};

/** Autogenerated return type of ToggleArchiveCatalog. */
export type ToggleArchiveCatalogPayload = {
  __typename?: 'ToggleArchiveCatalogPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Archive catalog response */
  response?: Maybe<Response>;
};

export type TransactionDetail = {
  __typename?: 'TransactionDetail';
  /** Amount */
  amount: Scalars['Float']['output'];
  /** Created At */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Additional data like Seats Count */
  data?: Maybe<TransactionDetailData>;
  /** Chargebee ID */
  displayChargebeeId?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Invoice Link */
  invoiceLink?: Maybe<Scalars['String']['output']>;
  /** Chargebee Invoice URL */
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  /** Paid At */
  paidAt: Scalars['ISO8601DateTime']['output'];
  /** Payment Method */
  paymentMethod?: Maybe<Scalars['String']['output']>;
  /** Transactionable - CompanyPackage or CompanyPackageFeatureAssignment */
  transactionable: Transactionable;
  /** User who is responsible for this transaction */
  user?: Maybe<User>;
};

export type TransactionDetailData = {
  __typename?: 'TransactionDetailData';
  /** No of Purchased Seats for this transaction */
  itemCount?: Maybe<Scalars['Int']['output']>;
};

export type TransactionDetailList = {
  __typename?: 'TransactionDetailList';
  meta: PaginationMetadata;
  transactions?: Maybe<Array<TransactionDetail>>;
};

/** Transactionable */
export type Transactionable = CompanyPackage | CompanyPackageFeatureAssignment;

/** Autogenerated input type of TransferWorkspaceOwnership */
export type TransferWorkspaceOwnershipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fromWorkspaceUserId: Scalars['ID']['input'];
  toWorkspaceUserId: Scalars['ID']['input'];
};

/** Autogenerated return type of TransferWorkspaceOwnership. */
export type TransferWorkspaceOwnershipPayload = {
  __typename?: 'TransferWorkspaceOwnershipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  serviceStatuses?: Maybe<Array<ServiceStatus>>;
  success: Scalars['Boolean']['output'];
  workspace?: Maybe<Workspace>;
};

/** Autogenerated input type of UninstallSlackApp */
export type UninstallSlackAppInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['String']['input'];
};

/** Autogenerated return type of UninstallSlackApp. */
export type UninstallSlackAppPayload = {
  __typename?: 'UninstallSlackAppPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UnlockPersonalWorkspace */
export type UnlockPersonalWorkspaceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UnlockPersonalWorkspace. */
export type UnlockPersonalWorkspacePayload = {
  __typename?: 'UnlockPersonalWorkspacePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  workspace?: Maybe<Workspace>;
};

/** Autogenerated input type of UpdateAssets */
export type UpdateAssetsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Name of library asset */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Notes of library asset */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Library Asset number */
  number: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateAssets. */
export type UpdateAssetsPayload = {
  __typename?: 'UpdateAssetsPayload';
  /** Library Asset */
  asset?: Maybe<DigitalAsset>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of UpdateCampaign */
export type UpdateCampaignInput = {
  campaign: CampaignInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
};

/** Autogenerated input type of UpdateCampaignMailerPreferences */
export type UpdateCampaignMailerPreferencesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: Scalars['Hash']['input'];
  number: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateCampaignMailerPreferences. */
export type UpdateCampaignMailerPreferencesPayload = {
  __typename?: 'UpdateCampaignMailerPreferencesPayload';
  campaign?: Maybe<Campaign>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of UpdateCampaign. */
export type UpdateCampaignPayload = {
  __typename?: 'UpdateCampaignPayload';
  campaign?: Maybe<Campaign>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateCatalog */
export type UpdateCatalogInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Catalog ID */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateCatalog. */
export type UpdateCatalogPayload = {
  __typename?: 'UpdateCatalogPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Update catalog response */
  response?: Maybe<Response>;
};

/** Autogenerated input type of UpdateChildCompanyStatus */
export type UpdateChildCompanyStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateChildCompanyStatus. */
export type UpdateChildCompanyStatusPayload = {
  __typename?: 'UpdateChildCompanyStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateCompanyValue */
export type UpdateCompanyValueInput = {
  add: Array<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['ID']['input'];
  remove: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateCompanyValue. */
export type UpdateCompanyValuePayload = {
  __typename?: 'UpdateCompanyValuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  program?: Maybe<Program>;
  success: Scalars['Boolean']['output'];
};

export type UpdateContact = {
  contact: ContactInput;
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of UpdateContactFilterView */
export type UpdateContactFilterViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: ContactFilterViewInput;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateContactFilterView. */
export type UpdateContactFilterViewPayload = {
  __typename?: 'UpdateContactFilterViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contactFilterView?: Maybe<ContactFilterView>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateContactResponse = {
  __typename?: 'UpdateContactResponse';
  contact?: Maybe<Contact>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateCustomContactFields */
export type UpdateCustomContactFieldsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fields: Array<CustomContactFieldInput>;
};

/** Autogenerated return type of UpdateCustomContactFields. */
export type UpdateCustomContactFieldsPayload = {
  __typename?: 'UpdateCustomContactFieldsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['Hash']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UpdateDefaultWorkspace */
export type UpdateDefaultWorkspaceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateDefaultWorkspace. */
export type UpdateDefaultWorkspacePayload = {
  __typename?: 'UpdateDefaultWorkspacePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

/** Autogenerated input type of UpdateDigitalAsset */
export type UpdateDigitalAssetInput = {
  /** Is approved by designer */
  approvedByDesigner?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Folder id */
  folderId?: InputMaybe<Scalars['ID']['input']>;
  /** Digital Asset id */
  id: Scalars['ID']['input'];
  /** Is user authorized */
  userAuthorized?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateDigitalAsset. */
export type UpdateDigitalAssetPayload = {
  __typename?: 'UpdateDigitalAssetPayload';
  /** Digital Asset */
  asset?: Maybe<DigitalAsset>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of UpdateDraftWarehouseProduct */
export type UpdateDraftWarehouseProductInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ColorDataInputType */
  colorData?: InputMaybe<OptionTypeValueHashInput>;
  /** Deletable image ids */
  deletableImageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id: Scalars['ID']['input'];
  /** Images */
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** Name */
  name: Scalars['String']['input'];
  /** Sell Price */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Quantity */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Size Data */
  sizeData?: InputMaybe<SizeDataInput>;
  /** Taxon Ids */
  taxonIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Tracking number */
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  /** WarehouseProductMetaData */
  warehouseProductMetadataAttributes?: InputMaybe<WarehouseProductMetadataInput>;
};

/** Autogenerated return type of UpdateDraftWarehouseProduct. */
export type UpdateDraftWarehouseProductPayload = {
  __typename?: 'UpdateDraftWarehouseProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Warehouse Product */
  warehouseProduct?: Maybe<Product>;
};

/** Autogenerated input type of UpdateDummyStore */
export type UpdateDummyStoreInput = {
  /** Destroying Banner */
  bannerDestroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Existing Banner Id */
  bannerId?: InputMaybe<Scalars['Int']['input']>;
  /** Banner metadata */
  bannerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create automted catalog or not */
  createAutomatedCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display Currency */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Logo file */
  logo?: InputMaybe<Scalars['Upload']['input']>;
  /** Destroying Logo */
  logoDestroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Existing Logo Id */
  logoId?: InputMaybe<Scalars['Int']['input']>;
  /** User authorized to use logos */
  logosAuthorized?: InputMaybe<Scalars['Boolean']['input']>;
  /** Max price for products in priceless shop in USD */
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Min price for products in priceless shop in USD */
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Number */
  number: Scalars['String']['input'];
  /** Taxon Ids */
  taxonIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Banner file */
  topBanner?: InputMaybe<Scalars['Upload']['input']>;
};

/** Autogenerated return type of UpdateDummyStore. */
export type UpdateDummyStorePayload = {
  __typename?: 'UpdateDummyStorePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Dummy Store */
  dummyStore?: Maybe<DummyStore>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Current User */
  user?: Maybe<User>;
};

/** Autogenerated input type of UpdateFeaturedSectionMenu */
export type UpdateFeaturedSectionMenuInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Country iso */
  country: Scalars['String']['input'];
  /** Menu Id to be set as featured section */
  menuId: Scalars['ID']['input'];
  /** Store number to identify store */
  number: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateFeaturedSectionMenu. */
export type UpdateFeaturedSectionMenuPayload = {
  __typename?: 'UpdateFeaturedSectionMenuPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Response */
  response: Response;
};

/** Autogenerated input type of Update */
export type UpdateInput = {
  /** Clone all attributes actually */
  actualClone?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allow all users to send items from this shop */
  allowAllUsersSendItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allow all users to send points from this shop */
  allowAllUsersSendPoints?: InputMaybe<Scalars['Boolean']['input']>;
  /** Existing banner id */
  bannerId?: InputMaybe<Scalars['String']['input']>;
  /** Banner metadata */
  bannerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Store code, to identify store */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Display Currency (STC/USD) */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Display Currency Id */
  displayCurrencyId?: InputMaybe<Scalars['String']['input']>;
  /** Enable whole number pricing */
  enableCeilPrices?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hides Featured Menu of store */
  featuredMenuHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update form states for store */
  formStates?: InputMaybe<Scalars['JSON']['input']>;
  /** Hide Bulk Pricing */
  hideBulkPricing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Logo file */
  logo?: InputMaybe<Scalars['Upload']['input']>;
  /** Destroying Logo */
  logoDestroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Existing logo id */
  logoId?: InputMaybe<Scalars['String']['input']>;
  /** User authorized to use logos */
  logosAuthorized?: InputMaybe<Scalars['Boolean']['input']>;
  /** Users who have visited the Edit Featured Products */
  markUserCatalogVisited?: InputMaybe<Scalars['Boolean']['input']>;
  /** Users who have visited the Edit Main Catalog */
  markUserEditCatalogVisited?: InputMaybe<Scalars['Boolean']['input']>;
  /** Users who have visited the Dashboard Guide */
  markUserVisited?: InputMaybe<Scalars['Boolean']['input']>;
  /** max price cap for products in priceless shop in USD */
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  /** min price cap for products in priceless shop in USD */
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Store number, to identify store */
  number?: InputMaybe<Scalars['String']['input']>;
  /** Pastel canvas id */
  pastelCanvasId?: InputMaybe<Scalars['String']['input']>;
  /** Pastel catalog url */
  pastelCatalogUrl?: InputMaybe<Scalars['String']['input']>;
  /** Pastel url */
  pastelUrl?: InputMaybe<Scalars['String']['input']>;
  /** Shop points converstion allowed */
  pointsMigrationAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** To display variants as products */
  productsBroken?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether Shop is Searched Indexed or not */
  searchIndexed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Pomp Fee Enabled/Disabled on Shop */
  showPompFee?: InputMaybe<Scalars['Boolean']['input']>;
  /** Swag Only Shop enabled/disabled on store */
  swagOnlyShop?: InputMaybe<Scalars['Boolean']['input']>;
  /** Top banner */
  topBanner?: InputMaybe<Scalars['Upload']['input']>;
  /** Destroying Top Banner */
  topBannerDestroy?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of Update. */
export type UpdatePayload = {
  __typename?: 'UpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Store */
  store?: Maybe<Store>;
};

/** Autogenerated input type of UpdatePost */
export type UpdatePostInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: PostInput;
  postId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdatePost. */
export type UpdatePostPayload = {
  __typename?: 'UpdatePostPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  post?: Maybe<Post>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateProductMapping */
export type UpdateProductMappingInput = {
  /** Whether to add product to automated catalog */
  addToAutomatedCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Default decoration technique for this product */
  defaultDecorationTechnique?: InputMaybe<Scalars['String']['input']>;
  /** Whether product is size customizable */
  isSizeCustomizable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mapping data grouped by size, decoration groups */
  mappingData: Scalars['JSON']['input'];
  /** Mockup IDs to be deleted */
  mockupsToBeDeleted?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Product ID */
  productId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateProductMapping. */
export type UpdateProductMappingPayload = {
  __typename?: 'UpdateProductMappingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Update product mapping response */
  response?: Maybe<Response>;
  /** Current user */
  user?: Maybe<User>;
};

/** Autogenerated input type of UpdateProgramContact */
export type UpdateProgramContactInput = {
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  newAmount?: InputMaybe<Scalars['Int']['input']>;
  programId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateProgramContact. */
export type UpdateProgramContactPayload = {
  __typename?: 'UpdateProgramContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  program?: Maybe<Program>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateProgram */
export type UpdateProgramInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  program: ProgramInput;
};

/** Autogenerated return type of UpdateProgram. */
export type UpdateProgramPayload = {
  __typename?: 'UpdateProgramPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  program?: Maybe<Program>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateSenderRlpMessage */
export type UpdateSenderRlpMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: SenderRlpMessageInput;
};

/** Autogenerated return type of UpdateSenderRlpMessage. */
export type UpdateSenderRlpMessagePayload = {
  __typename?: 'UpdateSenderRlpMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateShop */
export type UpdateShopInput = {
  /** Bundle Number to add/remove products from */
  bundleShopNumber: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Bundle name to update */
  name: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateShop. */
export type UpdateShopPayload = {
  __typename?: 'UpdateShopPayload';
  /** Bundle */
  bundleShop?: Maybe<Store>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateSlackPost */
export type UpdateSlackPostInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: SlackPostInput;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateSlackPost. */
export type UpdateSlackPostPayload = {
  __typename?: 'UpdateSlackPostPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  slackPost?: Maybe<SlackPost>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of UpdateStatus. */
export type UpdateStatusPayload = {
  __typename?: 'UpdateStatusPayload';
  errors: Array<Scalars['String']['output']>;
  workspaceJoinRequest?: Maybe<WorkspaceJoinRequest>;
};

/** Autogenerated input type of UpdateTeam */
export type UpdateTeamInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  markComplete?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
};

/** Autogenerated input type of UpdateTeamMemberPermission */
export type UpdateTeamMemberPermissionInput = {
  admin: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberEmail: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateTeamMemberPermission. */
export type UpdateTeamMemberPermissionPayload = {
  __typename?: 'UpdateTeamMemberPermissionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
  team?: Maybe<Team>;
};

/** Autogenerated return type of UpdateTeam. */
export type UpdateTeamPayload = {
  __typename?: 'UpdateTeamPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
  team?: Maybe<Team>;
};

/** Autogenerated input type of UpdateUserAddress */
export type UpdateUserAddressInput = {
  address: AddressInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateUserAddress. */
export type UpdateUserAddressPayload = {
  __typename?: 'UpdateUserAddressPayload';
  address?: Maybe<Address>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateUserContact */
export type UpdateUserContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contact: ContactInput;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateUserContact. */
export type UpdateUserContactPayload = {
  __typename?: 'UpdateUserContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateUserContactProvider */
export type UpdateUserContactProviderInput = {
  attributes?: InputMaybe<ContactProviderInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  publicToken?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateUserContactProvider. */
export type UpdateUserContactProviderPayload = {
  __typename?: 'UpdateUserContactProviderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contactProvider?: Maybe<ContactProvider>;
  contactProviders?: Maybe<Array<ContactProvider>>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateWarehouseProduct */
export type UpdateWarehouseProductInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Deletable image ids */
  deletableImageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id: Scalars['ID']['input'];
  /** Images */
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Sell Price */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Taxon Ids */
  taxonIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Tracking number */
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  /** WarehouseProductMetaData */
  warehouseProductMetadataAttributes?: InputMaybe<WarehouseProductMetadataInput>;
};

/** Autogenerated return type of UpdateWarehouseProduct. */
export type UpdateWarehouseProductPayload = {
  __typename?: 'UpdateWarehouseProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Warehouse Product */
  warehouseProduct?: Maybe<Product>;
};

/** User */
export type User = {
  __typename?: 'User';
  accountIds?: Maybe<Array<Scalars['ID']['output']>>;
  accounts?: Maybe<Array<MasterCompany>>;
  allProgramsCount?: Maybe<Scalars['Int']['output']>;
  /** Number of archived collections */
  archivedCatalogsCount?: Maybe<Scalars['Int']['output']>;
  atsContactProviders?: Maybe<Array<ContactProvider>>;
  /** Automated Catalog Banner Dismissed */
  automatedCatalogBannerDismissed?: Maybe<Scalars['Boolean']['output']>;
  /** Automated Catalog Footer Cart Guide Tour Viewed */
  automatedCatalogFooterCartGuideTourViewed?: Maybe<Scalars['Boolean']['output']>;
  /** Automated Catalog Guide Tour Viewed */
  automatedCatalogGuideTourViewed?: Maybe<Scalars['Boolean']['output']>;
  /** Automated Catalog Logo Drag Tooltip Viewed */
  automatedCatalogLogoDragTooltipViewed?: Maybe<Scalars['Boolean']['output']>;
  avatarUrl?: Maybe<Scalars['AttachmentType']['output']>;
  /** Bulk Swags present for user or not */
  bulkSwagsPresent?: Maybe<Scalars['Boolean']['output']>;
  childCompanies?: Maybe<Array<ChildCompany>>;
  company?: Maybe<MasterCompany>;
  companyName?: Maybe<Scalars['String']['output']>;
  contactFilters?: Maybe<Scalars['Hash']['output']>;
  contactProviders?: Maybe<Array<ContactProvider>>;
  corporateBilled: Scalars['Boolean']['output'];
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  crmContactProviders?: Maybe<Array<ContactProvider>>;
  /** Customizer Guide Tour Completed */
  customizerGuideTourCompleted?: Maybe<Scalars['Boolean']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  /** Deactivated in current workspace */
  deactivatedInCurrentWorkspace: Scalars['Boolean']['output'];
  defaultFeedProgramId?: Maybe<Scalars['Int']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  /** Count of non-draft, non-archived, non-locker Swag catalogs visible on the FE */
  designCatalogCount?: Maybe<Scalars['Int']['output']>;
  dialCode?: Maybe<Scalars['String']['output']>;
  displayRewardRules: Scalars['Boolean']['output'];
  /** Edit Access */
  editAccess?: Maybe<Scalars['Boolean']['output']>;
  /** Email */
  email: Scalars['String']['output'];
  favoriteProductIds?: Maybe<Array<Scalars['ID']['output']>>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  /** User has digital assets or not */
  hasDigitalAssets: Scalars['Boolean']['output'];
  /** User has locker products or not */
  hasLockerProduct: Scalars['Boolean']['output'];
  /** User has previously uploaded logos or not */
  hasUploadedLogos: Scalars['Boolean']['output'];
  /** ID */
  id: Scalars['ID']['output'];
  importTasks: Array<ImportTask>;
  integratedWith?: Maybe<Scalars['String']['output']>;
  /** User is admin of active company package */
  isActivePackageAdmin: Scalars['Boolean']['output'];
  /** User is contact or not */
  isContact: Scalars['Boolean']['output'];
  /** User has designer role or not */
  isDesigner: Scalars['Boolean']['output'];
  /** Is locker swag present for user or not */
  isLockerSwagPresent?: Maybe<Scalars['Boolean']['output']>;
  isMobileAppDropManager: Scalars['Boolean']['output'];
  /** Is on demand swag present for user or not */
  isOnDemandSwagPresent?: Maybe<Scalars['Boolean']['output']>;
  isSsoEnabled: Scalars['Boolean']['output'];
  /** Swag kits present for user or not */
  kitsPresent?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  ldSecureModeHash: Scalars['String']['output'];
  ldUserKey: Scalars['String']['output'];
  /** Bundles present for user or not */
  liveBundlePresent?: Maybe<Scalars['Boolean']['output']>;
  /** Number of live eshop */
  liveEshopStoreCount?: Maybe<Scalars['Int']['output']>;
  liveProgramsCount?: Maybe<Scalars['Int']['output']>;
  /** Locker swag list */
  lockerSwagList?: Maybe<Array<Catalog>>;
  /** Marketing Announcement Viewed */
  marketingAnnouncementViewed?: Maybe<Scalars['Boolean']['output']>;
  memberTeams?: Maybe<Array<Team>>;
  /** Memberships */
  membership: Membership;
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
  /** details of list of quest completed for confirmation modal */
  newlyCompletedQuests?: Maybe<Array<QuestTransaction>>;
  /** On demand swag list */
  onDemandSwagList?: Maybe<Array<Catalog>>;
  /** User`s pending reward points */
  pendingRewardPoints?: Maybe<Scalars['Int']['output']>;
  pendingWorkspacePoints: Scalars['Int']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  personalWorkspaceRestricted: Scalars['Boolean']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  /** Total number of User`s posts */
  postsCount: Scalars['Int']['output'];
  profile?: Maybe<UserProfile>;
  program?: Maybe<Program>;
  programMultipleUsersPostMessage: Scalars['Boolean']['output'];
  /** @deprecated Each workspace has different stadium points so use workspace_points instead */
  rewardPoints: Scalars['Int']['output'];
  /** User`s reward points in decimal */
  rewardPointsInDecimal?: Maybe<Scalars['Float']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  roleTitle?: Maybe<Scalars['String']['output']>;
  /** Eshops present for user or not */
  shopPresent?: Maybe<Scalars['Boolean']['output']>;
  slackIntegrated: Scalars['Boolean']['output'];
  /** User spree ID */
  spreeId: Scalars['ID']['output'];
  /** Swag Catalog Present for user or not */
  swagCatalogPresent?: Maybe<Scalars['Boolean']['output']>;
  /** Swag stores present for user or not */
  swagStorePresent?: Maybe<Scalars['Boolean']['output']>;
  walletBalance?: Maybe<Scalars['Float']['output']>;
  walletCurrency?: Maybe<Currency>;
  /** Warehouse for the user in a country */
  warehouse?: Maybe<Vendor>;
  workspacePoints: Scalars['Int']['output'];
  workspacesByDomainExists?: Maybe<Scalars['Boolean']['output']>;
};


/** User */
export type UserContactFiltersArgs = {
  sourceType?: InputMaybe<Scalars['String']['input']>;
};


/** User */
export type UserHasDigitalAssetsArgs = {
  kind?: InputMaybe<Scalars['String']['input']>;
};


/** User */
export type UserIsLockerSwagPresentArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};


/** User */
export type UserIsOnDemandSwagPresentArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};


/** User */
export type UserLockerSwagListArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};


/** User */
export type UserOnDemandSwagListArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};


/** User */
export type UserProgramArgs = {
  id: Scalars['String']['input'];
};


/** User */
export type UserWarehouseArgs = {
  country: Scalars['String']['input'];
};

/** Autogenerated input type of UserAllocateWorkspacePoints */
export type UserAllocateWorkspacePointsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Array of emails to exclude */
  excludedEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Notes for the allocation */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Points to allocate to the users */
  points: Scalars['Int']['input'];
  /** Search term to filter users */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  /** Select all users flag */
  selectAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mapping of user_id to email */
  userEmails?: InputMaybe<Array<UserEmailInput>>;
};

/** Autogenerated return type of UserAllocateWorkspacePoints. */
export type UserAllocateWorkspacePointsPayload = {
  __typename?: 'UserAllocateWorkspacePointsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Remaining unallocated workspace points after allocation */
  unallocatedWorkspacePoints?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UserChangePassword */
export type UserChangePasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: ChangePasswordInput;
};

/** Autogenerated return type of UserChangePassword. */
export type UserChangePasswordPayload = {
  __typename?: 'UserChangePasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Scalars['Hash']['output'];
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UserContactsAdd */
export type UserContactsAddInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactEmails: Scalars['String']['input'];
};

/** Autogenerated return type of UserContactsAdd. */
export type UserContactsAddPayload = {
  __typename?: 'UserContactsAddPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contacts: Array<Contact>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UserContactsRemove */
export type UserContactsRemoveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactEmails: Scalars['String']['input'];
};

/** Autogenerated return type of UserContactsRemove. */
export type UserContactsRemovePayload = {
  __typename?: 'UserContactsRemovePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contacts: Array<Contact>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UserCreate */
export type UserCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: UserInput;
};

/** Autogenerated input type of UserCreateOrUpdateAddress */
export type UserCreateOrUpdateAddressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: AddressInput;
};

/** Autogenerated return type of UserCreateOrUpdateAddress. */
export type UserCreateOrUpdateAddressPayload = {
  __typename?: 'UserCreateOrUpdateAddressPayload';
  address?: Maybe<Address>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of UserCreate. */
export type UserCreatePayload = {
  __typename?: 'UserCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UserDeleteAccount */
export type UserDeleteAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UserDeleteAccount. */
export type UserDeleteAccountPayload = {
  __typename?: 'UserDeleteAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UserDeleteAddress */
export type UserDeleteAddressInput = {
  addressId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UserDeleteAddress. */
export type UserDeleteAddressPayload = {
  __typename?: 'UserDeleteAddressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UserDownloadPersonalData */
export type UserDownloadPersonalDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UserDownloadPersonalData. */
export type UserDownloadPersonalDataPayload = {
  __typename?: 'UserDownloadPersonalDataPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Input type for user email mapping */
export type UserEmailInput = {
  /** User email */
  email: Scalars['String']['input'];
  /** User ID (optional, will be created via GRPC if not provided) */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input type for user */
export type UserInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  displayRewardRules?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastVisitedProgramId?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profileImage?: InputMaybe<Scalars['Upload']['input']>;
  programMultipleUsersPostMessage?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type UserList = {
  __typename?: 'UserList';
  meta: PaginationMetadata;
  users?: Maybe<Array<StoreUser>>;
};

/** User profile object type */
export type UserProfile = {
  __typename?: 'UserProfile';
  accountRelated: Scalars['Boolean']['output'];
  appOnboardingComplete: Scalars['Boolean']['output'];
  approvalSummaryMailerFrequency: Scalars['Int']['output'];
  autoTopUpAddFundsSeen: Scalars['Boolean']['output'];
  autoTopUpAmount?: Maybe<Scalars['Int']['output']>;
  autoTopUpMinBalance?: Maybe<Scalars['Int']['output']>;
  autoTopUpNotes?: Maybe<Scalars['String']['output']>;
  autoTopUpPaymentMethod?: Maybe<Scalars['String']['output']>;
  autoTopUpPaymentMethodId?: Maybe<Scalars['Int']['output']>;
  contactsShareAddress: Scalars['Boolean']['output'];
  contactsShareName: Scalars['Boolean']['output'];
  contactsSharePhoneNo: Scalars['Boolean']['output'];
  customAddOnsCount: Scalars['Int']['output'];
  customContactFields?: Maybe<Array<CustomContactField>>;
  defaultWorkspace?: Maybe<Workspace>;
  emailNotification: Scalars['Boolean']['output'];
  feedbackMailerSubscribed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastOrganizerOrderDate?: Maybe<Scalars['DateType']['output']>;
  lowFundsNotificationThreshold?: Maybe<Scalars['Int']['output']>;
  orderSpecific: Scalars['Boolean']['output'];
  organizerOrderCount: Scalars['Int']['output'];
  personalWorkspaceNudgeLastDismissedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  programAdminMailerNotifications: Scalars['Boolean']['output'];
  pushNotification: Scalars['Boolean']['output'];
  recipientOrderCount: Scalars['Int']['output'];
  rewardPoints: Scalars['Float']['output'];
  shopGuidedTourSeen: Scalars['Boolean']['output'];
  showSharedWalletAnnouncement: Scalars['Boolean']['output'];
  smsNotification: Scalars['Boolean']['output'];
  snackdropReminder: Scalars['Boolean']['output'];
  stashEverytimeOrderedMailerSubscribed: Scalars['Boolean']['output'];
  stashMonthlyEarningsMailerSubscribed: Scalars['Boolean']['output'];
  treatSummaryMailer?: Maybe<Scalars['String']['output']>;
  treatSummaryMailerFrequency: Scalars['Int']['output'];
  trendingMailerSubscribed: Scalars['Boolean']['output'];
};

/** Input type for user profile */
export type UserProfileInput = {
  accountRelated?: InputMaybe<Scalars['Boolean']['input']>;
  appOnboardingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  approvalSummaryMailerFrequency?: InputMaybe<Scalars['Int']['input']>;
  autoTopUpAddFundsSeen?: InputMaybe<Scalars['Boolean']['input']>;
  autoTopUpAmount?: InputMaybe<Scalars['Int']['input']>;
  autoTopUpMinBalance?: InputMaybe<Scalars['Int']['input']>;
  autoTopUpNotes?: InputMaybe<Scalars['String']['input']>;
  autoTopUpPaymentMethod?: InputMaybe<Scalars['String']['input']>;
  autoTopUpPaymentMethodId?: InputMaybe<Scalars['Int']['input']>;
  contactsShareAddress?: InputMaybe<Scalars['Boolean']['input']>;
  contactsShareName?: InputMaybe<Scalars['Boolean']['input']>;
  contactsSharePhoneNo?: InputMaybe<Scalars['Boolean']['input']>;
  dismissPersonalWorkspaceNudge?: InputMaybe<Scalars['Boolean']['input']>;
  emailNotification?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackMailerSubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  lowFundsNotificationThreshold?: InputMaybe<Scalars['Int']['input']>;
  orderSpecific?: InputMaybe<Scalars['Boolean']['input']>;
  programAdminMailerNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  pushNotification?: InputMaybe<Scalars['Boolean']['input']>;
  shopGuidedTourSeen?: InputMaybe<Scalars['Boolean']['input']>;
  showSharedWalletAnnouncement?: InputMaybe<Scalars['Boolean']['input']>;
  smsNotification?: InputMaybe<Scalars['Boolean']['input']>;
  snackdropReminder?: InputMaybe<Scalars['Boolean']['input']>;
  stashEverytimeOrderedMailerSubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  stashMonthlyEarningsMailerSubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  treatSummaryMailerFrequency?: InputMaybe<Scalars['Int']['input']>;
  trendingMailerSubscribed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of UserSendVerificationEmail */
export type UserSendVerificationEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UserSendVerificationEmail. */
export type UserSendVerificationEmailPayload = {
  __typename?: 'UserSendVerificationEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Scalars['Hash']['output'];
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UserSetDefaultAddress */
export type UserSetDefaultAddressInput = {
  addressId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UserSetDefaultAddress. */
export type UserSetDefaultAddressPayload = {
  __typename?: 'UserSetDefaultAddressPayload';
  addresses: Array<Address>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UserSetDefaultCreditCard */
export type UserSetDefaultCreditCardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UserSetDefaultCreditCard. */
export type UserSetDefaultCreditCardPayload = {
  __typename?: 'UserSetDefaultCreditCardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  creditCards: Array<CreditCard>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UserStadiumSetDefaultAddress */
export type UserStadiumSetDefaultAddressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UserStadiumSetDefaultAddress. */
export type UserStadiumSetDefaultAddressPayload = {
  __typename?: 'UserStadiumSetDefaultAddressPayload';
  addresses: Array<Address>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
};

/** User Program Stats for a cycle */
export type UserStat = {
  __typename?: 'UserStat';
  availablePoints: Scalars['Int']['output'];
  contactsAmount?: Maybe<Scalars['Int']['output']>;
  giveawayPointsReceived: Scalars['Float']['output'];
  recognitionsCount: Scalars['Int']['output'];
  stadiumPointsReceived: Scalars['Float']['output'];
  user: User;
};

/** Autogenerated input type of UserUpdateEmailPreferences */
export type UserUpdateEmailPreferencesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: Array<PreferenceInput>;
};

/** Autogenerated return type of UserUpdateEmailPreferences. */
export type UserUpdateEmailPreferencesPayload = {
  __typename?: 'UserUpdateEmailPreferencesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  emailPreferences: Array<Preference>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of UserUpdate */
export type UserUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: UserInput;
};

/** Autogenerated return type of UserUpdate. */
export type UserUpdatePayload = {
  __typename?: 'UserUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

/** Autogenerated input type of UserUpdateProfile */
export type UserUpdateProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: UserProfileInput;
};

/** Autogenerated return type of UserUpdateProfile. */
export type UserUpdateProfilePayload = {
  __typename?: 'UserUpdateProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

/** Autogenerated input type of UserUpdateTasteProfile */
export type UserUpdateTasteProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  taxonIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of UserUpdateTasteProfile. */
export type UserUpdateTasteProfilePayload = {
  __typename?: 'UserUpdateTasteProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ValidateCompanySubscription */
export type ValidateCompanySubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ValidateCompanySubscription. */
export type ValidateCompanySubscriptionPayload = {
  __typename?: 'ValidateCompanySubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error details if the request failed. */
  errors?: Maybe<Scalars['String']['output']>;
  /** The status of the subscription request. */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ValidateTeamInvitationToken */
export type ValidateTeamInvitationTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Autogenerated return type of ValidateTeamInvitationToken. */
export type ValidateTeamInvitationTokenPayload = {
  __typename?: 'ValidateTeamInvitationTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  invitation?: Maybe<Invitation>;
  valid: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ValidateTeamOpenInvitationToken */
export type ValidateTeamOpenInvitationTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Autogenerated return type of ValidateTeamOpenInvitationToken. */
export type ValidateTeamOpenInvitationTokenPayload = {
  __typename?: 'ValidateTeamOpenInvitationTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Hash']['output']>;
  team?: Maybe<Team>;
  valid: Scalars['Boolean']['output'];
};

/** Variant */
export type Variant = {
  __typename?: 'Variant';
  /** All Variants */
  allOptimizedVariants?: Maybe<Array<CatalogVariants>>;
  /** All Variants */
  allVariants?: Maybe<Array<CatalogVariants>>;
  /** Price in currency */
  amountIn?: Maybe<Scalars['String']['output']>;
  /** Blank Variant for Warehouse Product Variant */
  blankVariant?: Maybe<Variant>;
  /** Images */
  catalogVariants?: Maybe<Array<CatalogVariantImages>>;
  /** Current catalog id with variant id */
  currentCatalogIdWithId?: Maybe<Scalars['String']['output']>;
  /** IDs of the customizer templates for the passed store */
  customizerTemplateIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** External ID */
  externalId?: Maybe<Scalars['String']['output']>;
  /** External Source */
  externalSource?: Maybe<Scalars['String']['output']>;
  /** Variant Has Tier Pricing */
  hasTierPricing?: Maybe<Scalars['Boolean']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Images */
  images?: Maybe<Array<Scalars['Attachment']['output']>>;
  /** true for master variant */
  isMaster?: Maybe<Scalars['Boolean']['output']>;
  /** All Variants */
  masterImages?: Maybe<Array<MasterImage>>;
  /** measurement unit */
  measurementUnit?: Maybe<Scalars['String']['output']>;
  /** Minimum order quantity for variant */
  minOrderableQuantity?: Maybe<Scalars['Int']['output']>;
  /** Option values */
  optionValues?: Maybe<Array<OptionValue>>;
  /** originating parent id */
  originatingParentId?: Maybe<Scalars['String']['output']>;
  /** Out of Stock */
  outOfStock?: Maybe<Scalars['Boolean']['output']>;
  /** True Price in currency */
  priceIn?: Maybe<Scalars['Float']['output']>;
  /** Prices of variant */
  prices?: Maybe<Array<Price>>;
  /** Product */
  product: Product;
  /** Product ID */
  productId?: Maybe<Scalars['ID']['output']>;
  /** SKU */
  sku?: Maybe<Scalars['String']['output']>;
  /** Store Variant for current Store and Variant */
  storeVariant?: Maybe<StoreVariant>;
  /** Variant Detail */
  variantDetail?: Maybe<VariantDetail>;
  /** Vendor by Country or Global Zone */
  vendorByCountryOrGlobalZone?: Maybe<Vendor>;
  /** weight */
  weight?: Maybe<Scalars['String']['output']>;
};


/** Variant */
export type VariantAllOptimizedVariantsArgs = {
  catalogExternalStoreProductMappings?: InputMaybe<Scalars['String']['input']>;
  storeNumber: Scalars['String']['input'];
};


/** Variant */
export type VariantAllVariantsArgs = {
  catalogExternalStoreProductMappings?: InputMaybe<Scalars['String']['input']>;
  storeNumber: Scalars['String']['input'];
};


/** Variant */
export type VariantAmountInArgs = {
  currency: Scalars['String']['input'];
};


/** Variant */
export type VariantCatalogVariantsArgs = {
  catalogExternalStoreProductMappings: Scalars['String']['input'];
  storeNumber: Scalars['String']['input'];
};


/** Variant */
export type VariantCustomizerTemplateIdsArgs = {
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** Variant */
export type VariantImagesArgs = {
  catalogExternalStoreProductMappings?: InputMaybe<Scalars['String']['input']>;
  fromCatalogStore?: InputMaybe<Scalars['Boolean']['input']>;
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** Variant */
export type VariantMasterImagesArgs = {
  catalogExternalStoreProductMappings?: InputMaybe<Scalars['String']['input']>;
  storeNumber: Scalars['String']['input'];
};


/** Variant */
export type VariantPriceInArgs = {
  currency: Scalars['String']['input'];
};


/** Variant */
export type VariantPricesArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
};


/** Variant */
export type VariantStoreVariantArgs = {
  storeNumber?: InputMaybe<Scalars['String']['input']>;
};


/** Variant */
export type VariantVendorByCountryOrGlobalZoneArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  globalZone?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Variant Detail */
export type VariantDetail = {
  __typename?: 'VariantDetail';
  /** Blank Variant for Warehouse Product Variant */
  blankVariant?: Maybe<Variant>;
  /** Blank Variant ID */
  blankVariantId?: Maybe<Scalars['ID']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Variant ID */
  variantId?: Maybe<Scalars['ID']['output']>;
};

/** objects which can be linked product as variant */
export type VariantResource = Price | Variant;

/** Vendor */
export type Vendor = {
  __typename?: 'Vendor';
  /** Address */
  address?: Maybe<SwagAddress>;
  /** Description used when banner is not available */
  bannerDescription?: Maybe<Scalars['String']['output']>;
  /** Banner Image at Brand's product listing */
  bannerImage?: Maybe<Scalars['Attachment']['output']>;
  /** Is default warehouse */
  defaultWarehouse?: Maybe<Scalars['Boolean']['output']>;
  /** description */
  description?: Maybe<Scalars['String']['output']>;
  /** display name */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** ID used on Elasticsearch */
  esId: Scalars['ID']['output'];
  /** external_id */
  externalId?: Maybe<Scalars['Int']['output']>;
  /** external_source */
  externalSource?: Maybe<Scalars['String']['output']>;
  /** Featured Logo */
  featuredLogo?: Maybe<Scalars['Attachment']['output']>;
  /** Holiday End Date */
  holidayEndDate?: Maybe<Scalars['String']['output']>;
  /** Holiday Note */
  holidayNote?: Maybe<Scalars['String']['output']>;
  /** Holiday Start Date */
  holidayStartDate?: Maybe<Scalars['String']['output']>;
  /** ID */
  id: Scalars['ID']['output'];
  /** Key */
  key?: Maybe<Scalars['String']['output']>;
  /** Logo */
  logo?: Maybe<Scalars['Attachment']['output']>;
  /** name */
  name?: Maybe<Scalars['String']['output']>;
  /** Product Country Iso3 */
  productCountryIso3?: Maybe<Scalars['String']['output']>;
  /** Brand Name Visible */
  visible?: Maybe<Scalars['Boolean']['output']>;
};


/** Vendor */
export type VendorProductCountryIso3Args = {
  number: Scalars['String']['input'];
};

export type WalletBalanceGroup = {
  __typename?: 'WalletBalanceGroup';
  /** Metadata about this wallet balance group */
  meta: WalletBalanceGroupMeta;
  /** List of wallet balances in this group */
  resources: Array<WorkspaceUserWalletBalance>;
};

export type WalletBalanceGroupMeta = {
  __typename?: 'WalletBalanceGroupMeta';
  /** Sum of all balances in this group (e.g., "$300 USD", "300 points") */
  sum: Scalars['String']['output'];
  /** Type of the wallet balances in this group (e.g., wallet, points) */
  type: Scalars['String']['output'];
};

export type WalletSavingsPlan = {
  __typename?: 'WalletSavingsPlan';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  minimumAmount: Scalars['Float']['output'];
  minimumBonusAmount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  paymentMode: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};

/** WarehouseProductMetaData type */
export type WarehouseProductMetadata = {
  __typename?: 'WarehouseProductMetadata';
  /** Blank Product */
  blankProduct?: Maybe<Product>;
  /** Blank Product ID */
  blankProductId?: Maybe<Scalars['ID']['output']>;
  /** Estimated item value */
  estimatedItemValue?: Maybe<Scalars['Float']['output']>;
  /** ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** Low stick alert quantity */
  lowStockAlertQuantity?: Maybe<Scalars['Int']['output']>;
  /** Notes */
  notes?: Maybe<Scalars['String']['output']>;
  /** Product Link */
  productLink?: Maybe<Scalars['String']['output']>;
  /** Source */
  source?: Maybe<Scalars['String']['output']>;
  /** Blank Product Store */
  store?: Maybe<Store>;
  /** Unique id */
  uniqueId?: Maybe<Scalars['String']['output']>;
};

/** Attribtues for creating a warehouse product meta data */
export type WarehouseProductMetadataInput = {
  /** Estimated item value */
  estimatedItemValue?: InputMaybe<Scalars['Float']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Low stock alert quantity */
  lowStockAlertQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** Notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Product Link */
  productLink?: InputMaybe<Scalars['String']['input']>;
  /** Do not send out of stock mail */
  skipOutOfStockMail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique ID */
  uniqueId?: InputMaybe<Scalars['String']['input']>;
};

export type Widget = {
  __typename?: 'Widget';
  /** Widget date */
  date?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The scope at which the widget can be dismissed (workspace or workspace_user) */
  dismissalScope: Scalars['String']['output'];
  /** Whether the widget can be dismissed */
  dismissible: Scalars['Boolean']['output'];
  /** Widget heading */
  heading?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['AttachmentType']['output']>;
  /** Widget ID */
  id: Scalars['ID']['output'];
  /** Whether the widget is customizable */
  isCustomizable: Scalars['Boolean']['output'];
  /** Widget key */
  key: Scalars['String']['output'];
  /** Widget primary color */
  primaryColor?: Maybe<Scalars['String']['output']>;
  /** Widget redirect URL */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** Widget secondary color */
  secondaryColor?: Maybe<Scalars['String']['output']>;
  /** Widget date color */
  thirdColor?: Maybe<Scalars['String']['output']>;
  /** Widget title */
  widgetTitle?: Maybe<Scalars['String']['output']>;
};

export type WidgetState = {
  __typename?: 'WidgetState';
  dismissedByUserId?: Maybe<Scalars['ID']['output']>;
  dismissedForId: Scalars['ID']['output'];
  dismissedForType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  widget: Widget;
};

export type Workspace = {
  __typename?: 'Workspace';
  accessLocked: Scalars['Boolean']['output'];
  active: Scalars['Boolean']['output'];
  adminsCount?: Maybe<Scalars['Int']['output']>;
  company?: Maybe<ChildCompany>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  customContactFields?: Maybe<Array<CustomContactField>>;
  defaultWorkspacePermissions: Array<Scalars['String']['output']>;
  /** Whether the current user has a pending join request for this workspace */
  hasPendingJoinRequest: Scalars['Boolean']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Whether this is the current user default workspace */
  isDefault: Scalars['Boolean']['output'];
  membersCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nonMembersCount?: Maybe<Scalars['Int']['output']>;
  number: Scalars['String']['output'];
  ownerUsers?: Maybe<Array<User>>;
  package?: Maybe<Package>;
  sendersCount?: Maybe<Scalars['Int']['output']>;
  sendingEnabled: Scalars['Boolean']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  ssoEnabledDomains?: Maybe<Array<Domain>>;
  stadiumExpertsCount?: Maybe<Scalars['Int']['output']>;
  subscription?: Maybe<Subscription>;
  type: Scalars['String']['output'];
  unallocatedPoints: Scalars['Int']['output'];
  users?: Maybe<PaginatedUsers>;
  usersCount?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
  workspaceMetadata?: Maybe<WorkspaceMetadata>;
  workspaceUsers?: Maybe<Array<WorkspaceUser>>;
};


export type WorkspaceUsersArgs = {
  filters?: InputMaybe<Scalars['Hash']['input']>;
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Hash']['input']>;
};

export type WorkspaceInput = {
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  iconImage?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  packageName?: InputMaybe<Scalars['String']['input']>;
  removeIconImage?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  workspaceMetadata?: InputMaybe<WorkspaceMetadataInput>;
};

/** A workspace join request */
export type WorkspaceJoinRequest = {
  __typename?: 'WorkspaceJoinRequest';
  /** When the request was approved or rejected */
  actionTakenAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** User who approved or rejected the request */
  actionTakenBy?: Maybe<User>;
  /** When the request was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Unique identifier for the join request */
  id?: Maybe<Scalars['ID']['output']>;
  /** Type of the join request */
  kind?: Maybe<Scalars['String']['output']>;
  /** Status of the join request */
  status?: Maybe<WorkspaceJoinRequestStatus>;
  /** When the request was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** User who made the join request */
  user?: Maybe<User>;
  /** Workspace the user wants to join */
  workspace?: Maybe<Workspace>;
};

/** Status of a workspace join request */
export enum WorkspaceJoinRequestStatus {
  /** Request has been approved */
  Approved = 'APPROVED',
  /** Request is pending approval */
  Pending = 'PENDING',
  /** Request has been rejected */
  Rejected = 'REJECTED'
}

export type WorkspaceMetadata = {
  __typename?: 'WorkspaceMetadata';
  adminEmails?: Maybe<Array<Scalars['String']['output']>>;
  companySize?: Maybe<Scalars['String']['output']>;
  formState?: Maybe<Scalars['String']['output']>;
  packageOfferings?: Maybe<Scalars['JSON']['output']>;
  team?: Maybe<Scalars['String']['output']>;
  teamDetails?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceMetadataInput = {
  /** List of emails to be added as admins when workspace is activated */
  adminEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Company size (any string value, max 100 characters) */
  companySize?: InputMaybe<Scalars['String']['input']>;
  /** Form state (any string value, max 500 characters) */
  formState?: InputMaybe<Scalars['String']['input']>;
  /** Package offerings data (JSON format) */
  packageOfferings?: InputMaybe<Scalars['JSON']['input']>;
  /** Team information (any string value, max 500 characters) */
  team?: InputMaybe<Scalars['String']['input']>;
  /** Team details information (any string value, max 500 characters) */
  teamDetails?: InputMaybe<Scalars['String']['input']>;
};

/** Workspace permission object type */
export type WorkspacePermission = {
  __typename?: 'WorkspacePermission';
  /** Whether this permission is enabled by default */
  default: Scalars['Boolean']['output'];
  /** Permission description */
  description?: Maybe<Scalars['String']['output']>;
  /** Display name for UI */
  displayName: Scalars['String']['output'];
  /** Gatekeeper permission identifier */
  gatekeeperPermission: Scalars['String']['output'];
  /** Permission key */
  key: Scalars['String']['output'];
  /** Permission name */
  name: Scalars['String']['output'];
};

export type WorkspaceSlug = {
  __typename?: 'WorkspaceSlug';
  /** Whether the current user is a member of this workspace */
  hasCurrentUserAccess: Scalars['Boolean']['output'];
  /** Workspace slug */
  slug: Scalars['String']['output'];
  /** Workspace ID */
  workspaceId: Scalars['ID']['output'];
};

/** Autogenerated input type of WorkspaceUpdate */
export type WorkspaceUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: WorkspaceInput;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of WorkspaceUpdate. */
export type WorkspaceUpdatePayload = {
  __typename?: 'WorkspaceUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  workspace?: Maybe<Workspace>;
};

export type WorkspaceUser = {
  __typename?: 'WorkspaceUser';
  /** Whether the workspace user is active or not */
  active: Scalars['Boolean']['output'];
  atsContactProviders?: Maybe<Array<ContactProvider>>;
  availablePaymentMethods?: Maybe<Array<PaymentMethod>>;
  contactFilters?: Maybe<Scalars['Hash']['output']>;
  contactProviders?: Maybe<Array<ContactProvider>>;
  crmContactProviders?: Maybe<Array<ContactProvider>>;
  /** Permission is default or custom */
  customPermissions: Scalars['Boolean']['output'];
  /** Date and time when the workspace user was deactivated */
  deactivatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** User who deactivated this workspace user, or a display string when not a User */
  deactivatedBy?: Maybe<DeactivatedBy>;
  /** Date and time when the workspace user was deactivating */
  deactivatingAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Human-readable role names */
  displayRoles: Array<Scalars['String']['output']>;
  encodedUuid: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Whether the workspace user is deactivated */
  isDeactivated: Scalars['Boolean']['output'];
  kudosProgramPresent: Scalars['Boolean']['output'];
  pendingWorkspacePoints: Scalars['Int']['output'];
  permissions: Scalars['JSON']['output'];
  /** Number of resources owned by this workspace user */
  resourcesCount: Scalars['Int']['output'];
  roles: Array<Scalars['String']['output']>;
  /** Service Statuses */
  serviceStatuses?: Maybe<Array<ServiceStatus>>;
  /** Shop points balance for this workspace user */
  shopPoints: Scalars['Int']['output'];
  /** Status of the workspace user (active, deactivating, deactivated) */
  status: Scalars['String']['output'];
  /** The current workspace user's teams */
  teams: Array<Team>;
  user?: Maybe<User>;
  uuid: Scalars['String']['output'];
  widgets: Array<Widget>;
  workspace: Workspace;
  /** Workspace Contact Object */
  workspaceContact?: Maybe<Contact>;
  workspacePermissions: Array<Scalars['String']['output']>;
  workspacePoints: Scalars['Int']['output'];
};


export type WorkspaceUserPermissionsArgs = {
  resources?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type WorkspaceUserWidgetsArgs = {
  intent?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of WorkspaceUserDelete */
export type WorkspaceUserDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

/** Autogenerated return type of WorkspaceUserDelete. */
export type WorkspaceUserDeletePayload = {
  __typename?: 'WorkspaceUserDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type WorkspaceUserResource = {
  __typename?: 'WorkspaceUserResource';
  /** Unique identifier for the resource */
  resourceId: Scalars['String']['output'];
  /** Human-readable name of the resource */
  resourceName: Scalars['String']['output'];
  /** Type of the resource (e.g., Product, Order) */
  resourceType: Scalars['String']['output'];
  /** URL to access the resource */
  url: Scalars['String']['output'];
};

export type WorkspaceUserResourcesList = {
  __typename?: 'WorkspaceUserResourcesList';
  /** List of resource groups, each grouped by resource type */
  groups: Array<ResourceGroup>;
};

export type WorkspaceUserWalletBalance = {
  __typename?: 'WorkspaceUserWalletBalance';
  /** Formatted balance display (e.g., "$100 USD", "300 points") */
  displayBalance: Scalars['String']['output'];
  /** Human-readable name of the wallet */
  resourceName: Scalars['String']['output'];
  /** URL to access the wallet */
  url: Scalars['String']['output'];
};

export type WorkspaceUserWalletBalancesList = {
  __typename?: 'WorkspaceUserWalletBalancesList';
  /** List of wallet balance groups, each grouped by wallet type */
  groups: Array<WalletBalanceGroup>;
};

/** Autogenerated input type of WorkspaceUsersUpdateRole */
export type WorkspaceUsersUpdateRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  role: RoleTypes;
  uuids: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of WorkspaceUsersUpdateRole. */
export type WorkspaceUsersUpdateRolePayload = {
  __typename?: 'WorkspaceUsersUpdateRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** True when the failure was due to role downgrade restrictions */
  downgrade?: Maybe<Scalars['Boolean']['output']>;
  errors: Array<Scalars['String']['output']>;
  workspaceUsers?: Maybe<Array<WorkspaceUser>>;
};

export type BannerDetailsFragment = { __typename?: 'DigitalAsset', id: string, url?: any | null };

export type BasicCatalogDetailsFragment = { __typename?: 'Catalog', id: string, name?: string | null, canAddToStore: boolean, statusInformation?: string | null, state?: string | null, displayState?: string | null, storeId: string, kind: string, approvalRequired: boolean, estimatedReadyDate?: any | null, number: string, externalOrderNumber?: string | null, canRestock?: boolean | null, logoEditable: boolean, paid: boolean, archivedAt?: any | null, availableProductsCount?: number | null, primaryLogo?: { __typename?: 'Logo', id: string, url?: any | null, extension?: string | null, filename?: string | null, type?: string | null } | null, secondaryLogos: Array<{ __typename?: 'Logo', id: string, url?: any | null, extension?: string | null, filename?: string | null, type?: string | null }>, products?: Array<{ __typename?: 'Product', variantImages?: Array<any> | null, name?: string | null, productCatalogSlug?: string | null }>, store: { __typename?: 'Store', id: string, externalId?: string | null, number: string, cacheKey?: string | null, adminsCount?: number | null, creator?: { __typename?: 'User', email: string, name?: string | null } | null, storeDetail?: { __typename?: 'StoreDetail', pastelUrl?: string | null } | null }, storeCatalogs?: Array<{ __typename?: 'StoreCatalog', allProductsAdded: boolean, store: { __typename?: 'Store', id: string } }> | null };

export type DigitalAssetContentFragment = { __typename?: 'DigitalAsset', id: string, folderId?: number | null, kind?: string | null, url?: any | null, extension?: string | null, attachmentContentType?: string | null, attachmentFileSize?: string | null, attachmentFileName?: string | null, userAuthorized: boolean, estimatedPrintQuality?: string | null };

export type LogoDetailFragment = { __typename?: 'Logo', extension?: string | null, fileSize?: string | null, filename?: string | null, id: string, type?: string | null, url?: any | null };

export type UserLogoListFragment = { __typename?: 'Logo', extension?: string | null, fileSize?: string | null, filename?: string | null, id: string, type?: string | null, url?: any | null, approvedByDesigner: boolean, estimatedPrintQuality?: string | null, digitalAsset?: { __typename?: 'DigitalAsset', id: string } | null };

export type ProductBasicDetailsFragment = { __typename?: 'Product', id: string, name?: string | null, slug?: string | null, type?: string | null, productCatalogSlug?: string | null, customizable: boolean, showDiscardWarning?: boolean | null, isSizeCustomizable: boolean, customizerData?: any | null, dpiQualityTiers?: any | null, printAreaConfig?: any | null, decorationTechnique?: string | null, pastelUrl?: string | null, storeNumber?: string | null, shouldShowPrintAreaOverlay: boolean, shouldFeGeneratePreview: boolean, showPrintAreaAsMockupPreview: boolean, fontColors?: Array<Array<string>> | null, innerCanvasJsons?: Array<{ __typename?: 'DigitalAsset', id: string, url?: any | null }> | null, mockups?: Array<{ __typename?: 'Mockup', id: string, fileType: string, printAreaCoords?: any | null, conflictingPlacements?: Array<string> | null, bleedingAreaCoords?: any | null }> | null, themes?: Array<{ __typename?: 'Theme', id: string, name: string, size: string, colors: Array<string>, createdAt: any }> | null, customizerTemplates?: Array<{ __typename?: 'CustomizerTemplate', id: string, mockupId?: string | null, baseImage?: any | null, name: string, innerCanvasJsonId?: string | null }> | null, currentCatalog?: { __typename?: 'Catalog', number: string, creator?: { __typename?: 'User', email: string } | null } | null, variantsIncludingMaster?: Array<
    | { __typename?: 'Price' }
    | { __typename?: 'Variant', id: string, optionValues?: Array<{ __typename?: 'OptionValue', id: string, name?: string | null }> | null }
  > | null };

export type ProductMappingDetailsFragment = { __typename?: 'Product', id: string, name?: string | null, slug?: string | null, type?: string | null, isSizeCustomizable: boolean, addToAutomatedCatalog: boolean, defaultDecorationTechnique?: string | null, colorHexMapping: Array<Array<string>>, mappingToolData?: any | null, decorationTechniques: Array<string>, allowPmtEdit: boolean, canvasJsons?: Array<{ __typename?: 'DigitalAsset', id: string, url?: any | null }> | null, mockups?: Array<{ __typename?: 'Mockup', id: string, fileType: string, printAreaCoords?: any | null, automationPlacementCoords?: any | null, conflictingPlacements?: Array<string> | null, transparentBaseImageUrl?: string | null, transparentBaseImageColors?: Array<string> | null }> | null };

export type UserLogoStatusFragment = { __typename?: 'User', id: string, hasUploadedLogos: boolean };

export type ManageDraftAutomatedCatalogMutationVariables = Exact<{
  input: ManageDraftAutomatedCatalogInput;
}>;


export type ManageDraftAutomatedCatalogMutation = { __typename?: 'Mutation', manageDraftAutomatedCatalog?: { __typename?: 'ManageDraftAutomatedCatalogPayload', clientMutationId?: string | null, errors?: Array<string> | null, catalog?: { __typename?: 'Catalog', id: string, number: string, name?: string | null, kind: string, createdAt?: any | null, colorGroupIds?: Array<number> | null, showDraftAutomatedMockupBanner?: boolean | null } | null } | null };

export type ToggleArchiveCatalogMutationVariables = Exact<{
  input: ToggleArchiveCatalogInput;
  productsLimit?: InputMaybe<Scalars['Int']['input']>;
  includeProducts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ToggleArchiveCatalogMutation = { __typename?: 'Mutation', toggleArchiveCatalog?: { __typename?: 'ToggleArchiveCatalogPayload', response?: { __typename?: 'Response', success: boolean, errors?: Array<string> | null, entity?:
        | { __typename?: 'Brand' }
        | { __typename?: 'Catalog', id: string, name?: string | null, canAddToStore: boolean, statusInformation?: string | null, state?: string | null, displayState?: string | null, storeId: string, kind: string, approvalRequired: boolean, estimatedReadyDate?: any | null, number: string, externalOrderNumber?: string | null, canRestock?: boolean | null, logoEditable: boolean, paid: boolean, archivedAt?: any | null, availableProductsCount?: number | null, primaryLogo?: { __typename?: 'Logo', id: string, url?: any | null, extension?: string | null, filename?: string | null, type?: string | null } | null, secondaryLogos: Array<{ __typename?: 'Logo', id: string, url?: any | null, extension?: string | null, filename?: string | null, type?: string | null }>, products?: Array<{ __typename?: 'Product', variantImages?: Array<any> | null, name?: string | null, productCatalogSlug?: string | null }>, store: { __typename?: 'Store', id: string, externalId?: string | null, number: string, cacheKey?: string | null, adminsCount?: number | null, creator?: { __typename?: 'User', email: string, name?: string | null } | null, storeDetail?: { __typename?: 'StoreDetail', pastelUrl?: string | null } | null }, storeCatalogs?: Array<{ __typename?: 'StoreCatalog', allProductsAdded: boolean, store: { __typename?: 'Store', id: string } }> | null }
        | { __typename?: 'DigitalAsset' }
        | { __typename?: 'Logo' }
        | { __typename?: 'Product' }
        | { __typename?: 'Store' }
        | { __typename?: 'Vendor' }
       | null } | null } | null };

export type UpdateContactPermissionsMutationVariables = Exact<{
  input: SetWorkspaceUserPermissionsInput;
}>;


export type UpdateContactPermissionsMutation = { __typename?: 'Mutation', setWorkspaceUserPermissions?: { __typename?: 'SetWorkspaceUserPermissionsPayload', errors: Array<string>, workspaceUser?: { __typename?: 'WorkspaceUser', id: string, workspacePermissions: Array<string>, customPermissions: boolean } | null } | null };

export type ResetContactPermissionsMutationVariables = Exact<{
  input: ResetToDefaultInput;
}>;


export type ResetContactPermissionsMutation = { __typename?: 'Mutation', resetWorkspaceUserToDefault?: { __typename?: 'ResetToDefaultPayload', errors: Array<string>, workspaceUser?: { __typename?: 'WorkspaceUser', id: string, workspacePermissions: Array<string>, customPermissions: boolean } | null } | null };

export type CreatePostMutationVariables = Exact<{
  input: CreatePostInput;
  allComments?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatePostMutation = { __typename?: 'Mutation', createPost?: { __typename?: 'CreatePostPayload', success: boolean, errors?: any | null, post?: { __typename?: 'Post', number?: string | null, body: string, amount: number, commentsAmount?: number | null, creator: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, avatarUrl?: any | null }, mentions?: Array<{ __typename?: 'Mention', recognitionPointsReceived: number, tagged: boolean, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, avatarUrl?: any | null } }> | null, images?: Array<{ __typename?: 'PostImage', url: string }> | null, stickers?: Array<{ __typename?: 'PostSticker', altText: string, url: string }> | null } | null } | null };

export type CustomizeProductMutationVariables = Exact<{
  input: CustomizeProductInput;
}>;


export type CustomizeProductMutation = { __typename?: 'Mutation', customizeProduct?: { __typename?: 'CustomizeProductPayload', response?: { __typename?: 'Response', success: boolean, errors?: Array<string> | null, entity?:
        | { __typename?: 'Brand' }
        | { __typename?: 'Catalog' }
        | { __typename?: 'DigitalAsset' }
        | { __typename?: 'Logo' }
        | { __typename?: 'Product', id: string, name?: string | null, slug?: string | null, type?: string | null, productCatalogSlug?: string | null, customizable: boolean, showDiscardWarning?: boolean | null, isSizeCustomizable: boolean, customizerData?: any | null, dpiQualityTiers?: any | null, printAreaConfig?: any | null, decorationTechnique?: string | null, pastelUrl?: string | null, storeNumber?: string | null, shouldShowPrintAreaOverlay: boolean, shouldFeGeneratePreview: boolean, showPrintAreaAsMockupPreview: boolean, fontColors?: Array<Array<string>> | null, innerCanvasJsons?: Array<{ __typename?: 'DigitalAsset', id: string, url?: any | null }> | null, mockups?: Array<{ __typename?: 'Mockup', id: string, fileType: string, printAreaCoords?: any | null, conflictingPlacements?: Array<string> | null, bleedingAreaCoords?: any | null }> | null, themes?: Array<{ __typename?: 'Theme', id: string, name: string, size: string, colors: Array<string>, createdAt: any }> | null, customizerTemplates?: Array<{ __typename?: 'CustomizerTemplate', id: string, mockupId?: string | null, baseImage?: any | null, name: string, innerCanvasJsonId?: string | null }> | null, currentCatalog?: { __typename?: 'Catalog', number: string, creator?: { __typename?: 'User', email: string } | null } | null, variantsIncludingMaster?: Array<
            | { __typename?: 'Price' }
            | { __typename?: 'Variant', id: string, optionValues?: Array<{ __typename?: 'OptionValue', id: string, name?: string | null }> | null }
          > | null }
        | { __typename?: 'Store' }
        | { __typename?: 'Vendor' }
       | null } | null, user?: { __typename?: 'User', id: string, hasUploadedLogos: boolean } | null } | null };

export type GeneratePreviewMutationVariables = Exact<{
  input: GeneratePreviewInput;
}>;


export type GeneratePreviewMutation = { __typename?: 'Mutation', generatePreview?: { __typename?: 'GeneratePreviewPayload', previewRequestNumber?: string | null, errors?: Array<string> | null } | null };

export type CreateBaseImagesMutationVariables = Exact<{
  input: CreateBaseImagesInput;
}>;


export type CreateBaseImagesMutation = { __typename?: 'Mutation', createBaseImages?: { __typename?: 'CreateBaseImagesPayload', errors?: Array<string> | null, assets?: Array<{ __typename?: 'DigitalAsset', id: string, folderId?: number | null, kind?: string | null, url?: any | null, extension?: string | null, attachmentContentType?: string | null, attachmentFileSize?: string | null, attachmentFileName?: string | null, userAuthorized: boolean, estimatedPrintQuality?: string | null }> | null } | null };

export type CreateDigitalAssetMutationVariables = Exact<{
  input: CreateDigitalAssetInput;
  kind: Scalars['String']['input'];
}>;


export type CreateDigitalAssetMutation = { __typename?: 'Mutation', createDigitalAsset?: { __typename?: 'CreateDigitalAssetPayload', errors?: Array<string> | null, asset?: { __typename?: 'DigitalAsset', id: string, folderId?: number | null, kind?: string | null, url?: any | null, extension?: string | null, attachmentContentType?: string | null, attachmentFileSize?: string | null, attachmentFileName?: string | null, userAuthorized: boolean, estimatedPrintQuality?: string | null, designGuidelines?: { __typename?: 'DigitalAsset', id: string, folderId?: number | null, kind?: string | null, url?: any | null, extension?: string | null, attachmentContentType?: string | null, attachmentFileSize?: string | null, attachmentFileName?: string | null, userAuthorized: boolean, estimatedPrintQuality?: string | null } | null } | null, user?: { __typename?: 'User', id: string, hasDigitalAssets: boolean } | null } | null };

export type DestroyDigitalAssetMutationVariables = Exact<{
  input: DestroyDigitalAssetInput;
}>;


export type DestroyDigitalAssetMutation = { __typename?: 'Mutation', destroyDigitalAsset?: { __typename?: 'DestroyDigitalAssetPayload', errors?: Array<string> | null, digitalAsset?: { __typename?: 'DigitalAsset', id: string, folderId?: number | null, designGuidelines?: { __typename?: 'DigitalAsset', id: string } | null } | null } | null };

export type UpdateDigitalAssetMutationVariables = Exact<{
  input: UpdateDigitalAssetInput;
}>;


export type UpdateDigitalAssetMutation = { __typename?: 'Mutation', updateDigitalAsset?: { __typename?: 'UpdateDigitalAssetPayload', errors?: Array<string> | null, asset?: { __typename?: 'DigitalAsset', id: string, folderId?: number | null, userAuthorized: boolean } | null } | null };

export type CreateLogoMutationVariables = Exact<{
  input: CreateLogoInput;
}>;


export type CreateLogoMutation = { __typename?: 'Mutation', createLogo?: { __typename?: 'CreateLogoPayload', errors?: Array<string> | null, logo?: { __typename?: 'Logo', id: string, imageUrl?: string | null, url?: any | null, type?: string | null, filename?: string | null } | null, user?: { __typename?: 'User', id: string, hasUploadedLogos: boolean } | null } | null };

export type CreateChildCompanyMutationVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type CreateChildCompanyMutation = { __typename?: 'Mutation', createChildCompany?: { __typename?: 'CreateChildCompanyPayload', errors: Array<string>, success: boolean, childCompany?: { __typename?: 'ChildCompany', id: string, number?: string | null, packageIntentMappingKey?: string | null, name?: string | null, ownerUser?: { __typename?: 'User', email: string } | null } | null } | null };

export type ValidateCompanySubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type ValidateCompanySubscriptionMutation = { __typename?: 'Mutation', validateCompanySubscription?: { __typename?: 'ValidateCompanySubscriptionPayload', errors?: string | null, success: boolean } | null };

export type UpdateProductMappingMutationVariables = Exact<{
  input: UpdateProductMappingInput;
}>;


export type UpdateProductMappingMutation = { __typename?: 'Mutation', updateProductMapping?: { __typename?: 'UpdateProductMappingPayload', response?: { __typename?: 'Response', success: boolean, errors?: Array<string> | null, entity?:
        | { __typename?: 'Brand' }
        | { __typename?: 'Catalog' }
        | { __typename?: 'DigitalAsset' }
        | { __typename?: 'Logo' }
        | { __typename?: 'Product', id: string, name?: string | null, slug?: string | null, type?: string | null, isSizeCustomizable: boolean, addToAutomatedCatalog: boolean, defaultDecorationTechnique?: string | null, colorHexMapping: Array<Array<string>>, mappingToolData?: any | null, decorationTechniques: Array<string>, allowPmtEdit: boolean, canvasJsons?: Array<{ __typename?: 'DigitalAsset', id: string, url?: any | null }> | null, mockups?: Array<{ __typename?: 'Mockup', id: string, fileType: string, printAreaCoords?: any | null, automationPlacementCoords?: any | null, conflictingPlacements?: Array<string> | null, transparentBaseImageUrl?: string | null, transparentBaseImageColors?: Array<string> | null }> | null }
        | { __typename?: 'Store' }
        | { __typename?: 'Vendor' }
       | null } | null } | null };

export type UpdateRlpMutationVariables = Exact<{
  input: UpdateSenderRlpMessageInput;
}>;


export type UpdateRlpMutation = { __typename?: 'Mutation', updateSenderRlpMessage?: { __typename?: 'UpdateSenderRlpMessagePayload', errors?: any | null, success: boolean } | null };

export type UpdateRewardUserMutationVariables = Exact<{
  input: UserUpdateInput;
}>;


export type UpdateRewardUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UserUpdatePayload', user?: { __typename?: 'User', id: string, displayRewardRules: boolean } | null } | null };

export type UpdateProfileMutationVariables = Exact<{
  input: UserUpdateProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'UserUpdateProfilePayload', success: boolean, user?: { __typename?: 'User', id: string, profile?: { __typename?: 'UserProfile', id: string, lowFundsNotificationThreshold?: number | null, personalWorkspaceNudgeLastDismissedAt?: any | null } | null } | null } | null };

export type LibrayAssetsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  kinds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  addedBy?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type LibrayAssetsQuery = { __typename?: 'Query', libraryAssets?: { __typename?: 'AssetLibraryPaginated', total: number, aggregations?: { __typename?: 'AssetAggregation', kinds: Array<{ __typename?: 'AssetLibraryKind', key: string, presentation: string }>, users: Array<{ __typename?: 'User', id: string, name?: string | null }> } | null, collection: Array<{ __typename?: 'DigitalAsset', id: string, folderId?: number | null, name?: string | null, kind?: string | null, notes?: string | null, number?: string | null, createdAt?: any | null, url?: any | null, thumbnailUrl?: any | null, approvedByDesigner: boolean, extension?: string | null, creator?: { __typename?: 'User', name?: string | null } | null, designGuidelines?: { __typename?: 'DigitalAsset', id: string, folderId?: number | null, kind?: string | null, url?: any | null, extension?: string | null, attachmentContentType?: string | null, attachmentFileSize?: string | null, attachmentFileName?: string | null, userAuthorized: boolean, estimatedPrintQuality?: string | null } | null }> } | null };

export type DummyBannerQueryVariables = Exact<{
  bannerBackground: Scalars['String']['input'];
  bannerBackgroundImageType?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  logoBackground: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  textColor: Scalars['String']['input'];
  textBackground?: InputMaybe<Scalars['String']['input']>;
  removeLogo?: InputMaybe<Scalars['Boolean']['input']>;
  removeBackgroundPattern?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DummyBannerQuery = { __typename?: 'Query', dummyBanner: { __typename?: 'DummyBanner', url: string }, user?: { __typename?: 'User', id: string, hasUploadedLogos: boolean } | null };

export type FetchPreviewQueryVariables = Exact<{
  previewRequestNumber: Scalars['String']['input'];
}>;


export type FetchPreviewQuery = { __typename?: 'Query', fetchPreview?: { __typename?: 'PreviewRequest', status: string, response?: any | null } | null };

export type FetchDigitalAssetsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type FetchDigitalAssetsQuery = { __typename?: 'Query', digitalAssets?: { __typename?: 'DigitalAssetConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, edges?: Array<{ __typename?: 'DigitalAssetEdge', cursor: string } | null> | null, nodes?: Array<{ __typename?: 'DigitalAsset', id: string, folderId?: number | null, kind?: string | null, url?: any | null, extension?: string | null, attachmentContentType?: string | null, attachmentFileSize?: string | null, attachmentFileName?: string | null, userAuthorized: boolean, estimatedPrintQuality?: string | null, designGuidelines?: { __typename?: 'DigitalAsset', id: string, folderId?: number | null, kind?: string | null, url?: any | null, extension?: string | null, attachmentContentType?: string | null, attachmentFileSize?: string | null, attachmentFileName?: string | null, userAuthorized: boolean, estimatedPrintQuality?: string | null } | null } | null> | null } | null };

export type FetchLockerConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchLockerConfigQuery = { __typename?: 'Query', lockerShop?: { __typename?: 'Store', feUrl: string, storeDetail?: { __typename?: 'StoreDetail', newRoutesEnabled: boolean } | null } | null };

export type CompanyLogosQueryVariables = Exact<{
  domain: Scalars['String']['input'];
}>;


export type CompanyLogosQuery = { __typename?: 'Query', companyDetail?: { __typename?: 'CompanyDetail', id: string, logos: Array<any> } | null };

export type FetchLogosListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  catalogNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchLogosListQuery = { __typename?: 'Query', paginatedUserLogosList?: { __typename: 'PaginatedCollection', total: number, collection?: Array<
      | { __typename?: 'Brand' }
      | { __typename?: 'Catalog' }
      | { __typename?: 'DigitalAsset' }
      | { __typename?: 'Logo', extension?: string | null, fileSize?: string | null, filename?: string | null, id: string, type?: string | null, url?: any | null, approvedByDesigner: boolean, estimatedPrintQuality?: string | null, digitalAsset?: { __typename?: 'DigitalAsset', id: string } | null }
      | { __typename?: 'Product' }
      | { __typename?: 'Store' }
      | { __typename?: 'Vendor' }
    > | null } | null };

export type FetchProductBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type FetchProductBySlugQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, name?: string | null, slug?: string | null, type?: string | null, productCatalogSlug?: string | null, customizable: boolean, showDiscardWarning?: boolean | null, isSizeCustomizable: boolean, customizerData?: any | null, dpiQualityTiers?: any | null, printAreaConfig?: any | null, decorationTechnique?: string | null, pastelUrl?: string | null, storeNumber?: string | null, shouldShowPrintAreaOverlay: boolean, shouldFeGeneratePreview: boolean, showPrintAreaAsMockupPreview: boolean, fontColors?: Array<Array<string>> | null, innerCanvasJsons?: Array<{ __typename?: 'DigitalAsset', id: string, url?: any | null }> | null, mockups?: Array<{ __typename?: 'Mockup', id: string, fileType: string, printAreaCoords?: any | null, conflictingPlacements?: Array<string> | null, bleedingAreaCoords?: any | null }> | null, themes?: Array<{ __typename?: 'Theme', id: string, name: string, size: string, colors: Array<string>, createdAt: any }> | null, customizerTemplates?: Array<{ __typename?: 'CustomizerTemplate', id: string, mockupId?: string | null, baseImage?: any | null, name: string, innerCanvasJsonId?: string | null }> | null, currentCatalog?: { __typename?: 'Catalog', number: string, creator?: { __typename?: 'User', email: string } | null } | null, variantsIncludingMaster?: Array<
      | { __typename?: 'Price' }
      | { __typename?: 'Variant', id: string, optionValues?: Array<{ __typename?: 'OptionValue', id: string, name?: string | null }> | null }
    > | null } | null };

export type FetchProductMappingDetailsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type FetchProductMappingDetailsQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, name?: string | null, slug?: string | null, type?: string | null, isSizeCustomizable: boolean, addToAutomatedCatalog: boolean, defaultDecorationTechnique?: string | null, colorHexMapping: Array<Array<string>>, mappingToolData?: any | null, decorationTechniques: Array<string>, allowPmtEdit: boolean, canvasJsons?: Array<{ __typename?: 'DigitalAsset', id: string, url?: any | null }> | null, mockups?: Array<{ __typename?: 'Mockup', id: string, fileType: string, printAreaCoords?: any | null, automationPlacementCoords?: any | null, conflictingPlacements?: Array<string> | null, transparentBaseImageUrl?: string | null, transparentBaseImageColors?: Array<string> | null }> | null } | null };

export type FetchRecognitionProgramsListQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Scalars['Hash']['input']>;
}>;


export type FetchRecognitionProgramsListQuery = { __typename?: 'Query', programs: { __typename?: 'ProgramList', programs?: Array<{ __typename?: 'Program', id: string, name?: string | null, status: string, totalUsers?: number | null, frequency?: string | null, nextCycleStartAt?: any | null, totalPointsPurchased?: number | null, totalPointsUsed?: number | null, startedAt?: any | null, createdAt?: any | null, slackIntegrated: boolean, msTeamsIntegrated: boolean, attachMonetaryValue: boolean, admin: boolean, conversionRate?: number | null, amount?: number | null, contactsAmount?: number | null, currencyName?: string | null, allowWithoutPoints: boolean, formState?: string | null, creatorId: number, creatorEmail: string, companyValuesRequired: boolean, permissions: any, companyValues?: Array<{ __typename?: 'CompanyValue', id?: string | null, name?: string | null }> | null, userStats: { __typename?: 'UserStat', availablePoints: number } }> | null, meta?: { __typename?: 'ListMeta', total?: number | null } | null } };

export type GetFeedContactsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['Hash']['input']>;
  excludeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  includeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetFeedContactsQuery = { __typename?: 'Query', programContacts: { __typename?: 'ProgramContactList', programContacts?: Array<{ __typename?: 'ProgramContact', id: string, email: string, firstName?: string | null, lastName?: string | null, isDeactivated: boolean, manual: boolean, avatarUrl?: any | null, userId: string }> | null, meta: { __typename?: 'ListMeta', total?: number | null } } };

export type FetchRecognitionProgramHashtagsSuggestionsQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchRecognitionProgramHashtagsSuggestionsQuery = { __typename?: 'Query', hashtagsSuggestions?: Array<{ __typename?: 'Hashtag', name: string, companyValue: boolean }> | null };

export type FetchResourceCreatorsQueryVariables = Exact<{
  resourceType: Scalars['String']['input'];
}>;


export type FetchResourceCreatorsQuery = { __typename?: 'Query', resourceCreators: Array<{ __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, deactivatedInCurrentWorkspace: boolean }> };

export type FetchSwagResourceCreatorsQueryVariables = Exact<{
  resourceType: Scalars['String']['input'];
}>;


export type FetchSwagResourceCreatorsQuery = { __typename?: 'Query', resourceCreators: Array<{ __typename?: 'User', email: string, name?: string | null, deactivatedInCurrentWorkspace: boolean, id: string }> };

export type GetRewardsUserQueryVariables = Exact<{
  skipDisplayRewardRules: Scalars['Boolean']['input'];
  skipNewlyCompletedQuests: Scalars['Boolean']['input'];
}>;


export type GetRewardsUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, rewardPoints: number, defaultFeedProgramId?: number | null, pendingRewardPoints?: number | null, displayRewardRules?: boolean, newlyCompletedQuests?: Array<{ __typename?: 'QuestTransaction', id: string, message: string, points: number }> | null } };

export type UserAccountStoreQueryVariables = Exact<{
  type: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  accountIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type UserAccountStoreQuery = { __typename?: 'Query', stores?: Array<{ __typename?: 'Store', id: string, storeName?: string | null, sampleProductsImage?: any | null, topBannerImage?: any | null, feUrl: string, storeNumber: string, account?: { __typename?: 'Account', id: string, externalId: string } | null, config: { __typename?: 'StoreConfig', type: string }, storeDetail?: { __typename?: 'StoreDetail', shortDescription?: string | null, longDescription?: string | null } | null }> | null };

export type StadiumLibraryCategoriesQueryVariables = Exact<{
  onlyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  atleastOneLiveStore?: InputMaybe<Scalars['Boolean']['input']>;
  includeRestrictions?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type StadiumLibraryCategoriesQuery = { __typename?: 'Query', marketingCategories: Array<{ __typename?: 'MarketingCategory', id: string, name: string, description: string, slug: string }> };

export type GetUserConfigQueryVariables = Exact<{
  shouldSkipWorkspaceValidation?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUserConfigQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, liveEshopStoreCount?: number | null, archivedCatalogsCount?: number | null, marketingAnnouncementViewed?: boolean | null, automatedCatalogBannerDismissed?: boolean | null, automatedCatalogGuideTourViewed?: boolean | null, automatedCatalogFooterCartGuideTourViewed?: boolean | null, automatedCatalogLogoDragTooltipViewed?: boolean | null, customizerGuideTourCompleted?: boolean | null, isDesigner: boolean } | null };

export type FetchRewardUserQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchRewardUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, rewardPoints: number } };

export type FetchUserBannersQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchUserBannersQuery = { __typename?: 'Query', userBannersList?: Array<{ __typename?: 'DigitalAsset', id: string, url?: any | null }> | null };

export type GetContactFiltersQueryVariables = Exact<{
  sourceType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetContactFiltersQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', contactFilters?: any | null, id: string } };

export type FetchUserLogosListQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchUserLogosListQuery = { __typename?: 'Query', userLogosList?: Array<{ __typename?: 'Logo', extension?: string | null, fileSize?: string | null, filename?: string | null, id: string, type?: string | null, url?: any | null }> | null };

export const BannerDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BannerDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DigitalAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<BannerDetailsFragment, unknown>;
export const BasicCatalogDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicCatalogDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Catalog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"canAddToStore"}},{"kind":"Field","name":{"kind":"Name","value":"statusInformation"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"displayState"}},{"kind":"Field","name":{"kind":"Name","value":"storeId"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"approvalRequired"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedReadyDate"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"externalOrderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"canRestock"}},{"kind":"Field","name":{"kind":"Name","value":"logoEditable"}},{"kind":"Field","name":{"kind":"Name","value":"paid"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"primaryLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryLogos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableProductsCount"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeProducts"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"forCatalogStore"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productsLimit"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeProducts"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variantImages"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"productCatalogSlug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"store"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"cacheKey"}},{"kind":"Field","name":{"kind":"Name","value":"adminsCount"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storeDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pastelUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storeCatalogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"store"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allProductsAdded"}}]}}]}}]} as unknown as DocumentNode<BasicCatalogDetailsFragment, unknown>;
export const DigitalAssetContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DigitalAssetContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DigitalAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentContentType"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentFileSize"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentFileName"}},{"kind":"Field","name":{"kind":"Name","value":"userAuthorized"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedPrintQuality"}}]}}]} as unknown as DocumentNode<DigitalAssetContentFragment, unknown>;
export const LogoDetailFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LogoDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Logo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<LogoDetailFragment, unknown>;
export const UserLogoListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserLogoList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Logo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"approvedByDesigner"}},{"kind":"Field","name":{"kind":"Name","value":"digitalAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimatedPrintQuality"}}]}}]} as unknown as DocumentNode<UserLogoListFragment, unknown>;
export const ProductBasicDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductBasicDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"productCatalogSlug"}},{"kind":"Field","name":{"kind":"Name","value":"customizable"}},{"kind":"Field","name":{"kind":"Name","value":"showDiscardWarning"}},{"kind":"Field","name":{"kind":"Name","value":"isSizeCustomizable"}},{"kind":"Field","name":{"kind":"Name","value":"innerCanvasJsons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mockups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"printAreaCoords"}},{"kind":"Field","name":{"kind":"Name","value":"conflictingPlacements"}},{"kind":"Field","name":{"kind":"Name","value":"bleedingAreaCoords"}}]}},{"kind":"Field","name":{"kind":"Name","value":"themes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"colors"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customizerData"}},{"kind":"Field","name":{"kind":"Name","value":"dpiQualityTiers"}},{"kind":"Field","name":{"kind":"Name","value":"printAreaConfig"}},{"kind":"Field","name":{"kind":"Name","value":"decorationTechnique"}},{"kind":"Field","name":{"kind":"Name","value":"pastelUrl"}},{"kind":"Field","name":{"kind":"Name","value":"storeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowPrintAreaOverlay"}},{"kind":"Field","name":{"kind":"Name","value":"shouldFeGeneratePreview"}},{"kind":"Field","name":{"kind":"Name","value":"showPrintAreaAsMockupPreview"}},{"kind":"Field","name":{"kind":"Name","value":"customizerTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mockupId"}},{"kind":"Field","name":{"kind":"Name","value":"baseImage"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"innerCanvasJsonId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentCatalog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontColors"}},{"kind":"Field","name":{"kind":"Name","value":"variantsIncludingMaster"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Variant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"optionValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductBasicDetailsFragment, unknown>;
export const ProductMappingDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductMappingDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isSizeCustomizable"}},{"kind":"Field","name":{"kind":"Name","value":"addToAutomatedCatalog"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDecorationTechnique"}},{"kind":"Field","name":{"kind":"Name","value":"canvasJsons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"colorHexMapping"}},{"kind":"Field","name":{"kind":"Name","value":"mockups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeDisabledMockups"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"printAreaCoords"}},{"kind":"Field","name":{"kind":"Name","value":"automationPlacementCoords"}},{"kind":"Field","name":{"kind":"Name","value":"conflictingPlacements"}},{"kind":"Field","name":{"kind":"Name","value":"transparentBaseImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"transparentBaseImageColors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mappingToolData"}},{"kind":"Field","name":{"kind":"Name","value":"decorationTechniques"}},{"kind":"Field","name":{"kind":"Name","value":"allowPmtEdit"}}]}}]} as unknown as DocumentNode<ProductMappingDetailsFragment, unknown>;
export const UserLogoStatusFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserLogoStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasUploadedLogos"}}]}}]} as unknown as DocumentNode<UserLogoStatusFragment, unknown>;
export const ManageDraftAutomatedCatalogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ManageDraftAutomatedCatalog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ManageDraftAutomatedCatalogInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manageDraftAutomatedCatalog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"colorGroupIds"}},{"kind":"Field","name":{"kind":"Name","value":"showDraftAutomatedMockupBanner"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientMutationId"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<ManageDraftAutomatedCatalogMutation, ManageDraftAutomatedCatalogMutationVariables>;
export const ToggleArchiveCatalogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"toggleArchiveCatalog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ToggleArchiveCatalogInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productsLimit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeProducts"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toggleArchiveCatalog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"response"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicCatalogDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicCatalogDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Catalog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"canAddToStore"}},{"kind":"Field","name":{"kind":"Name","value":"statusInformation"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"displayState"}},{"kind":"Field","name":{"kind":"Name","value":"storeId"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"approvalRequired"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedReadyDate"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"externalOrderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"canRestock"}},{"kind":"Field","name":{"kind":"Name","value":"logoEditable"}},{"kind":"Field","name":{"kind":"Name","value":"paid"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"primaryLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryLogos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableProductsCount"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeProducts"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"forCatalogStore"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productsLimit"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeProducts"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variantImages"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"productCatalogSlug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"store"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"cacheKey"}},{"kind":"Field","name":{"kind":"Name","value":"adminsCount"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storeDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pastelUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"storeCatalogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"store"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allProductsAdded"}}]}}]}}]} as unknown as DocumentNode<ToggleArchiveCatalogMutation, ToggleArchiveCatalogMutationVariables>;
export const UpdateContactPermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateContactPermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetWorkspaceUserPermissionsInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"api"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"users","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setWorkspaceUserPermissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workspaceUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workspacePermissions"}},{"kind":"Field","name":{"kind":"Name","value":"customPermissions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateContactPermissionsMutation, UpdateContactPermissionsMutationVariables>;
export const ResetContactPermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"resetContactPermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResetToDefaultInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"api"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"users","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetWorkspaceUserToDefault"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workspaceUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workspacePermissions"}},{"kind":"Field","name":{"kind":"Name","value":"customPermissions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<ResetContactPermissionsMutation, ResetContactPermissionsMutationVariables>;
export const CreatePostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePostInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allComments"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"api"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"rewards","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"post"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"commentsAmount"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mentions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recognitionPointsReceived"}},{"kind":"Field","name":{"kind":"Name","value":"tagged"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stickers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<CreatePostMutation, CreatePostMutationVariables>;
export const CustomizeProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"customizeProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomizeProductInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customizeProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"response"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductBasicDetails"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserLogoStatus"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductBasicDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"productCatalogSlug"}},{"kind":"Field","name":{"kind":"Name","value":"customizable"}},{"kind":"Field","name":{"kind":"Name","value":"showDiscardWarning"}},{"kind":"Field","name":{"kind":"Name","value":"isSizeCustomizable"}},{"kind":"Field","name":{"kind":"Name","value":"innerCanvasJsons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mockups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"printAreaCoords"}},{"kind":"Field","name":{"kind":"Name","value":"conflictingPlacements"}},{"kind":"Field","name":{"kind":"Name","value":"bleedingAreaCoords"}}]}},{"kind":"Field","name":{"kind":"Name","value":"themes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"colors"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customizerData"}},{"kind":"Field","name":{"kind":"Name","value":"dpiQualityTiers"}},{"kind":"Field","name":{"kind":"Name","value":"printAreaConfig"}},{"kind":"Field","name":{"kind":"Name","value":"decorationTechnique"}},{"kind":"Field","name":{"kind":"Name","value":"pastelUrl"}},{"kind":"Field","name":{"kind":"Name","value":"storeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowPrintAreaOverlay"}},{"kind":"Field","name":{"kind":"Name","value":"shouldFeGeneratePreview"}},{"kind":"Field","name":{"kind":"Name","value":"showPrintAreaAsMockupPreview"}},{"kind":"Field","name":{"kind":"Name","value":"customizerTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mockupId"}},{"kind":"Field","name":{"kind":"Name","value":"baseImage"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"innerCanvasJsonId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentCatalog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontColors"}},{"kind":"Field","name":{"kind":"Name","value":"variantsIncludingMaster"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Variant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"optionValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserLogoStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasUploadedLogos"}}]}}]} as unknown as DocumentNode<CustomizeProductMutation, CustomizeProductMutationVariables>;
export const GeneratePreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"generatePreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GeneratePreviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generatePreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewRequestNumber"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<GeneratePreviewMutation, GeneratePreviewMutationVariables>;
export const CreateBaseImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createBaseImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBaseImagesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBaseImages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DigitalAssetContent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DigitalAssetContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DigitalAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentContentType"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentFileSize"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentFileName"}},{"kind":"Field","name":{"kind":"Name","value":"userAuthorized"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedPrintQuality"}}]}}]} as unknown as DocumentNode<CreateBaseImagesMutation, CreateBaseImagesMutationVariables>;
export const CreateDigitalAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createDigitalAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDigitalAssetInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kind"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDigitalAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DigitalAssetContent"}},{"kind":"Field","name":{"kind":"Name","value":"designGuidelines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DigitalAssetContent"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasDigitalAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"kind"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kind"}}}]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DigitalAssetContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DigitalAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentContentType"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentFileSize"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentFileName"}},{"kind":"Field","name":{"kind":"Name","value":"userAuthorized"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedPrintQuality"}}]}}]} as unknown as DocumentNode<CreateDigitalAssetMutation, CreateDigitalAssetMutationVariables>;
export const DestroyDigitalAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"destroyDigitalAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DestroyDigitalAssetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"destroyDigitalAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"digitalAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"designGuidelines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DestroyDigitalAssetMutation, DestroyDigitalAssetMutationVariables>;
export const UpdateDigitalAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDigitalAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDigitalAssetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDigitalAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"userAuthorized"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateDigitalAssetMutation, UpdateDigitalAssetMutationVariables>;
export const CreateLogoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createLogo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateLogoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLogo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserLogoStatus"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserLogoStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasUploadedLogos"}}]}}]} as unknown as DocumentNode<CreateLogoMutation, CreateLogoMutationVariables>;
export const CreateChildCompanyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createChildCompany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"api"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"users","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createChildCompany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"childCompany"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"packageIntentMappingKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"originalKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownerUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CreateChildCompanyMutation, CreateChildCompanyMutationVariables>;
export const ValidateCompanySubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"validateCompanySubscription"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"api"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"users","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateCompanySubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ValidateCompanySubscriptionMutation, ValidateCompanySubscriptionMutationVariables>;
export const UpdateProductMappingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProductMapping"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProductMappingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProductMapping"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"response"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductMappingDetails"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductMappingDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isSizeCustomizable"}},{"kind":"Field","name":{"kind":"Name","value":"addToAutomatedCatalog"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDecorationTechnique"}},{"kind":"Field","name":{"kind":"Name","value":"canvasJsons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"colorHexMapping"}},{"kind":"Field","name":{"kind":"Name","value":"mockups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeDisabledMockups"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"printAreaCoords"}},{"kind":"Field","name":{"kind":"Name","value":"automationPlacementCoords"}},{"kind":"Field","name":{"kind":"Name","value":"conflictingPlacements"}},{"kind":"Field","name":{"kind":"Name","value":"transparentBaseImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"transparentBaseImageColors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mappingToolData"}},{"kind":"Field","name":{"kind":"Name","value":"decorationTechniques"}},{"kind":"Field","name":{"kind":"Name","value":"allowPmtEdit"}}]}}]} as unknown as DocumentNode<UpdateProductMappingMutation, UpdateProductMappingMutationVariables>;
export const UpdateRlpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRlp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSenderRlpMessageInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"api"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"users","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSenderRlpMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateRlpMutation, UpdateRlpMutationVariables>;
export const UpdateRewardUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRewardUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"api"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"rewards","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayRewardRules"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRewardUserMutation, UpdateRewardUserMutationVariables>;
export const UpdateProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateProfileInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"api"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"users","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"spreeId"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lowFundsNotificationThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"personalWorkspaceNudgeLastDismissedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const LibrayAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"librayAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kinds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addedBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"libraryAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"kinds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kinds"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"addedBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addedBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kinds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"presentation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"approvedByDesigner"}},{"kind":"Field","name":{"kind":"Name","value":"designGuidelines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DigitalAssetContent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extension"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DigitalAssetContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DigitalAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentContentType"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentFileSize"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentFileName"}},{"kind":"Field","name":{"kind":"Name","value":"userAuthorized"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedPrintQuality"}}]}}]} as unknown as DocumentNode<LibrayAssetsQuery, LibrayAssetsQueryVariables>;
export const DummyBannerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dummyBanner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bannerBackground"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bannerBackgroundImageType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logoBackground"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"textColor"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"textBackground"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"removeLogo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"removeBackgroundPattern"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dummyBanner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bannerBackground"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bannerBackground"}}},{"kind":"Argument","name":{"kind":"Name","value":"bannerBackgroundImageType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bannerBackgroundImageType"}}},{"kind":"Argument","name":{"kind":"Name","value":"logo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logo"}}},{"kind":"Argument","name":{"kind":"Name","value":"logoBackground"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logoBackground"}}},{"kind":"Argument","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}},{"kind":"Argument","name":{"kind":"Name","value":"textColor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"textColor"}}},{"kind":"Argument","name":{"kind":"Name","value":"textBackground"},"value":{"kind":"Variable","name":{"kind":"Name","value":"textBackground"}}},{"kind":"Argument","name":{"kind":"Name","value":"removeLogo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"removeLogo"}}},{"kind":"Argument","name":{"kind":"Name","value":"removeBackgroundPattern"},"value":{"kind":"Variable","name":{"kind":"Name","value":"removeBackgroundPattern"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserLogoStatus"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserLogoStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasUploadedLogos"}}]}}]} as unknown as DocumentNode<DummyBannerQuery, DummyBannerQueryVariables>;
export const FetchPreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchPreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"previewRequestNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchPreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"previewRequestNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"previewRequestNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"response"}}]}}]}}]} as unknown as DocumentNode<FetchPreviewQuery, FetchPreviewQueryVariables>;
export const FetchDigitalAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchDigitalAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"20"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kind"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"logo","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"digitalAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"kind"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kind"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DigitalAssetContent"}},{"kind":"Field","name":{"kind":"Name","value":"designGuidelines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DigitalAssetContent"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DigitalAssetContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DigitalAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"folderId"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentContentType"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentFileSize"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentFileName"}},{"kind":"Field","name":{"kind":"Name","value":"userAuthorized"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedPrintQuality"}}]}}]} as unknown as DocumentNode<FetchDigitalAssetsQuery, FetchDigitalAssetsQueryVariables>;
export const FetchLockerConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchLockerConfig"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"api"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"products","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lockerShop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"feUrl"},"name":{"kind":"Name","value":"feUrlWithWorkspaceSlug"}},{"kind":"Field","name":{"kind":"Name","value":"storeDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newRoutesEnabled"}}]}}]}}]}}]} as unknown as DocumentNode<FetchLockerConfigQuery, FetchLockerConfigQueryVariables>;
export const CompanyLogosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"companyLogos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"companyDetail"},"name":{"kind":"Name","value":"fetchCompanyDetail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"domain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domain"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logos"}}]}}]}}]} as unknown as DocumentNode<CompanyLogosQuery, CompanyLogosQueryVariables>;
export const FetchLogosListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchLogosList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginatedUserLogosList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserLogoList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserLogoList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Logo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"approvedByDesigner"}},{"kind":"Field","name":{"kind":"Name","value":"digitalAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimatedPrintQuality"}}]}}]} as unknown as DocumentNode<FetchLogosListQuery, FetchLogosListQueryVariables>;
export const FetchProductBySlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchProductBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductBasicDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductBasicDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"productCatalogSlug"}},{"kind":"Field","name":{"kind":"Name","value":"customizable"}},{"kind":"Field","name":{"kind":"Name","value":"showDiscardWarning"}},{"kind":"Field","name":{"kind":"Name","value":"isSizeCustomizable"}},{"kind":"Field","name":{"kind":"Name","value":"innerCanvasJsons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mockups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"printAreaCoords"}},{"kind":"Field","name":{"kind":"Name","value":"conflictingPlacements"}},{"kind":"Field","name":{"kind":"Name","value":"bleedingAreaCoords"}}]}},{"kind":"Field","name":{"kind":"Name","value":"themes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"colors"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customizerData"}},{"kind":"Field","name":{"kind":"Name","value":"dpiQualityTiers"}},{"kind":"Field","name":{"kind":"Name","value":"printAreaConfig"}},{"kind":"Field","name":{"kind":"Name","value":"decorationTechnique"}},{"kind":"Field","name":{"kind":"Name","value":"pastelUrl"}},{"kind":"Field","name":{"kind":"Name","value":"storeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowPrintAreaOverlay"}},{"kind":"Field","name":{"kind":"Name","value":"shouldFeGeneratePreview"}},{"kind":"Field","name":{"kind":"Name","value":"showPrintAreaAsMockupPreview"}},{"kind":"Field","name":{"kind":"Name","value":"customizerTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mockupId"}},{"kind":"Field","name":{"kind":"Name","value":"baseImage"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"innerCanvasJsonId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentCatalog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fontColors"}},{"kind":"Field","name":{"kind":"Name","value":"variantsIncludingMaster"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Variant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"optionValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchProductBySlugQuery, FetchProductBySlugQueryVariables>;
export const FetchProductMappingDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchProductMappingDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductMappingDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductMappingDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isSizeCustomizable"}},{"kind":"Field","name":{"kind":"Name","value":"addToAutomatedCatalog"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDecorationTechnique"}},{"kind":"Field","name":{"kind":"Name","value":"canvasJsons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"colorHexMapping"}},{"kind":"Field","name":{"kind":"Name","value":"mockups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeDisabledMockups"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"printAreaCoords"}},{"kind":"Field","name":{"kind":"Name","value":"automationPlacementCoords"}},{"kind":"Field","name":{"kind":"Name","value":"conflictingPlacements"}},{"kind":"Field","name":{"kind":"Name","value":"transparentBaseImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"transparentBaseImageColors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mappingToolData"}},{"kind":"Field","name":{"kind":"Name","value":"decorationTechniques"}},{"kind":"Field","name":{"kind":"Name","value":"allowPmtEdit"}}]}}]} as unknown as DocumentNode<FetchProductMappingDetailsQuery, FetchProductMappingDetailsQueryVariables>;
export const FetchRecognitionProgramsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchRecognitionProgramsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Hash"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"api"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"rewards","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalUsers"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"nextCycleStartAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalPointsPurchased"}},{"kind":"Field","name":{"kind":"Name","value":"totalPointsUsed"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"slackIntegrated"}},{"kind":"Field","name":{"kind":"Name","value":"msTeamsIntegrated"}},{"kind":"Field","name":{"kind":"Name","value":"attachMonetaryValue"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"contactsAmount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyName"}},{"kind":"Field","name":{"kind":"Name","value":"allowWithoutPoints"}},{"kind":"Field","name":{"kind":"Name","value":"formState"}},{"kind":"Field","name":{"kind":"Name","value":"creatorId"}},{"kind":"Field","name":{"kind":"Name","value":"creatorEmail"}},{"kind":"Field","name":{"kind":"Name","value":"companyValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyValuesRequired"}},{"kind":"Field","name":{"kind":"Name","value":"userStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availablePoints"}}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]} as unknown as DocumentNode<FetchRecognitionProgramsListQuery, FetchRecognitionProgramsListQueryVariables>;
export const GetFeedContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFeedContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageNo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Hash"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"api"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"rewards","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pageNo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageNo"}}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"excludeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"isDeactivated"}},{"kind":"Field","name":{"kind":"Name","value":"manual"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]} as unknown as DocumentNode<GetFeedContactsQuery, GetFeedContactsQueryVariables>;
export const FetchRecognitionProgramHashtagsSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchRecognitionProgramHashtagsSuggestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"api"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"rewards","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hashtagsSuggestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"programId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programId"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchTerm"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companyValue"}}]}}]}}]} as unknown as DocumentNode<FetchRecognitionProgramHashtagsSuggestionsQuery, FetchRecognitionProgramHashtagsSuggestionsQueryVariables>;
export const FetchResourceCreatorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchResourceCreators"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"api"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"rewards","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resourceCreators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resourceType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedInCurrentWorkspace"}}]}}]}}]} as unknown as DocumentNode<FetchResourceCreatorsQuery, FetchResourceCreatorsQueryVariables>;
export const FetchSwagResourceCreatorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchSwagResourceCreators"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resourceCreators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resourceType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"spreeId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedInCurrentWorkspace"}}]}}]}}]} as unknown as DocumentNode<FetchSwagResourceCreatorsQuery, FetchSwagResourceCreatorsQueryVariables>;
export const GetRewardsUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRewardsUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipDisplayRewardRules"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipNewlyCompletedQuests"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"api"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"rewards","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rewardPoints"}},{"kind":"Field","name":{"kind":"Name","value":"defaultFeedProgramId"}},{"kind":"Field","name":{"kind":"Name","value":"pendingRewardPoints"}},{"kind":"Field","name":{"kind":"Name","value":"displayRewardRules"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipDisplayRewardRules"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"newlyCompletedQuests"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipNewlyCompletedQuests"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"points"}}]}}]}}]}}]} as unknown as DocumentNode<GetRewardsUserQuery, GetRewardsUserQueryVariables>;
export const UserAccountStoreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userAccountStore"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stores"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"accountIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"storeName"},"name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"sampleProductsImage"},"name":{"kind":"Name","value":"productImage"}},{"kind":"Field","alias":{"kind":"Name","value":"topBannerImage"},"name":{"kind":"Name","value":"topBanner"}},{"kind":"Field","alias":{"kind":"Name","value":"feUrl"},"name":{"kind":"Name","value":"feUrlWithWorkspaceSlug"}},{"kind":"Field","alias":{"kind":"Name","value":"storeNumber"},"name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"storeDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"longDescription"}}]}}]}}]}}]} as unknown as DocumentNode<UserAccountStoreQuery, UserAccountStoreQueryVariables>;
export const StadiumLibraryCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"stadiumLibraryCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlyEnabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"atleastOneLiveStore"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeRestrictions"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"onlyEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlyEnabled"}}},{"kind":"Argument","name":{"kind":"Name","value":"atleastOneLiveStore"},"value":{"kind":"Variable","name":{"kind":"Name","value":"atleastOneLiveStore"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeRestrictions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeRestrictions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<StadiumLibraryCategoriesQuery, StadiumLibraryCategoriesQueryVariables>;
export const GetUserConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldSkipWorkspaceValidation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"api"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"products","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"liveEshopStoreCount"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldSkipWorkspaceValidation"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"archivedCatalogsCount"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldSkipWorkspaceValidation"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"marketingAnnouncementViewed"}},{"kind":"Field","name":{"kind":"Name","value":"automatedCatalogBannerDismissed"}},{"kind":"Field","name":{"kind":"Name","value":"automatedCatalogGuideTourViewed"}},{"kind":"Field","name":{"kind":"Name","value":"automatedCatalogFooterCartGuideTourViewed"}},{"kind":"Field","name":{"kind":"Name","value":"automatedCatalogLogoDragTooltipViewed"}},{"kind":"Field","name":{"kind":"Name","value":"customizerGuideTourCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"isDesigner"}}]}}]}}]} as unknown as DocumentNode<GetUserConfigQuery, GetUserConfigQueryVariables>;
export const FetchRewardUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchRewardUser"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"api"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"rewards","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rewardPoints"}}]}}]}}]} as unknown as DocumentNode<FetchRewardUserQuery, FetchRewardUserQueryVariables>;
export const FetchUserBannersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchUserBanners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userBannersList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BannerDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BannerDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DigitalAsset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<FetchUserBannersQuery, FetchUserBannersQueryVariables>;
export const GetContactFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getContactFilters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"api"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"users","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"spreeId"}},{"kind":"Field","name":{"kind":"Name","value":"contactFilters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sourceType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceType"}}}]}]}}]}}]} as unknown as DocumentNode<GetContactFiltersQuery, GetContactFiltersQueryVariables>;
export const FetchUserLogosListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchUserLogosList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userLogosList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LogoDetail"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LogoDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Logo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<FetchUserLogosListQuery, FetchUserLogosListQueryVariables>;